import moment from "moment";

const getUpdatedDateData = (key, custFormat, arr) => {
  const latest_date = moment(arr[arr.length - 1]?.[key], custFormat);
  const diff = moment().diff(latest_date, "days");

  return arr?.map((item) => ({
    ...item,
    [key]: moment(item[key], custFormat).add(diff, "days").format(custFormat),
  }));
};

const getCustomersActivity = (arr) =>
  arr?.map((item, index) => ({
    ...item,
    date_time: moment()
      .subtract(index * 11, "minutes")
      .format("DD MMM, YYYY | hh:mm"),
  }));

const getbirthdayDates = (arr) => {
  const latest_date = moment(arr[0]?.birthday || arr[0]?.anniversary);
  let diff = moment().diff(latest_date, "days") + 1;

  return arr?.map((item) => {
    let diff2 = moment().diff(latest_date, "days");

    return item.birthday
      ? {
          ...item,
          birthday: moment(item.birthday)
            .add(diff + diff2, "days")
            .toISOString(),
        }
      : {
          ...item,
          anniversary: moment(item.anniversary)
            .add(diff + diff2, "days")
            .toISOString(),
        };
  });
};

const commonRewardScoreboard = [
  {
    _id: "633ad102c23d786015b38593",
    redemption_count: 43,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "633ad102c23d786015b38596",
    redemption_count: 33,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "630c5a568e3cf78bb07dcb32",
    redemption_count: 27,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "621cdeddc8facf2e7cb2e7c6",
    redemption_count: 26,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "621cdeddc8facf2e7cb2e7c7",
    redemption_count: 22,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "627e10c5fbece6f0689a5eed",
    redemption_count: 22,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "62566f76119655aaf0e8b83e",
    redemption_count: 21,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "62566f76119655aaf0e8b83f",
    redemption_count: 21,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "632c41c3e2b66ea457dddfd4",
    redemption_count: 19,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "62fdda6d0f81b1fa8db0fcb3",
    redemption_count: 19,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "62a9be51ffacabe892b53101",
    redemption_count: 18,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "630c5a568e3cf78bb07dcb35",
    redemption_count: 17,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "633ad103c23d786015b3859c",
    redemption_count: 16,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "63206ca57e084fc0748e9aaa",
    redemption_count: 16,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "62fdda6e0f81b1fa8db0fcb5",
    redemption_count: 15,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "63526839e8aa6b319b60dcdf",
    redemption_count: 14,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "62a9be50ffacabe892b53100",
    redemption_count: 14,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "627e10c6fbece6f0689a5eee",
    redemption_count: 14,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "62a066da2e0622489d033b0e",
    redemption_count: 13,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "622c4f66b63f6a152558d97f",
    redemption_count: 13,
    name: "Set a no cooking week tradition in your family. Get 15% off on order above Rs1199",
    type: "campaign",
  },
  {
    _id: "63206ca57e084fc0748e9aad",
    redemption_count: 13,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "62a9be51ffacabe892b53102",
    redemption_count: 12,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "62da4600a9a8964ae51ade67",
    redemption_count: 12,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "6305e8b18fe4c44de187e8b8",
    redemption_count: 11,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "62a9be51ffacabe892b53104",
    redemption_count: 11,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "63353dd4062c411c7eb4b440",
    redemption_count: 11,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "62d00ee7e949e8bc775024f1",
    redemption_count: 11,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "62f3b339c552d6753d640b77",
    redemption_count: 11,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "631ae0216d94a038c8bad0de",
    redemption_count: 11,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "631ae0216d94a038c8bad0db",
    redemption_count: 11,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "62da4600a9a8964ae51ade66",
    redemption_count: 11,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "62d00ee7e949e8bc775024f3",
    redemption_count: 11,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "632c41c3e2b66ea457dddfda",
    redemption_count: 10,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "62d00ee7e949e8bc775024f0",
    redemption_count: 10,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "621cdeddc8facf2e7cb2e7c5",
    redemption_count: 9,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "62f3b339c552d6753d640b76",
    redemption_count: 9,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "62e389455701bec30dedf0ef",
    redemption_count: 9,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "62ecc54ad5a2053697587fd4",
    redemption_count: 9,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "62e389455701bec30dedf0ee",
    redemption_count: 8,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "62bd69d42ce762b438786a1e",
    redemption_count: 8,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "6290b8d8043538ae667d856a",
    redemption_count: 8,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "636769513890a899ee6da92c",
    redemption_count: 8,
    name: "Set a no cooking weekend tradition in your family. Get 20% off. ",
    type: "campaign",
  },
  {
    _id: "63216d5b11ff08c3a0ff4ff7",
    redemption_count: 8,
    name: "Order your food & enjoy 15% discount",
    type: "campaign",
  },
  {
    _id: "62fdda6d0f81b1fa8db0fcb1",
    redemption_count: 8,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "63526839e8aa6b319b60dce8",
    redemption_count: 8,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "621cdedec8facf2e7cb2e7c9",
    redemption_count: 7,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "62566f77119655aaf0e8b841",
    redemption_count: 7,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "62a066da2e0622489d033b0f",
    redemption_count: 7,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "6305e8b18fe4c44de187e8bb",
    redemption_count: 7,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "621cdeddc8facf2e7cb2e7c4",
    redemption_count: 7,
    name: "Got a sweet tooth? Get one Chocolate Truffle slice!",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "62da4600a9a8964ae51ade69",
    redemption_count: 7,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "630c5a568e3cf78bb07dcb3f",
    redemption_count: 7,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "62ecc54ad5a2053697587fd3",
    redemption_count: 7,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "620e65513442de7ddf4ae039",
    redemption_count: 7,
    name: "Enjoy a no cooking weekend with Rs.150 off on your order.",
    type: "campaign",
  },
  {
    _id: "62c422605d9e907647cc3ab7",
    redemption_count: 7,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "63144e5089db7bf85b6292bf",
    redemption_count: 7,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "633ad102c23d786015b3858c",
    redemption_count: 7,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "6312ea2f89db7bf85b4d5481",
    redemption_count: 6,
    name: "Tired of same food? Try our all new chinese,continental, tandoori sizzlers and get Rs.200 off . ",
    type: "campaign",
  },
  {
    _id: "627e10c3fbece6f0689a5eec",
    redemption_count: 6,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "6305e8b18fe4c44de187e8c5",
    redemption_count: 6,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "62fdda6d0f81b1fa8db0fcaf",
    redemption_count: 6,
    name: "Get a free choclate truffle slice",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "62f3b339c552d6753d640b79",
    redemption_count: 5,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "631977926d94a038c8a90ea0",
    redemption_count: 5,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "63526839e8aa6b319b60dcd9",
    redemption_count: 5,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "62da4600a9a8964ae51ade65",
    redemption_count: 5,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "63353dd5062c411c7eb4b449",
    redemption_count: 5,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "62dfafd1e4a4098c34cc5f8e",
    redemption_count: 5,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "62c422605d9e907647cc3ab8",
    redemption_count: 5,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "62bd69d42ce762b438786a1f",
    redemption_count: 5,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "62e389455701bec30dedf0f1",
    redemption_count: 5,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "62fdda6d0f81b1fa8db0fcb0",
    redemption_count: 5,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "63353dd4062c411c7eb4b443",
    redemption_count: 5,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "62566f76119655aaf0e8b83d",
    redemption_count: 5,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "63295cb87a20f457a422cb11",
    redemption_count: 5,
    name: "Enjoy the all new dishes at GAUTAMS O DINE and get 20% flat discount",
    type: "campaign",
  },
  {
    _id: "62f8812e17a564a993084681",
    redemption_count: 5,
    name: "Independence Day Offer: 15% Off!",
    type: "campaign",
  },
  {
    _id: "62bd69d42ce762b438786a1d",
    redemption_count: 4,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "62eb68403de8ea2350eb22eb",
    redemption_count: 4,
    name: "Your BFF deserves a treat! Visit us & enjoy FRIENDSHIP DAY, 15% Off with live musical band night.",
    type: "campaign",
  },
  {
    _id: "62e8dd01d4f4990457d2998d",
    redemption_count: 4,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "63526839e8aa6b319b60dcdc",
    redemption_count: 4,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "62cd253a7f893a66f95f074a",
    redemption_count: 4,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "62e389445701bec30dedf0ed",
    redemption_count: 4,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "62751b1cddf0a778ec9e455f",
    redemption_count: 4,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "62d00ee7e949e8bc775024ef",
    redemption_count: 4,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "62dfafd2e4a4098c34cc5f8f",
    redemption_count: 4,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "62c422605d9e907647cc3ab6",
    redemption_count: 4,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "628f7147ab3e9ff4ab8d2bfc",
    redemption_count: 4,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "62a066da2e0622489d033b0d",
    redemption_count: 4,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "630c5a568e3cf78bb07dcb2d",
    redemption_count: 4,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "62b960b2da1c9502f158cfde",
    redemption_count: 4,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "62a9be50ffacabe892b530ff",
    redemption_count: 4,
    name: "Got a sweet tooth? Get one Chocolate Truffle slice!",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "62bd69d52ce762b438786a21",
    redemption_count: 4,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "621b5d81bd5e281e79cf36b4",
    redemption_count: 4,
    name: "Missing the good ol’ days? Let's bond over a Free Starter!",
    type: "auto-campaign",
  },
  {
    _id: "62566f76119655aaf0e8b83c",
    redemption_count: 4,
    name: "Got a sweet tooth? Get one Chocolate Truffle slice!",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "63329d2f61697df41d75366b",
    redemption_count: 4,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "6312e5a889db7bf85b4d3136",
    redemption_count: 4,
    name: "Tired of same food? Try out our new  chinese,continental  and tandoori sizzlers and get Rs.200 off. https://tinyurl.com/yc5mhkp4",
    type: "campaign",
  },
  {
    _id: "62fdda6e0f81b1fa8db0fcb6",
    redemption_count: 4,
    name: "Party time! Get ₹1000 off on entire purchase",
    type: "loyalty",
    points_value: 5000,
  },
  {
    _id: "626f84b55236e00f3398ab40",
    redemption_count: 4,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "6213da4b5b6fc1e0237abab4",
    redemption_count: 4,
    name: "Make your Week exciting with this FREE Pizza!",
    type: "campaign",
  },
  {
    _id: "630c5a568e3cf78bb07dcb45",
    redemption_count: 4,
    name: "Party time! Get ₹1000 off on entire purchase",
    type: "loyalty",
    points_value: 5000,
  },
  {
    _id: "62d90b61df4c36cdbd6cec0c",
    redemption_count: 4,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "632c41c3e2b66ea457dddfce",
    redemption_count: 4,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "63206ca57e084fc0748e9ab9",
    redemption_count: 4,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "631ae0216d94a038c8bad0d8",
    redemption_count: 4,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "62c422615d9e907647cc3aba",
    redemption_count: 4,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "6299f3fdbb79facf38b726d9",
    redemption_count: 3,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "6305e8b18fe4c44de187e8b4",
    redemption_count: 3,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "626f84b65236e00f3398ab42",
    redemption_count: 3,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "63343c15056c48192176a988",
    redemption_count: 3,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "63206ca57e084fc0748e9abf",
    redemption_count: 3,
    name: "Party time! Get ₹1000 off on entire purchase",
    type: "loyalty",
    points_value: 5000,
  },
  {
    _id: "62b6d132b2aa92d43cd97f9c",
    redemption_count: 3,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "6290b8d8043538ae667d856c",
    redemption_count: 3,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "627e10c9fbece6f0689a5ef0",
    redemption_count: 3,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "62fc921a0f81b1fa8db07e10",
    redemption_count: 3,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "6326f627f2d4322580f400cb",
    redemption_count: 3,
    name: "Make your weekend special with this 20% discount",
    type: "campaign",
  },
  {
    _id: "631825856d94a038c895b458",
    redemption_count: 3,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "632961767a20f457a4232031",
    redemption_count: 3,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "62e8dd01d4f4990457d2998c",
    redemption_count: 3,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "629da145f2a7ed168e194dde",
    redemption_count: 3,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "62f3b339c552d6753d640b75",
    redemption_count: 3,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "6331e08961697df41d713aa3",
    redemption_count: 3,
    name: "Celebrate Navratri ka tyohaar with 15% off",
    type: "campaign",
  },
  {
    _id: "62ce9757e949e8bc774f9974",
    redemption_count: 3,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "62ecc54ad5a2053697587fd6",
    redemption_count: 3,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "62c94c3a6b919560bab6b178",
    redemption_count: 3,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "626f84b55236e00f3398ab3f",
    redemption_count: 3,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "633ad103c23d786015b3859f",
    redemption_count: 3,
    name: "Party time! Get ₹1000 off on entire purchase",
    type: "loyalty",
    points_value: 5000,
  },
  {
    _id: "6290b8d8043538ae667d8569",
    redemption_count: 3,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "631ae0226d94a038c8bad0ee",
    redemption_count: 3,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "631977926d94a038c8a90ea3",
    redemption_count: 3,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "631ae0206d94a038c8bad0d5",
    redemption_count: 3,
    name: "Get a free Dessert Truffle slice",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "62e389445701bec30dedf0ec",
    redemption_count: 3,
    name: "Got a sweet tooth? Get one Chocolate Truffle slice!",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "621cdedec8facf2e7cb2e7ca",
    redemption_count: 3,
    name: "Party time! Get ₹1000 off on entire purchase",
    type: "loyalty",
    points_value: 5000,
  },
  {
    _id: "63144e5089db7bf85b6292c6",
    redemption_count: 3,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "6328403af2d43225800b4130",
    redemption_count: 3,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "62cd253b7f893a66f95f074b",
    redemption_count: 3,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "631ae0226d94a038c8bad0f1",
    redemption_count: 3,
    name: "Party time! Get ₹1000 off on entire purchase",
    type: "loyalty",
    points_value: 5000,
  },
  {
    _id: "631825856d94a038c895b453",
    redemption_count: 3,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "621b5b10bd5e281e79cf35df",
    redemption_count: 3,
    name: "Birthday special: 25% Off from GAUTAMS O DINE !",
    type: "auto-campaign",
  },
  {
    _id: "632aae43ff4718744696045f",
    redemption_count: 3,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "62c2d62e5d9e907647cbcbda",
    redemption_count: 3,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "629757058bbb51e2233a19ad",
    redemption_count: 3,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "62cc16417f893a66f95eb81c",
    redemption_count: 3,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "62751b1cddf0a778ec9e455c",
    redemption_count: 3,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "6352683ae8aa6b319b60dced",
    redemption_count: 3,
    name: "Party time! Get ₹1000 off on entire purchase",
    type: "loyalty",
    points_value: 5000,
  },
  {
    _id: "62e8dd01d4f4990457d2998f",
    redemption_count: 3,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "621a4c6abd5e281e79cf0e0b",
    redemption_count: 3,
    name: "Enjoy FREE Dessert From GAUTAMS O DINE ",
    type: "auto-campaign",
  },
  {
    _id: "62a066da2e0622489d033b11",
    redemption_count: 3,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "62ce9757e949e8bc774f9978",
    redemption_count: 3,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "6220893eb7dd71409d48cd6a",
    redemption_count: 3,
    name: "Live music and 10% off at GAUTAMS O DINE on order above Rs999 ",
    type: "campaign",
  },
  {
    _id: "63206ca57e084fc0748e9aa7",
    redemption_count: 3,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "62b960b3da1c9502f158cfe1",
    redemption_count: 3,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "62cd253b7f893a66f95f074d",
    redemption_count: 2,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "6305e8b18fe4c44de187e8c9",
    redemption_count: 2,
    name: "Party time! Get ₹1000 off on entire purchase",
    type: "loyalty",
    points_value: 5000,
  },
  {
    _id: "633aa02ec23d786015af1d81",
    redemption_count: 2,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "62c422605d9e907647cc3ab5",
    redemption_count: 2,
    name: "Got a sweet tooth? Get one Chocolate Truffle slice!",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "627bc32cf43aa7f7d38a0e02",
    redemption_count: 2,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "629da145f2a7ed168e194ddf",
    redemption_count: 2,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "62e8dd00d4f4990457d2998a",
    redemption_count: 2,
    name: "Get a free choclate truffle slice",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "631d65ecb0fb47762cb98d23",
    redemption_count: 2,
    name: "Set a no cooking weekend tradition in your family. Get 15% off. ",
    type: "campaign",
  },
  {
    _id: "629da145f2a7ed168e194de0",
    redemption_count: 2,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "62f3b33ac552d6753d640b7a",
    redemption_count: 2,
    name: "Party time! Get ₹1000 off on entire purchase",
    type: "loyalty",
    points_value: 5000,
  },
  {
    _id: "632c41c3e2b66ea457dddfe9",
    redemption_count: 2,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "626f864c5236e00f3398aba3",
    redemption_count: 2,
    name: "Make Mother's Day sweet with our FREE Cake(min order 999) & Live Band Performance!",
    type: "campaign",
  },
  {
    _id: "62ce9757e949e8bc774f9975",
    redemption_count: 2,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "6290b8d8043538ae667d8568",
    redemption_count: 2,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "63353dd4062c411c7eb4b43d",
    redemption_count: 2,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "62b960b2da1c9502f158cfdf",
    redemption_count: 2,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "63206ca47e084fc0748e9aa4",
    redemption_count: 2,
    name: "Get a free Dessert Truffle slice",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "62a066da2e0622489d033b0c",
    redemption_count: 2,
    name: "Got a sweet tooth? Get one Chocolate Truffle slice!",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "62cd253a7f893a66f95f0748",
    redemption_count: 2,
    name: "Got a sweet tooth? Get one Chocolate Truffle slice!",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "62751b1bddf0a778ec9e455b",
    redemption_count: 2,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "62566f76119655aaf0e8b840",
    redemption_count: 2,
    name: "Get a free RED VELVET CAKE. CELEBRATIONS TIME ",
    type: "loyalty",
    points_value: 2500,
  },
  {
    _id: "630c5a558e3cf78bb07dcb25",
    redemption_count: 2,
    name: "Get a free ",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "62d00ee7e949e8bc775024ee",
    redemption_count: 2,
    name: "Got a sweet tooth? Get one Chocolate Truffle slice!",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "62fb837317a564a99309da87",
    redemption_count: 2,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "6220850db7dd71409d48cc5d",
    redemption_count: 2,
    name: "Free DESSERT Alert this Women’s Day on min order Rs799",
    type: "campaign",
  },
  {
    _id: "63353dd5062c411c7eb4b44c",
    redemption_count: 2,
    name: "Party time! Get ₹1000 off on entire purchase",
    type: "loyalty",
    points_value: 5000,
  },
  {
    _id: "62c94c3a6b919560bab6b17b",
    redemption_count: 2,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "62751b1cddf0a778ec9e455e",
    redemption_count: 2,
    name: "Get a free RED VELVET CAKE. CELEBRATIONS TIME ",
    type: "loyalty",
    points_value: 2500,
  },
  {
    _id: "62751b1bddf0a778ec9e455a",
    redemption_count: 2,
    name: "Got a sweet tooth? Get one Chocolate Truffle slice!",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "62f4a3d1c552d6753d646175",
    redemption_count: 2,
    name: "Food Festival like never before from 11-15 Aug!",
    type: "campaign",
  },
  {
    _id: "627e10cbfbece6f0689a5ef1",
    redemption_count: 2,
    name: "Party time! Get ₹1000 off on entire purchase",
    type: "loyalty",
    points_value: 5000,
  },
  {
    _id: "62fc92190f81b1fa8db07e0f",
    redemption_count: 2,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "62c2d62e5d9e907647cbcbdc",
    redemption_count: 2,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "63329d2f61697df41d753679",
    redemption_count: 2,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "62b960b3da1c9502f158cfe2",
    redemption_count: 2,
    name: "Party time! Get ₹1000 off on entire purchase",
    type: "loyalty",
    points_value: 5000,
  },
  {
    _id: "62e21ba8db2250adbfa5a197",
    redemption_count: 2,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "63329d2e61697df41d753664",
    redemption_count: 2,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "6246894fea5e5b2d5f4433b1",
    redemption_count: 2,
    name: "We have good wishes & 15% Off on this Chaitra Navratri on min order 1499",
    type: "campaign",
  },
  {
    _id: "6346a28ee44f06501f0659aa",
    redemption_count: 2,
    name: "Karwa Chauth Special - 15% Off with amazing gift hampers to amazing women.",
    type: "campaign",
  },
  {
    _id: "62cff2aae949e8bc77501618",
    redemption_count: 2,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "62bd69d52ce762b438786a22",
    redemption_count: 2,
    name: "Party time! Get ₹1000 off on entire purchase",
    type: "loyalty",
    points_value: 5000,
  },
  {
    _id: "62dfafd1e4a4098c34cc5f8d",
    redemption_count: 2,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "62d00ee8e949e8bc775024f4",
    redemption_count: 2,
    name: "Party time! Get ₹1000 off on entire purchase",
    type: "loyalty",
    points_value: 5000,
  },
  {
    _id: "6334110eab7ac5151eb6d10d",
    redemption_count: 2,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "62e21ba8db2250adbfa5a195",
    redemption_count: 2,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "627e10c2fbece6f0689a5ee9",
    redemption_count: 2,
    name: "Got a sweet tooth? Get one Chocolate Truffle slice!",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "62da45ffa9a8964ae51ade64",
    redemption_count: 2,
    name: "Got a sweet tooth? Get one Chocolate Truffle slice!",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "62fdda6d0f81b1fa8db0fcb4",
    redemption_count: 2,
    name: "Get a free RED VELVET CAKE. CELEBRATIONS TIME ",
    type: "loyalty",
    points_value: 2500,
  },
  {
    _id: "632c41c4e2b66ea457dddff0",
    redemption_count: 2,
    name: "Party time! Get ₹1000 off on entire purchase",
    type: "loyalty",
    points_value: 5000,
  },
  {
    _id: "62ecc54bd5a2053697587fd7",
    redemption_count: 2,
    name: "Party time! Get ₹1000 off on entire purchase",
    type: "loyalty",
    points_value: 5000,
  },
  {
    _id: "62a066da2e0622489d033b12",
    redemption_count: 2,
    name: "Party time! Get ₹1000 off on entire purchase",
    type: "loyalty",
    points_value: 5000,
  },
  {
    _id: "62566f77119655aaf0e8b842",
    redemption_count: 2,
    name: "Party time! Get ₹1000 off on entire purchase",
    type: "loyalty",
    points_value: 5000,
  },
  {
    _id: "63281640f2d432258007d614",
    redemption_count: 2,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "6334110eab7ac5151eb6d10a",
    redemption_count: 2,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "62cd253a7f893a66f95f0749",
    redemption_count: 2,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "62ecc54ad5a2053697587fd2",
    redemption_count: 2,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "62fc921a0f81b1fa8db07e11",
    redemption_count: 2,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "6290b8d8043538ae667d8567",
    redemption_count: 1,
    name: "Got a sweet tooth? Get one Chocolate Truffle slice!",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "621b544fbd5e281e79cf32b3",
    redemption_count: 1,
    name: "And the winner is you! Save Rs.299 on your bill",
    type: "auto-campaign",
  },
  {
    _id: "629757058bbb51e2233a19ae",
    redemption_count: 1,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "63343c15056c48192176a98d",
    redemption_count: 1,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "63144e5189db7bf85b6292d2",
    redemption_count: 1,
    name: "Party time! Get ₹1000 off on entire purchase",
    type: "loyalty",
    points_value: 5000,
  },
  {
    _id: "63144e5089db7bf85b6292ae",
    redemption_count: 1,
    name: "Get a free Dessert",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "630754b64b558a70dc3cc6cb",
    redemption_count: 1,
    name: "Enjoy the all new dishes at GAUTAMS O DINE ",
    type: "campaign",
  },
  {
    _id: "62fb6b6f17a564a99309cfa4",
    redemption_count: 1,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "62751b1cddf0a778ec9e455d",
    redemption_count: 1,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "631977926d94a038c8a90e9b",
    redemption_count: 1,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "62d90b61df4c36cdbd6cec0d",
    redemption_count: 1,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "62c2d62f5d9e907647cbcbdd",
    redemption_count: 1,
    name: "Party time! Get ₹1000 off on entire purchase",
    type: "loyalty",
    points_value: 5000,
  },
  {
    _id: "62cc16417f893a66f95eb81a",
    redemption_count: 1,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "62c40e265d9e907647cc300b",
    redemption_count: 1,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "6299f3fdbb79facf38b726da",
    redemption_count: 1,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "62cc16407f893a66f95eb819",
    redemption_count: 1,
    name: "Got a sweet tooth? Get one Chocolate Truffle slice!",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "627a0378ddf0a778ec9fe781",
    redemption_count: 1,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "62e21ba8db2250adbfa5a196",
    redemption_count: 1,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "62362e4906cd93722756b6b0",
    redemption_count: 1,
    name: "Celebrate your big day at GAUTAMS O DINE  and get 20% Off on order above Rs1999",
    type: "campaign",
  },
  {
    _id: "632aae43ff4718744696045b",
    redemption_count: 1,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "6299beac8bbb51e2233accd0",
    redemption_count: 1,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "62ecc54ad5a2053697587fd1",
    redemption_count: 1,
    name: "Get a free choclate truffle slice",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "62e21ba8db2250adbfa5a194",
    redemption_count: 1,
    name: "Got a sweet tooth? Get one Chocolate Truffle slice!",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "627bc32df43aa7f7d38a0e04",
    redemption_count: 1,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "62d90b62df4c36cdbd6cec0f",
    redemption_count: 1,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "62a9be51ffacabe892b53105",
    redemption_count: 1,
    name: "Party time! Get ₹1000 off on entire purchase",
    type: "loyalty",
    points_value: 5000,
  },
  {
    _id: "6334110eab7ac5151eb6d110",
    redemption_count: 1,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "628f7147ab3e9ff4ab8d2bfa",
    redemption_count: 1,
    name: "Got a sweet tooth? Get one Chocolate Truffle slice!",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "621cdeddc8facf2e7cb2e7c8",
    redemption_count: 1,
    name: "Get a free RED VELVET CAKE. CELEBRATIONS TIME ",
    type: "loyalty",
    points_value: 2500,
  },
  {
    _id: "62d90b61df4c36cdbd6cec0b",
    redemption_count: 1,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "62e21ba8db2250adbfa5a199",
    redemption_count: 1,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "623a258989c238a6fb719fb1",
    redemption_count: 1,
    name: "Missing the good ol’ days? Let's bond over a Free Starter!",
    type: "auto-campaign",
  },
  {
    _id: "62cc16417f893a66f95eb81b",
    redemption_count: 1,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "62e3e6825701bec30dee35ae",
    redemption_count: 1,
    name: "Get a Free Dessert with your meal with 10% discount.",
    type: "campaign",
  },
  {
    _id: "62fb6b6f17a564a99309cfa3",
    redemption_count: 1,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "62c2d62e5d9e907647cbcbd8",
    redemption_count: 1,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "633ad102c23d786015b38587",
    redemption_count: 1,
    name: "Get a free Dessert Truffle slice",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "632c483ae2b66ea457de6b69",
    redemption_count: 1,
    name: "Take a midweek break. Get Rs.200 off",
    type: "campaign",
  },
  {
    _id: "6305e8b08fe4c44de187e8ad",
    redemption_count: 1,
    name: "Get a free choclate truffle slice",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "63144e5089db7bf85b6292cf",
    redemption_count: 1,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "620b5e7986adaf1359e37eba",
    redemption_count: 1,
    name: "Got a sweet tooth? Get one Chocolate Truffle slice!",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "629da144f2a7ed168e194ddd",
    redemption_count: 1,
    name: "Got a sweet tooth? Get one Chocolate Truffle slice!",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "632961767a20f457a423202a",
    redemption_count: 1,
    name: "Hurrayyy!100₹ off on entire purchase",
    type: "loyalty",
    points_value: 1000,
  },
  {
    _id: "63144e5089db7bf85b6292b5",
    redemption_count: 1,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "629757058bbb51e2233a19ac",
    redemption_count: 1,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "626f84b55236e00f3398ab3e",
    redemption_count: 1,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "6328403af2d43225800b4137",
    redemption_count: 1,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "62171bc65b6fc1e0237b0d7e",
    redemption_count: 1,
    name: "Party time! Get ₹1000 off on entire purchase",
    type: "loyalty",
    points_value: 5000,
  },
  {
    _id: "62c94c3a6b919560bab6b177",
    redemption_count: 1,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "633ad102c23d786015b38599",
    redemption_count: 1,
    name: "Get a free RED VELVET CAKE. CELEBRATIONS TIME ",
    type: "loyalty",
    points_value: 2500,
  },
  {
    _id: "62fcb9350f81b1fa8db09667",
    redemption_count: 1,
    name: "This Janmashtami, enjoy a FREE Dessert from us",
    type: "campaign",
  },
  {
    _id: "62751b1cddf0a778ec9e4560",
    redemption_count: 1,
    name: "Party time! Get ₹1000 off on entire purchase",
    type: "loyalty",
    points_value: 5000,
  },
  {
    _id: "62fc921a0f81b1fa8db07e13",
    redemption_count: 1,
    name: "You deserve it! Get ₹500 off on entire purchase",
    type: "loyalty",
    points_value: 3000,
  },
  {
    _id: "62cc16417f893a66f95eb81f",
    redemption_count: 1,
    name: "Party time! Get ₹1000 off on entire purchase",
    type: "loyalty",
    points_value: 5000,
  },
  {
    _id: "63526839e8aa6b319b60dce2",
    redemption_count: 1,
    name: "Get a free RED VELVET CAKE. CELEBRATIONS TIME ",
    type: "loyalty",
    points_value: 2500,
  },
  {
    _id: "63207d0411ff08c3a0f56767",
    redemption_count: 1,
    name: "Order your food & enjoy 15% discount",
    type: "campaign",
  },
  {
    _id: "627a0379ddf0a778ec9fe783",
    redemption_count: 1,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "62ce9756e949e8bc774f9973",
    redemption_count: 1,
    name: "Got a sweet tooth? Get one Chocolate Truffle slice!",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "62fb837217a564a99309da86",
    redemption_count: 1,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "6299f3fdbb79facf38b726d8",
    redemption_count: 1,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "62b6d132b2aa92d43cd97f9d",
    redemption_count: 1,
    name: "Treat yourself with ₹300 off on entire purchase",
    type: "loyalty",
    points_value: 2000,
  },
  {
    _id: "62e8dd01d4f4990457d2998b",
    redemption_count: 1,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "62e389455701bec30dedf0f2",
    redemption_count: 1,
    name: "Party time! Get ₹1000 off on entire purchase",
    type: "loyalty",
    points_value: 5000,
  },
  {
    _id: "63526839e8aa6b319b60dcd6",
    redemption_count: 1,
    name: "Get a free Dessert Truffle slice",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "632c41c2e2b66ea457dddfc8",
    redemption_count: 1,
    name: "Get a free Dessert Truffle slice",
    type: "loyalty",
    points_value: 500,
  },
  {
    _id: "62b960b2da1c9502f158cfdd",
    redemption_count: 1,
    name: 'Get a free 6"pizza , because who does not love pizza .',
    type: "loyalty",
    points_value: 800,
  },
  {
    _id: "62b6d133b2aa92d43cd97fa0",
    redemption_count: 1,
    name: "Party time! Get ₹1000 off on entire purchase",
    type: "loyalty",
    points_value: 5000,
  },
];

export const demoData = {
  dashboard: {
    hlAndFreq: {
      todays_highlight: {
        sales: 6471,
        visits: 9,
        percentage_change: {
          change: "-501.8",
          increase: false,
        },
        new_customers: 5,
        redemptions: 2,
      },
      customer_frequency: [
        {
          frequency_0: 0,
        },
        {
          frequency_1: 6270,
        },
        {
          frequency_2: 1437,
        },
        {
          frequency_3: 610,
        },
        {
          frequency_4: 330,
        },
        {
          frequency_5: 180,
        },
        {
          frequency_6_and_more: 516,
        },
        {
          total_visitors: 9343,
        },
      ],
      top_insights: {
        total_customers: 9404,
        gained_revenue: 839927,
        gained_visits: 1264,
        revenue_distribution: {
          customers: 20,
          revenue: 60,
        },
        average_order_value: "686.6",
        average_items: "3.7",
        average_visits: "0.0",
      },
    },
    sales: getUpdatedDateData("_id", "YYYY-MM-DD", [
      {
        _id: "2022-10-10",
        total: 27447,
        total_blocked: 0,
      },
      {
        _id: "2022-10-11",
        total: 44186,
        total_blocked: 0,
      },
      {
        _id: "2022-10-12",
        total: 37502,
        total_blocked: 0,
      },
      {
        _id: "2022-10-13",
        total: 80983,
        total_blocked: 0,
      },
      {
        _id: "2022-10-14",
        total: 36406,
        total_blocked: 0,
      },
      {
        _id: "2022-10-15",
        total: 30649,
        total_blocked: 0,
      },
      {
        _id: "2022-10-16",
        total: 51555,
        total_blocked: 0,
      },
      {
        _id: "2022-10-17",
        total: 24874,
        total_blocked: 0,
      },
      {
        _id: "2022-10-18",
        total: 37058,
        total_blocked: 0,
      },
      {
        _id: "2022-10-19",
        total: 37223,
        total_blocked: 0,
      },
      {
        _id: "2022-10-20",
        total: 31374,
        total_blocked: 0,
      },
      {
        _id: "2022-10-21",
        total: 99868,
        total_blocked: 0,
      },
      {
        _id: "2022-10-22",
        total: 45722,
        total_blocked: 0,
      },
      {
        _id: "2022-10-23",
        total: 58596,
        total_blocked: 0,
      },
      {
        _id: "2022-10-24",
        total: 14425,
        total_blocked: 0,
      },
      {
        _id: "2022-10-25",
        total: 47235,
        total_blocked: 0,
      },
      {
        _id: "2022-10-26",
        total: 52548,
        total_blocked: 0,
      },
      {
        _id: "2022-10-27",
        total: 43079,
        total_blocked: 0,
      },
      {
        _id: "2022-10-28",
        total: 18147,
        total_blocked: 0,
      },
      {
        _id: "2022-10-29",
        total: 45051,
        total_blocked: 0,
      },
      {
        _id: "2022-10-30",
        total: 24157,
        total_blocked: 0,
      },
      {
        _id: "2022-10-31",
        total: 35738,
        total_blocked: 0,
      },
      {
        _id: "2022-11-01",
        total: 26100,
        total_blocked: 0,
      },
      {
        _id: "2022-11-02",
        total: 25092,
        total_blocked: 0,
      },
      {
        _id: "2022-11-03",
        total: 17926,
        total_blocked: 0,
      },
      {
        _id: "2022-11-04",
        total: 23949,
        total_blocked: 0,
      },
      {
        _id: "2022-11-05",
        total: 30536,
        total_blocked: 0,
      },
      {
        _id: "2022-11-06",
        total: 49210,
        total_blocked: 0,
      },
      {
        _id: "2022-11-07",
        total: 38940,
        total_blocked: 0,
      },
      {
        _id: "2022-11-08",
        total: 6471,
        total_blocked: 0,
      },
    ]),
    orders: getUpdatedDateData("_id", "YYYY-MM-DD", [
      {
        _id: "2022-10-10",
        total: 44,
        total_blocked: 0,
      },
      {
        _id: "2022-10-11",
        total: 58,
        total_blocked: 0,
      },
      {
        _id: "2022-10-12",
        total: 49,
        total_blocked: 0,
      },
      {
        _id: "2022-10-13",
        total: 107,
        total_blocked: 0,
      },
      {
        _id: "2022-10-14",
        total: 48,
        total_blocked: 0,
      },
      {
        _id: "2022-10-15",
        total: 46,
        total_blocked: 0,
      },
      {
        _id: "2022-10-16",
        total: 56,
        total_blocked: 0,
      },
      {
        _id: "2022-10-17",
        total: 38,
        total_blocked: 0,
      },
      {
        _id: "2022-10-18",
        total: 58,
        total_blocked: 0,
      },
      {
        _id: "2022-10-19",
        total: 54,
        total_blocked: 0,
      },
      {
        _id: "2022-10-20",
        total: 45,
        total_blocked: 0,
      },
      {
        _id: "2022-10-21",
        total: 77,
        total_blocked: 0,
      },
      {
        _id: "2022-10-22",
        total: 59,
        total_blocked: 0,
      },
      {
        _id: "2022-10-23",
        total: 85,
        total_blocked: 0,
      },
      {
        _id: "2022-10-24",
        total: 26,
        total_blocked: 0,
      },
      {
        _id: "2022-10-25",
        total: 72,
        total_blocked: 0,
      },
      {
        _id: "2022-10-26",
        total: 72,
        total_blocked: 0,
      },
      {
        _id: "2022-10-27",
        total: 58,
        total_blocked: 0,
      },
      {
        _id: "2022-10-28",
        total: 26,
        total_blocked: 0,
      },
      {
        _id: "2022-10-29",
        total: 66,
        total_blocked: 0,
      },
      {
        _id: "2022-10-30",
        total: 45,
        total_blocked: 0,
      },
      {
        _id: "2022-10-31",
        total: 48,
        total_blocked: 0,
      },
      {
        _id: "2022-11-01",
        total: 35,
        total_blocked: 0,
      },
      {
        _id: "2022-11-02",
        total: 31,
        total_blocked: 0,
      },
      {
        _id: "2022-11-03",
        total: 30,
        total_blocked: 0,
      },
      {
        _id: "2022-11-04",
        total: 39,
        total_blocked: 0,
      },
      {
        _id: "2022-11-05",
        total: 50,
        total_blocked: 0,
      },
      {
        _id: "2022-11-06",
        total: 65,
        total_blocked: 0,
      },
      {
        _id: "2022-11-07",
        total: 55,
        total_blocked: 0,
      },
      {
        _id: "2022-11-08",
        total: 9,
        total_blocked: 0,
      },
    ]),
    time: {
      popular: {
        day: "Thursday",
        time: "Night",
        orders: 103,
        sales: 95204,
      },
      inactive: {
        day: "Monday",
        time: "Mornings",
        orders: 6,
        sales: 2218,
      },
    },
    reportStatus: {
      preferences: {
        reports_frequency: {
          daily: false,
          weekly: true,
        },
      },
      id: "62d80de4e4c2ae0a994f3ddb",
    },
    popularItemsAndCate: {
      categories: [
        {
          times: 10614,
          name: "Main Course",
          customers: 4250,
        },
        {
          times: 9550,
          name: "Bread",
          customers: 3395,
        },
        {
          times: 3810,
          name: "Starters Chinese",
          customers: 2151,
        },
        {
          times: 3096,
          name: "South Indian",
          customers: 1932,
        },
      ],
      items: [
        {
          times: 4429,
          name: "Butter Roti",
          customers: 2169,
        },
        {
          times: 2843,
          name: "Butter Naan",
          customers: 1608,
        },
        {
          times: 2600,
          name: "Masala Dosa",
          customers: 1790,
        },
        {
          times: 2365,
          name: "Double Dairy Dal Makhani",
          customers: 1734,
        },
      ],
    },
    upcomingCelebrations: {
      countOfCustomers: {
        countOfTotalCustomer: 9404,
        countOfProfileCompletedCustomer: 1066,
      },
      thisWeek: getbirthdayDates([
        {
          name: "mr sundr",
          email: "",
          phone: "9XXXXXXXX2",
          gender: "male",
          dayOfMonthB: 9,
          monthB: 11,
          birthday: "2022-11-09T00:00:00.000Z",
          dayofMonth: 9,
          month: 11,
        },
        {
          name: "vikas",
          email: "vxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX0",
          gender: "male",
          dayOfMonthA: 9,
          monthA: 11,
          anniversary: "2002-11-09T00:00:00.000Z",
          dayofMonth: 9,
          month: 11,
        },
        {
          name: "Vijay",
          email: "",
          phone: "9XXXXXXXX5",
          gender: "male",
          dayOfMonthB: 9,
          monthB: 11,
          birthday: "2022-11-09T00:00:00.000Z",
          dayofMonth: 9,
          month: 11,
        },
        {
          name: "mr sandeep",
          email: "",
          phone: "9XXXXXXXX8",
          gender: "male",
          dayOfMonthB: 9,
          monthB: 11,
          birthday: "2022-11-09T00:00:00.000Z",
          dayofMonth: 9,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX7",
          gender: "male",
          dayOfMonthA: 9,
          monthA: 11,
          anniversary: "2022-11-09T00:00:00.000Z",
          dayofMonth: 9,
          month: 11,
        },
        {
          name: "Naman",
          email: "",
          phone: "7XXXXXXXX1",
          gender: "male",
          dayOfMonthB: 10,
          monthB: 11,
          birthday: "2022-11-10T00:00:00.000Z",
          dayofMonth: 10,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX9",
          gender: "male",
          dayOfMonthB: 10,
          monthB: 11,
          birthday: "2022-11-10T00:00:00.000Z",
          dayofMonth: 10,
          month: 11,
        },
        {
          name: "Rishi",
          email: "",
          phone: "7XXXXXXXX2",
          gender: "male",
          dayOfMonthB: 10,
          monthB: 11,
          birthday: "2022-11-10T00:00:00.000Z",
          dayofMonth: 10,
          month: 11,
        },
        {
          name: "Piyush Dawer",
          email: "Pxxxxxxxx@gmail.com",
          phone: "8XXXXXXXX2",
          gender: "male",
          dayOfMonthA: 10,
          monthA: 11,
          anniversary: "2012-11-10T00:00:00.000Z",
          dayofMonth: 10,
          month: 11,
        },
        {
          name: "Aadit",
          email: "",
          phone: "9XXXXXXXX5",
          gender: "male",
          dayOfMonthA: 10,
          monthA: 11,
          anniversary: "2002-11-10T00:00:00.000Z",
          dayofMonth: 10,
          month: 11,
        },
        {
          name: "RAVI CHAUHAN",
          email: "rxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX0",
          gender: "male",
          dayOfMonthA: 10,
          monthA: 11,
          anniversary: "2022-11-10T18:30:00.000Z",
          dayofMonth: 10,
          month: 11,
        },
        {
          name: "Jitender",
          email: "js3xxxxxxxx@gmail.com",
          phone: "9XXXXXXXX8",
          gender: "male",
          dayOfMonthA: 10,
          monthA: 11,
          anniversary: "2022-11-10T00:00:00.000Z",
          dayofMonth: 10,
          month: 11,
        },
        {
          name: "Nayan",
          email: "",
          phone: "9XXXXXXXX0",
          gender: "male",
          dayOfMonthB: 10,
          monthB: 11,
          birthday: "2022-11-10T00:00:00.000Z",
          dayofMonth: 10,
          month: 11,
        },
        {
          name: "mr akash",
          email: "axxxxxxxx@gmail.com",
          phone: "9XXXXXXXX0",
          gender: "male",
          dayOfMonthB: 10,
          monthB: 11,
          birthday: "2022-11-10T00:00:00.000Z",
          dayofMonth: 10,
          month: 11,
        },
        {
          name: "Tanuj Walia",
          email: "txxxxxxxx@gmail.com",
          phone: "9XXXXXXXX9",
          gender: "male",
          dayOfMonthA: 10,
          monthA: 11,
          anniversary: "2012-11-10T00:00:00.000Z",
          dayofMonth: 10,
          month: 11,
        },
        {
          name: "mayank",
          email: "",
          phone: "7XXXXXXXX4",
          gender: "male",
          dayOfMonthA: 11,
          monthA: 11,
          anniversary: "2022-11-11T00:00:00.000Z",
          dayofMonth: 11,
          month: 11,
        },
        {
          name: "nishat",
          email: "",
          phone: "9XXXXXXXX7",
          gender: "male",
          dayOfMonthA: 11,
          monthA: 11,
          anniversary: "2012-11-11T00:00:00.000Z",
          dayofMonth: 11,
          month: 11,
        },
        {
          name: "mr netesh",
          email: "nxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX1",
          gender: "male",
          dayOfMonthA: 11,
          monthA: 11,
          anniversary: "2012-11-11T00:00:00.000Z",
          dayofMonth: 11,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "8XXXXXXXX2",
          gender: "male",
          dayOfMonthB: 11,
          monthB: 11,
          birthday: "2022-11-11T00:00:00.000Z",
          dayofMonth: 11,
          month: 11,
        },
        {
          name: "Pargat singh dhillon",
          email: "pxxxxxxxx@gmail.com",
          phone: "8XXXXXXXX5",
          gender: "male",
          dayOfMonthB: 11,
          monthB: 11,
          birthday: "2022-11-11T00:00:00.000Z",
          dayofMonth: 11,
          month: 11,
        },
        {
          name: "Parveen Kumar",
          email: "dxxxxxxxx@gmail.com",
          phone: "8XXXXXXXX7",
          gender: "male",
          dayOfMonthB: 11,
          monthB: 11,
          birthday: "2022-11-11T00:00:00.000Z",
          dayofMonth: 11,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX8",
          gender: "male",
          dayOfMonthB: 11,
          monthB: 11,
          birthday: "2022-11-11T00:00:00.000Z",
          dayofMonth: 11,
          month: 11,
        },
        {
          name: "Sheetal sharma",
          email: "sxxxxxxxxxx@outlook.com",
          phone: "8XXXXXXXX6",
          gender: "female",
          dayOfMonthA: 11,
          monthA: 11,
          anniversary: "2022-11-11T00:00:00.000Z",
          dayofMonth: 11,
          month: 11,
        },
        {
          name: "Ramesh kumar",
          email: "rsaxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX2",
          gender: "male",
          dayOfMonthA: 11,
          monthA: 11,
          anniversary: "2002-11-11T00:00:00.000Z",
          dayofMonth: 11,
          month: 11,
        },
        {
          name: "Chinej Gupta",
          email: "Cnjxxxxxxxx@gmail.com",
          phone: "8XXXXXXXX1",
          gender: "male",
          dayOfMonthB: 12,
          monthB: 11,
          birthday: "2022-11-12T00:00:00.000Z",
          dayofMonth: 12,
          month: 11,
        },
        {
          name: "AJAY",
          email: "avexxxxxxxx@gmail.com",
          phone: "9XXXXXXXX6",
          gender: "male",
          dayOfMonthA: 12,
          monthA: 11,
          anniversary: "2022-11-12T00:00:00.000Z",
          dayofMonth: 12,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX5",
          gender: "male",
          dayOfMonthB: 12,
          monthB: 11,
          birthday: "2022-11-12T00:00:00.000Z",
          dayofMonth: 12,
          month: 11,
        },
        {
          name: "Vansh",
          email: "",
          phone: "9XXXXXXXX7",
          gender: "male",
          dayOfMonthB: 12,
          monthB: 11,
          birthday: "2022-11-12T00:00:00.000Z",
          dayofMonth: 12,
          month: 11,
        },
        {
          name: "Sandeep",
          email: "saxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX8",
          gender: "male",
          dayOfMonthB: 12,
          monthB: 11,
          birthday: "2022-11-12T00:00:00.000Z",
          dayofMonth: 12,
          month: 11,
        },
        {
          name: "Gourav Chanana",
          email: "advxxxxxxxx@gmail.com",
          phone: "8XXXXXXXX3",
          gender: "male",
          dayOfMonthB: 12,
          monthB: 11,
          birthday: "2022-11-12T00:00:00.000Z",
          dayofMonth: 12,
          month: 11,
        },
        {
          name: "Parveen Ansari",
          email: "paxxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX3",
          gender: "male",
          dayOfMonthA: 12,
          monthA: 11,
          anniversary: "2012-11-12T00:00:00.000Z",
          dayofMonth: 12,
          month: 11,
        },
        {
          name: "HARMANDEEP",
          email: "",
          phone: "8XXXXXXXX8",
          gender: "male",
          dayOfMonthB: 13,
          monthB: 11,
          birthday: "2022-11-13T00:00:00.000Z",
          dayofMonth: 13,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX8",
          gender: "male",
          dayOfMonthB: 13,
          monthB: 11,
          birthday: "2022-11-13T00:00:00.000Z",
          dayofMonth: 13,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX5",
          gender: "male",
          dayOfMonthB: 13,
          monthB: 11,
          birthday: "2022-11-13T00:00:00.000Z",
          dayofMonth: 13,
          month: 11,
        },
        {
          name: "minakshi piplani",
          email: "",
          phone: "7XXXXXXXX5",
          gender: "female",
          dayOfMonthA: 13,
          monthA: 11,
          anniversary: "2012-11-13T00:00:00.000Z",
          dayofMonth: 13,
          month: 11,
        },
        {
          name: "CUSTOMER",
          email: "drpruxxxxxxxx@gmail.com",
          phone: "7XXXXXXXX2",
          gender: "female",
          dayOfMonthA: 13,
          monthA: 11,
          anniversary: "2002-11-13T00:00:00.000Z",
          dayofMonth: 13,
          month: 11,
        },
        {
          name: "mr anil",
          email: "92anxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX1",
          gender: "male",
          dayOfMonthA: 13,
          monthA: 11,
          anniversary: "2012-11-13T00:00:00.000Z",
          dayofMonth: 13,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX3",
          gender: "male",
          dayOfMonthA: 14,
          monthA: 11,
          anniversary: "2022-11-14T00:00:00.000Z",
          dayofMonth: 14,
          month: 11,
        },
        {
          name: "sandhav",
          email: "",
          phone: "8XXXXXXXX1",
          gender: "male",
          dayOfMonthA: 14,
          monthA: 11,
          anniversary: "2012-11-14T00:00:00.000Z",
          dayofMonth: 14,
          month: 11,
        },
        {
          name: "AMAN",
          email: "amxxxxxxx@gmail.com",
          phone: "9XXXXXXXX9",
          gender: "female",
          dayOfMonthA: 14,
          monthA: 11,
          anniversary: "2012-11-14T00:00:00.000Z",
          dayofMonth: 14,
          month: 11,
        },
        {
          name: "Gurjeet singh",
          email: "pringxxxxxxxx@gmail.com",
          phone: "7XXXXXXXX0",
          gender: "male",
          dayOfMonthB: 14,
          monthB: 11,
          birthday: "2022-11-14T00:00:00.000Z",
          dayofMonth: 14,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX4",
          gender: "male",
          dayOfMonthA: 14,
          monthA: 11,
          anniversary: "2012-11-14T00:00:00.000Z",
          dayofMonth: 14,
          month: 11,
        },
      ]),
      nextFourWeek: getbirthdayDates([
        {
          name: "sapna",
          email: "",
          phone: "7XXXXXXXX3",
          gender: "female",
          dayOfMonthB: 16,
          monthB: 11,
          birthday: "2022-11-16T00:00:00.000Z",
          dayofMonth: 16,
          month: 11,
        },
        {
          name: "Sarthak Soni",
          email: "saxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX5",
          gender: "male",
          dayOfMonthB: 16,
          monthB: 11,
          birthday: "2022-11-16T00:00:00.000Z",
          dayofMonth: 16,
          month: 11,
        },
        {
          name: "SANDEEP NAGI",
          email: "naxxxxxxxxx@yahoo.com",
          phone: "9XXXXXXXX0",
          gender: "male",
          dayOfMonthB: 16,
          monthB: 11,
          birthday: "2022-11-16T00:00:00.000Z",
          dayofMonth: 16,
          month: 11,
        },
        {
          name: "mr amit",
          email: "",
          phone: "7XXXXXXXX9",
          gender: "male",
          dayOfMonthB: 16,
          monthB: 11,
          birthday: "2022-11-16T00:00:00.000Z",
          dayofMonth: 16,
          month: 11,
        },
        {
          name: "hamant",
          email: "heimxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX1",
          gender: "male",
          dayOfMonthB: 16,
          monthB: 11,
          birthday: "2022-11-16T00:00:00.000Z",
          dayofMonth: 16,
          month: 11,
        },
        {
          name: "Aasim",
          email: "",
          phone: "7XXXXXXXX4",
          gender: "male",
          dayOfMonthB: 16,
          monthB: 11,
          birthday: "2022-11-16T00:00:00.000Z",
          dayofMonth: 16,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX6",
          gender: "male",
          dayOfMonthB: 16,
          monthB: 11,
          birthday: "2022-11-16T00:00:00.000Z",
          dayofMonth: 16,
          month: 11,
        },
        {
          name: "Nitish Sharma",
          email: "shtisxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX4",
          gender: "male",
          dayOfMonthB: 16,
          monthB: 11,
          birthday: "2022-11-16T00:00:00.000Z",
          dayofMonth: 16,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "8XXXXXXXX9",
          gender: "female",
          dayOfMonthB: 17,
          monthB: 11,
          birthday: "2022-11-17T00:00:00.000Z",
          dayofMonth: 17,
          month: 11,
        },
        {
          name: "meyank",
          email: "mitxxxxxxxx@gmail.com",
          phone: "8XXXXXXXX8",
          gender: "male",
          dayOfMonthB: 17,
          monthB: 11,
          birthday: "2022-11-17T00:00:00.000Z",
          dayofMonth: 17,
          month: 11,
        },
        {
          name: "Vijay Sharma",
          email: "vijxxxxxxxx@gmail.com",
          phone: "6XXXXXXXX4",
          gender: "male",
          dayOfMonthB: 17,
          monthB: 11,
          birthday: "2022-11-17T00:00:00.000Z",
          dayofMonth: 17,
          month: 11,
        },
        {
          name: "mr shubham",
          email: "",
          phone: "7XXXXXXXX0",
          gender: "male",
          dayOfMonthA: 17,
          monthA: 11,
          anniversary: "2022-11-17T00:00:00.000Z",
          dayofMonth: 17,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "7XXXXXXXX8",
          gender: "male",
          dayOfMonthB: 17,
          monthB: 11,
          birthday: "2022-11-17T00:00:00.000Z",
          dayofMonth: 17,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX3",
          gender: "male",
          dayOfMonthA: 17,
          monthA: 11,
          anniversary: "2012-11-17T00:00:00.000Z",
          dayofMonth: 17,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "7XXXXXXXX5",
          gender: "male",
          dayOfMonthA: 17,
          monthA: 11,
          anniversary: "2022-11-17T00:00:00.000Z",
          dayofMonth: 17,
          month: 11,
        },
        {
          name: "shubham sir",
          email: "",
          phone: "9XXXXXXXX5",
          gender: "male",
          dayOfMonthB: 18,
          monthB: 11,
          birthday: "2022-11-18T00:00:00.000Z",
          dayofMonth: 18,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX6",
          gender: "male",
          dayOfMonthB: 18,
          monthB: 11,
          birthday: "2022-11-18T00:00:00.000Z",
          dayofMonth: 18,
          month: 11,
        },
        {
          name: "mr sandeep",
          email: "",
          phone: "9XXXXXXXX6",
          gender: "male",
          dayOfMonthA: 18,
          monthA: 11,
          anniversary: "2012-11-18T00:00:00.000Z",
          dayofMonth: 18,
          month: 11,
        },
        {
          name: "Ramit",
          email: "ramit_gh@hotmail.com",
          phone: "7XXXXXXXX6",
          gender: "male",
          dayOfMonthA: 18,
          monthA: 11,
          anniversary: "2012-11-18T00:00:00.000Z",
          dayofMonth: 18,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX3",
          gender: "male",
          dayOfMonthA: 18,
          monthA: 11,
          anniversary: "2012-11-18T00:00:00.000Z",
          dayofMonth: 18,
          month: 11,
        },
        {
          name: "Amit Pundir",
          email: "thexxxxxxxx@gmail.com",
          phone: "9XXXXXXXX6",
          gender: "male",
          dayOfMonthB: 19,
          monthB: 11,
          birthday: "2022-11-19T00:00:00.000Z",
          dayofMonth: 19,
          month: 11,
        },
        {
          name: "aditya",
          email: "adityaaxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX3",
          gender: "male",
          dayOfMonthB: 19,
          monthB: 11,
          birthday: "2022-11-19T00:00:00.000Z",
          dayofMonth: 19,
          month: 11,
        },
        {
          name: "sachin ji",
          email: "",
          phone: "7XXXXXXXX9",
          gender: "female",
          dayOfMonthA: 19,
          monthA: 11,
          anniversary: "2012-11-19T00:00:00.000Z",
          dayofMonth: 19,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "8XXXXXXXX2",
          gender: "male",
          dayOfMonthA: 19,
          monthA: 11,
          anniversary: "2012-11-19T00:00:00.000Z",
          dayofMonth: 19,
          month: 11,
        },
        {
          name: "Pooja Arya",
          email: "pxxxxxxxx@gmail.com",
          phone: "8XXXXXXXX9",
          gender: "female",
          dayOfMonthB: 19,
          monthB: 11,
          birthday: "2022-11-19T00:00:00.000Z",
          dayofMonth: 19,
          month: 11,
        },
        {
          name: "mr sandeep",
          email: "",
          phone: "9XXXXXXXX8",
          gender: "male",
          dayOfMonthA: 19,
          monthA: 11,
          anniversary: "2012-11-19T00:00:00.000Z",
          dayofMonth: 19,
          month: 11,
        },
        {
          name: "yogesh",
          email: "",
          phone: "8XXXXXXXX9",
          gender: "male",
          dayOfMonthA: 19,
          monthA: 11,
          anniversary: "2012-11-19T00:00:00.000Z",
          dayofMonth: 19,
          month: 11,
        },
        {
          name: "deepak",
          email: "",
          phone: "8XXXXXXXX6",
          gender: "male",
          dayOfMonthA: 19,
          monthA: 11,
          anniversary: "2012-11-19T00:00:00.000Z",
          dayofMonth: 19,
          month: 11,
        },
        {
          name: "Manish Kumar",
          email: "marexxxxxxxx@gmail.com",
          phone: "9XXXXXXXX4",
          gender: "male",
          dayOfMonthB: 19,
          monthB: 11,
          birthday: "2022-11-19T00:00:00.000Z",
          dayofMonth: 19,
          month: 11,
        },
        {
          name: "ajay",
          email: "",
          phone: "7XXXXXXXX3",
          gender: "male",
          dayOfMonthA: 20,
          monthA: 11,
          anniversary: "2022-11-20T00:00:00.000Z",
          dayofMonth: 20,
          month: 11,
        },
        {
          name: "Jeetender Salhotra",
          email: "acmeauto@myself.com",
          phone: "9XXXXXXXX4",
          gender: "male",
          dayOfMonthB: 20,
          monthB: 11,
          birthday: "2022-11-20T00:00:00.000Z",
          dayofMonth: 20,
          month: 11,
        },
        {
          name: "neetu",
          email: "dinxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX8",
          gender: "female",
          dayOfMonthA: 20,
          monthA: 11,
          anniversary: "2002-11-20T00:00:00.000Z",
          dayofMonth: 20,
          month: 11,
        },
        {
          name: "naveen",
          email: "",
          phone: "9XXXXXXXX6",
          gender: "male",
          dayOfMonthA: 20,
          monthA: 11,
          anniversary: "2002-11-20T00:00:00.000Z",
          dayofMonth: 20,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX1",
          gender: "male",
          dayOfMonthA: 20,
          monthA: 11,
          anniversary: "2022-11-20T00:00:00.000Z",
          dayofMonth: 20,
          month: 11,
        },
        {
          name: "Nikhil saini",
          email: "nixxxxxxxx@gmail.com",
          phone: "9XXXXXXXX4",
          gender: "male",
          dayOfMonthA: 20,
          monthA: 11,
          anniversary: "2012-11-20T00:00:00.000Z",
          dayofMonth: 20,
          month: 11,
        },
        {
          name: "deepak",
          email: "dexxxxxxxx@gmail.com",
          phone: "7XXXXXXXX2",
          gender: "male",
          dayOfMonthA: 20,
          monthA: 11,
          anniversary: "2022-11-20T00:00:00.000Z",
          dayofMonth: 20,
          month: 11,
        },
        {
          name: "Sanket sharma",
          email: "sharxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX1",
          gender: "male",
          dayOfMonthB: 20,
          monthB: 11,
          birthday: "2022-11-20T00:00:00.000Z",
          dayofMonth: 20,
          month: 11,
        },
        {
          name: "Rajat",
          email: "rajaxxxxxxxx@gmail.com",
          phone: "7XXXXXXXX6",
          gender: "male",
          dayOfMonthA: 20,
          monthA: 11,
          anniversary: "2022-11-20T00:00:00.000Z",
          dayofMonth: 20,
          month: 11,
        },
        {
          name: "Babita Kumari",
          email: "bxxxxxxxx@gmail.com",
          phone: "7XXXXXXXX5",
          gender: "female",
          dayOfMonthA: 21,
          monthA: 11,
          anniversary: "2012-11-21T00:00:00.000Z",
          dayofMonth: 21,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "6XXXXXXXX0",
          gender: "female",
          dayOfMonthA: 21,
          monthA: 11,
          anniversary: "2022-11-21T00:00:00.000Z",
          dayofMonth: 21,
          month: 11,
        },
        {
          name: "Amit Pundir",
          email: "thexxxxxxxx@gmail.com",
          phone: "9XXXXXXXX6",
          gender: "male",
          dayOfMonthA: 22,
          monthA: 11,
          anniversary: "2002-11-22T00:00:00.000Z",
          dayofMonth: 22,
          month: 11,
        },
        {
          name: "JATIN",
          email: "jatxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX7",
          gender: "male",
          dayOfMonthA: 22,
          monthA: 11,
          anniversary: "2022-11-22T00:00:00.000Z",
          dayofMonth: 22,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "8XXXXXXXX5",
          gender: "male",
          dayOfMonthB: 22,
          monthB: 11,
          birthday: "2022-11-22T00:00:00.000Z",
          dayofMonth: 22,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX9",
          gender: "male",
          dayOfMonthA: 22,
          monthA: 11,
          anniversary: "2012-11-22T00:00:00.000Z",
          dayofMonth: 22,
          month: 11,
        },
        {
          name: "Amit Chawla",
          email: "amixxxxxxxx@gmail.com",
          phone: "8XXXXXXXX8",
          gender: "male",
          dayOfMonthA: 22,
          monthA: 11,
          anniversary: "2022-11-22T00:00:00.000Z",
          dayofMonth: 22,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX3",
          gender: "male",
          dayOfMonthA: 23,
          monthA: 11,
          anniversary: "2012-11-23T00:00:00.000Z",
          dayofMonth: 23,
          month: 11,
        },
        {
          name: "goldy",
          email: "",
          phone: "9XXXXXXXX0",
          gender: "male",
          dayOfMonthA: 23,
          monthA: 11,
          anniversary: "2002-11-23T00:00:00.000Z",
          dayofMonth: 23,
          month: 11,
        },
        {
          name: "ANKUR",
          email: "gmoxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX0",
          gender: "male",
          dayOfMonthA: 23,
          monthA: 11,
          anniversary: "2012-11-23T00:00:00.000Z",
          dayofMonth: 23,
          month: 11,
        },
        {
          name: "Anshika",
          email: "dannxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX3",
          gender: "female",
          dayOfMonthB: 23,
          monthB: 11,
          birthday: "2022-11-23T00:00:00.000Z",
          dayofMonth: 23,
          month: 11,
        },
        {
          name: "SAHIL",
          email: "",
          phone: "9XXXXXXXX3",
          gender: "male",
          dayOfMonthA: 23,
          monthA: 11,
          anniversary: "2012-11-23T00:00:00.000Z",
          dayofMonth: 23,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX2",
          gender: "male",
          dayOfMonthA: 23,
          monthA: 11,
          anniversary: "2002-11-23T00:00:00.000Z",
          dayofMonth: 23,
          month: 11,
        },
        {
          name: "Vikas gupta",
          email: "Kamxxxxxxxxx@rediffmail.com",
          phone: "7XXXXXXXX7",
          gender: "male",
          dayOfMonthA: 23,
          monthA: 11,
          anniversary: "2002-11-23T00:00:00.000Z",
          dayofMonth: 23,
          month: 11,
        },
        {
          name: "Vipin kumar Saini",
          email: "vipxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX1",
          gender: "male",
          dayOfMonthB: 23,
          monthB: 11,
          birthday: "2022-11-23T00:00:00.000Z",
          dayofMonth: 23,
          month: 11,
        },
        {
          name: "Nirmal",
          email: "nirmaxxxxxxxx@gmail.com",
          phone: "8XXXXXXXX5",
          gender: "male",
          dayOfMonthA: 23,
          monthA: 11,
          anniversary: "2012-11-23T00:00:00.000Z",
          dayofMonth: 23,
          month: 11,
        },
        {
          name: "Vivek Mukkar",
          email: "vivekmukxxxxxxxx@gmail.com",
          phone: "7XXXXXXXX6",
          gender: "male",
          dayOfMonthA: 24,
          monthA: 11,
          anniversary: "2012-11-24T00:00:00.000Z",
          dayofMonth: 24,
          month: 11,
        },
        {
          name: "mr manav",
          email: "",
          phone: "9XXXXXXXX8",
          gender: "male",
          dayOfMonthA: 24,
          monthA: 11,
          anniversary: "2002-11-24T00:00:00.000Z",
          dayofMonth: 24,
          month: 11,
        },
        {
          name: "pankaj sharma",
          email: "panxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX2",
          gender: "male",
          dayOfMonthA: 24,
          monthA: 11,
          anniversary: "1992-11-24T00:00:00.000Z",
          dayofMonth: 24,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "7XXXXXXXX1",
          gender: "male",
          dayOfMonthA: 24,
          monthA: 11,
          anniversary: "2002-11-24T00:00:00.000Z",
          dayofMonth: 24,
          month: 11,
        },
        {
          name: "mr rahul",
          email: "kohxxxxxxxx@gmail.com",
          phone: "8XXXXXXXX9",
          gender: "male",
          dayOfMonthB: 24,
          monthB: 11,
          birthday: "2022-11-24T00:00:00.000Z",
          dayofMonth: 24,
          month: 11,
        },
        {
          name: "Fenny",
          email: "",
          phone: "9XXXXXXXX2",
          gender: "male",
          dayOfMonthB: 25,
          monthB: 11,
          birthday: "2022-11-25T00:00:00.000Z",
          dayofMonth: 25,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX0",
          gender: "male",
          dayOfMonthB: 25,
          monthB: 11,
          birthday: "2022-11-25T00:00:00.000Z",
          dayofMonth: 25,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX0",
          gender: "male",
          dayOfMonthA: 25,
          monthA: 11,
          anniversary: "2022-11-25T00:00:00.000Z",
          dayofMonth: 25,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX5",
          gender: "male",
          dayOfMonthA: 25,
          monthA: 11,
          anniversary: "2002-11-25T00:00:00.000Z",
          dayofMonth: 25,
          month: 11,
        },
        {
          name: "bhajan singh",
          email: "",
          phone: "9XXXXXXXX8",
          gender: "male",
          dayOfMonthA: 25,
          monthA: 11,
          anniversary: "2002-11-25T00:00:00.000Z",
          dayofMonth: 25,
          month: 11,
        },
        {
          name: "neeraj",
          email: "",
          phone: "8XXXXXXXX0",
          gender: "male",
          dayOfMonthA: 25,
          monthA: 11,
          anniversary: "2012-11-25T00:00:00.000Z",
          dayofMonth: 25,
          month: 11,
        },
        {
          name: "Anirudh Rana",
          email: "aniraxxxxxxxx@gmail.com",
          phone: "7XXXXXXXX4",
          gender: "male",
          dayOfMonthA: 25,
          monthA: 11,
          anniversary: "2022-11-25T00:00:00.000Z",
          dayofMonth: 25,
          month: 11,
        },
        {
          name: "Ankur Gupta",
          email: "ankuxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX0",
          gender: "male",
          dayOfMonthA: 25,
          monthA: 11,
          anniversary: "2012-11-25T00:00:00.000Z",
          dayofMonth: 25,
          month: 11,
        },
        {
          name: "mr sandeep",
          email: "",
          phone: "7XXXXXXXX7",
          gender: "male",
          dayOfMonthA: 25,
          monthA: 11,
          anniversary: "2022-11-25T00:00:00.000Z",
          dayofMonth: 25,
          month: 11,
        },
        {
          name: "Ankit Taneja",
          email: "tanejaankxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX2",
          gender: "male",
          dayOfMonthA: 25,
          monthA: 11,
          anniversary: "2022-11-25T00:00:00.000Z",
          dayofMonth: 25,
          month: 11,
        },
        {
          name: "Gaurav",
          email: "grvbaxxxxxxxx@gmail.com",
          phone: "7XXXXXXXX2",
          gender: "male",
          dayOfMonthA: 26,
          monthA: 11,
          anniversary: "2012-11-26T00:00:00.000Z",
          dayofMonth: 26,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX4",
          gender: "male",
          dayOfMonthA: 26,
          monthA: 11,
          anniversary: "1992-11-26T00:00:00.000Z",
          dayofMonth: 26,
          month: 11,
        },
        {
          name: "Rajan kumar",
          email: "rajanxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX9",
          gender: "male",
          dayOfMonthA: 26,
          monthA: 11,
          anniversary: "1992-11-26T00:00:00.000Z",
          dayofMonth: 26,
          month: 11,
        },
        {
          name: "mr anil",
          email: "",
          phone: "9XXXXXXXX0",
          gender: "male",
          dayOfMonthB: 27,
          monthB: 11,
          birthday: "2022-11-27T00:00:00.000Z",
          dayofMonth: 27,
          month: 11,
        },
        {
          name: "muskan",
          email: "",
          phone: "8XXXXXXXX2",
          gender: "female",
          dayOfMonthB: 27,
          monthB: 11,
          birthday: "2022-11-27T00:00:00.000Z",
          dayofMonth: 27,
          month: 11,
        },
        {
          name: "dr karam veer",
          email: "",
          phone: "8XXXXXXXX1",
          gender: "male",
          dayOfMonthB: 27,
          monthB: 11,
          birthday: "2022-11-27T00:00:00.000Z",
          dayofMonth: 27,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX5",
          gender: "male",
          dayOfMonthB: 27,
          monthB: 11,
          birthday: "2022-11-27T00:00:00.000Z",
          dayofMonth: 27,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX2",
          gender: "male",
          dayOfMonthA: 28,
          monthA: 11,
          anniversary: "2022-11-28T00:00:00.000Z",
          dayofMonth: 28,
          month: 11,
        },
        {
          name: "Dr Rajat Chauhan",
          email: "chaurxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX8",
          gender: "male",
          dayOfMonthA: 28,
          monthA: 11,
          anniversary: "2022-11-28T00:00:00.000Z",
          dayofMonth: 28,
          month: 11,
        },
        {
          name: "sunny bhatia",
          email: "",
          phone: "9XXXXXXXX9",
          gender: "male",
          dayOfMonthA: 28,
          monthA: 11,
          anniversary: "2012-11-28T00:00:00.000Z",
          dayofMonth: 28,
          month: 11,
        },
        {
          name: "Gurmeet singh",
          email: "gurmxxxxxxxx@gmail.com",
          phone: "8XXXXXXXX5",
          gender: "male",
          dayOfMonthA: 28,
          monthA: 11,
          anniversary: "2012-11-28T00:00:00.000Z",
          dayofMonth: 28,
          month: 11,
        },
        {
          name: "Rajani",
          email: "rs80xxxxxxxx@gmail.com",
          phone: "9XXXXXXXX1",
          gender: "female",
          dayOfMonthA: 28,
          monthA: 11,
          anniversary: "2002-11-28T00:00:00.000Z",
          dayofMonth: 28,
          month: 11,
        },
        {
          name: "customer",
          email: "",
          phone: "8XXXXXXXX8",
          gender: "female",
          dayOfMonthA: 28,
          monthA: 11,
          anniversary: "1992-11-28T00:00:00.000Z",
          dayofMonth: 28,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX4",
          gender: "male",
          dayOfMonthA: 28,
          monthA: 11,
          anniversary: "2002-11-28T00:00:00.000Z",
          dayofMonth: 28,
          month: 11,
        },
        {
          name: "Govind",
          email: "sharnxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX1",
          gender: "male",
          dayOfMonthB: 28,
          monthB: 11,
          birthday: "2022-11-28T00:00:00.000Z",
          dayofMonth: 28,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "7XXXXXXXX6",
          gender: "male",
          dayOfMonthB: 29,
          monthB: 11,
          birthday: "2022-11-29T00:00:00.000Z",
          dayofMonth: 29,
          month: 11,
        },
        {
          name: "vikas",
          email: "",
          phone: "9XXXXXXXX5",
          gender: "male",
          dayOfMonthA: 29,
          monthA: 11,
          anniversary: "2022-11-29T00:00:00.000Z",
          dayofMonth: 29,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX9",
          gender: "female",
          dayOfMonthB: 29,
          monthB: 11,
          birthday: "2022-11-29T00:00:00.000Z",
          dayofMonth: 29,
          month: 11,
        },
        {
          name: "Hari om",
          email: "hom1xxxxxxxx@gmail.com",
          phone: "8XXXXXXXX8",
          gender: "male",
          dayOfMonthB: 29,
          monthB: 11,
          birthday: "2022-11-29T00:00:00.000Z",
          dayofMonth: 29,
          month: 11,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX1",
          gender: "male",
          dayOfMonthA: 30,
          monthA: 11,
          anniversary: "2022-11-30T00:00:00.000Z",
          dayofMonth: 30,
          month: 11,
        },
        {
          name: "satish",
          email: "",
          phone: "8XXXXXXXX5",
          gender: "male",
          dayOfMonthA: 30,
          monthA: 11,
          anniversary: "2002-11-30T18:30:00.000Z",
          dayofMonth: 30,
          month: 11,
        },
        {
          name: "Rishendra Srivastava",
          email: "rishxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX4",
          gender: "male",
          dayOfMonthA: 30,
          monthA: 11,
          anniversary: "2002-11-30T00:00:00.000Z",
          dayofMonth: 30,
          month: 11,
        },
        {
          name: "naveen",
          email: "",
          phone: "9XXXXXXXX6",
          gender: "male",
          dayOfMonthA: 30,
          monthA: 11,
          anniversary: "2022-11-30T00:00:00.000Z",
          dayofMonth: 30,
          month: 11,
        },
        {
          name: "Kamaljot",
          email: "kamalsxxxxxxxx@gmail.com",
          phone: "8XXXXXXXX8",
          gender: "female",
          dayOfMonthB: 1,
          monthB: 12,
          birthday: "2022-12-01T00:00:00.000Z",
          dayofMonth: 1,
          month: 12,
        },
        {
          name: "Rohit",
          email: "",
          phone: "9XXXXXXXX8",
          gender: "male",
          dayOfMonthA: 1,
          monthA: 12,
          anniversary: "2012-12-01T00:00:00.000Z",
          dayofMonth: 1,
          month: 12,
        },
        {
          name: "Hardik",
          email: "hardixxxxxxxx@gmail.com",
          phone: "8XXXXXXXX3",
          gender: "male",
          dayOfMonthB: 1,
          monthB: 12,
          birthday: "2022-12-01T00:00:00.000Z",
          dayofMonth: 1,
          month: 12,
        },
        {
          name: "customer",
          email: "kavlelxxxxxxxx@gmail.com",
          phone: "8XXXXXXXX3",
          gender: "female",
          dayOfMonthB: 1,
          monthB: 12,
          birthday: "2022-12-01T00:00:00.000Z",
          dayofMonth: 1,
          month: 12,
        },
        {
          name: "Irom melody devi",
          email: "meloxxxxxxxx@gmail.com",
          phone: "8XXXXXXXX4",
          gender: "female",
          dayOfMonthB: 1,
          monthB: 12,
          birthday: "2022-12-01T00:00:00.000Z",
          dayofMonth: 1,
          month: 12,
        },
        {
          name: "Kartik Namdev",
          email: "kartikvxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX7",
          gender: "male",
          dayOfMonthB: 1,
          monthB: 12,
          birthday: "2022-12-01T00:00:00.000Z",
          dayofMonth: 1,
          month: 12,
        },
        {
          name: "ISHANT SINGLA",
          email: "",
          phone: "9XXXXXXXX4",
          gender: "male",
          dayOfMonthB: 2,
          monthB: 12,
          birthday: "2022-12-02T00:00:00.000Z",
          dayofMonth: 2,
          month: 12,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX8",
          gender: "male",
          dayOfMonthA: 2,
          monthA: 12,
          anniversary: "2012-12-02T00:00:00.000Z",
          dayofMonth: 2,
          month: 12,
        },
        {
          name: "JITENDAR KUMAR JI",
          email: "jmohxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX6",
          gender: "male",
          dayOfMonthA: 2,
          monthA: 12,
          anniversary: "2012-12-02T00:00:00.000Z",
          dayofMonth: 2,
          month: 12,
        },
        {
          name: "Gurmeet ji",
          email: "",
          phone: "9XXXXXXXX3",
          gender: "male",
          dayOfMonthA: 2,
          monthA: 12,
          anniversary: "2012-12-02T00:00:00.000Z",
          dayofMonth: 2,
          month: 12,
        },
        {
          name: "Harsh",
          email: "harshsainxxxxxxxx@gmail.com",
          phone: "8XXXXXXXX9",
          gender: "male",
          dayOfMonthB: 2,
          monthB: 12,
          birthday: "2022-12-02T00:00:00.000Z",
          dayofMonth: 2,
          month: 12,
        },
        {
          name: "Vipin kumar Saini",
          email: "vipinsaixxxxxxxx@gmail.com",
          phone: "9XXXXXXXX1",
          gender: "male",
          dayOfMonthA: 2,
          monthA: 12,
          anniversary: "2012-12-02T00:00:00.000Z",
          dayofMonth: 2,
          month: 12,
        },
        {
          name: "",
          email: "",
          phone: "7XXXXXXXX4",
          gender: "male",
          dayOfMonthB: 2,
          monthB: 12,
          birthday: "2022-12-02T00:00:00.000Z",
          dayofMonth: 2,
          month: 12,
        },
        {
          name: "",
          email: "",
          phone: "7XXXXXXXX3",
          gender: "female",
          dayOfMonthB: 3,
          monthB: 12,
          birthday: "2022-12-03T00:00:00.000Z",
          dayofMonth: 3,
          month: 12,
        },
        {
          name: "",
          email: "abxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX2",
          gender: "male",
          dayOfMonthA: 3,
          monthA: 12,
          anniversary: "2022-12-03T00:00:00.000Z",
          dayofMonth: 3,
          month: 12,
        },
        {
          name: "Gurpreet Jassal",
          email: "gurpreexxxxxxxx@gmail.com",
          phone: "8XXXXXXXX3",
          gender: "male",
          dayOfMonthB: 3,
          monthB: 12,
          birthday: "2022-12-03T00:00:00.000Z",
          dayofMonth: 3,
          month: 12,
        },
        {
          name: "praveen",
          email: "",
          phone: "8XXXXXXXX1",
          gender: "male",
          dayOfMonthB: 3,
          monthB: 12,
          birthday: "2022-12-03T00:00:00.000Z",
          dayofMonth: 3,
          month: 12,
        },
        {
          name: "praveen",
          email: "",
          phone: "8XXXXXXXX1",
          gender: "male",
          dayOfMonthA: 3,
          monthA: 12,
          anniversary: "2012-12-03T00:00:00.000Z",
          dayofMonth: 3,
          month: 12,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX6",
          gender: "female",
          dayOfMonthB: 3,
          monthB: 12,
          birthday: "2022-12-03T00:00:00.000Z",
          dayofMonth: 3,
          month: 12,
        },
        {
          name: "Vishal",
          email: "isxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX6",
          gender: "male",
          dayOfMonthA: 3,
          monthA: 12,
          anniversary: "2012-12-03T00:00:00.000Z",
          dayofMonth: 3,
          month: 12,
        },
        {
          name: "rizwan",
          email: "riahooxxxxxxxx@gmail.com",
          phone: "7XXXXXXXX3",
          gender: "female",
          dayOfMonthB: 3,
          monthB: 12,
          birthday: "2022-12-03T00:00:00.000Z",
          dayofMonth: 3,
          month: 12,
        },
        {
          name: "harsh",
          email: "hargupxxxxxxxx@gmail.com",
          phone: "8XXXXXXXX4",
          gender: "male",
          dayOfMonthB: 3,
          monthB: 12,
          birthday: "2022-12-03T00:00:00.000Z",
          dayofMonth: 3,
          month: 12,
        },
        {
          name: "Kamaljeet Singh",
          email: "saixxxxxxxx@gmail.com",
          phone: "8XXXXXXXX7",
          gender: "male",
          dayOfMonthA: 3,
          monthA: 12,
          anniversary: "2012-12-03T00:00:00.000Z",
          dayofMonth: 3,
          month: 12,
        },
        {
          name: "ISHANT SINGLA",
          email: "",
          phone: "9XXXXXXXX4",
          gender: "male",
          dayOfMonthA: 4,
          monthA: 12,
          anniversary: "2012-12-04T00:00:00.000Z",
          dayofMonth: 4,
          month: 12,
        },
        {
          name: "ravindar",
          email: "",
          phone: "9XXXXXXXX1",
          gender: "male",
          dayOfMonthA: 4,
          monthA: 12,
          anniversary: "2002-12-04T00:00:00.000Z",
          dayofMonth: 4,
          month: 12,
        },
        {
          name: "Jaswinder Singh",
          email: "sxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX7",
          gender: "male",
          dayOfMonthB: 4,
          monthB: 12,
          birthday: "2022-12-04T00:00:00.000Z",
          dayofMonth: 4,
          month: 12,
        },
        {
          name: "",
          email: "",
          phone: "8XXXXXXXX3",
          gender: "male",
          dayOfMonthA: 4,
          monthA: 12,
          anniversary: "2012-12-04T00:00:00.000Z",
          dayofMonth: 4,
          month: 12,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX9",
          gender: "male",
          dayOfMonthA: 4,
          monthA: 12,
          anniversary: "2012-12-04T00:00:00.000Z",
          dayofMonth: 4,
          month: 12,
        },
        {
          name: "Balwant kumar",
          email: "jnxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX6",
          gender: "female",
          dayOfMonthA: 4,
          monthA: 12,
          anniversary: "2012-12-04T00:00:00.000Z",
          dayofMonth: 4,
          month: 12,
        },
        {
          name: "mr sourab",
          email: "",
          phone: "7XXXXXXXX6",
          gender: "male",
          dayOfMonthB: 4,
          monthB: 12,
          birthday: "2022-12-04T00:00:00.000Z",
          dayofMonth: 4,
          month: 12,
        },
        {
          name: "mr sanjay",
          email: "",
          phone: "9XXXXXXXX4",
          gender: "male",
          dayOfMonthA: 4,
          monthA: 12,
          anniversary: "2002-12-04T18:30:00.000Z",
          dayofMonth: 4,
          month: 12,
        },
        {
          name: "Amrit",
          email: "amritnaxxxxxxxx@gmail.com",
          phone: "8XXXXXXXX2",
          gender: "male",
          dayOfMonthB: 4,
          monthB: 12,
          birthday: "2022-12-04T00:00:00.000Z",
          dayofMonth: 4,
          month: 12,
        },
        {
          name: "Pawan",
          email: "pawaxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX7",
          gender: "male",
          dayOfMonthB: 4,
          monthB: 12,
          birthday: "2022-12-04T00:00:00.000Z",
          dayofMonth: 4,
          month: 12,
        },
        {
          name: "",
          email: "",
          phone: "7XXXXXXXX6",
          gender: "male",
          dayOfMonthB: 5,
          monthB: 12,
          birthday: "2022-12-05T00:00:00.000Z",
          dayofMonth: 5,
          month: 12,
        },
        {
          name: "rajesh",
          email: "",
          phone: "8XXXXXXXX2",
          gender: "male",
          dayOfMonthB: 5,
          monthB: 12,
          birthday: "2022-12-05T00:00:00.000Z",
          dayofMonth: 5,
          month: 12,
        },
        {
          name: "Yogesh",
          email: "sonihxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX1",
          gender: "male",
          dayOfMonthB: 5,
          monthB: 12,
          birthday: "2022-12-05T00:00:00.000Z",
          dayofMonth: 5,
          month: 12,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX3",
          gender: "male",
          dayOfMonthA: 5,
          monthA: 12,
          anniversary: "2002-12-05T00:00:00.000Z",
          dayofMonth: 5,
          month: 12,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX2",
          gender: "male",
          dayOfMonthA: 5,
          monthA: 12,
          anniversary: "2022-12-05T00:00:00.000Z",
          dayofMonth: 5,
          month: 12,
        },
        {
          name: "Dikshant",
          email: "diksharmxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX8",
          gender: "male",
          dayOfMonthB: 5,
          monthB: 12,
          birthday: "2022-12-05T00:00:00.000Z",
          dayofMonth: 5,
          month: 12,
        },
        {
          name: "Anjna Rani",
          email: "anjnaxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX5",
          gender: "female",
          dayOfMonthA: 5,
          monthA: 12,
          anniversary: "2002-12-05T00:00:00.000Z",
          dayofMonth: 5,
          month: 12,
        },
        {
          name: "",
          email: "",
          phone: "7XXXXXXXX9",
          gender: "male",
          dayOfMonthA: 6,
          monthA: 12,
          anniversary: "2022-12-06T00:00:00.000Z",
          dayofMonth: 6,
          month: 12,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX9",
          gender: "male",
          dayOfMonthB: 6,
          monthB: 12,
          birthday: "2022-12-06T00:00:00.000Z",
          dayofMonth: 6,
          month: 12,
        },
        {
          name: "customer",
          email: "vivexxxxxxxx@gmail.com",
          phone: "8XXXXXXXX1",
          gender: "male",
          dayOfMonthB: 6,
          monthB: 12,
          birthday: "2022-12-06T00:00:00.000Z",
          dayofMonth: 6,
          month: 12,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX5",
          gender: "male",
          dayOfMonthA: 7,
          monthA: 12,
          anniversary: "2002-12-07T00:00:00.000Z",
          dayofMonth: 7,
          month: 12,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX0",
          gender: "male",
          dayOfMonthA: 7,
          monthA: 12,
          anniversary: "2012-12-07T18:30:00.000Z",
          dayofMonth: 7,
          month: 12,
        },
        {
          name: "mr anmol",
          email: "",
          phone: "7XXXXXXXX1",
          gender: "male",
          dayOfMonthB: 7,
          monthB: 12,
          birthday: "2022-12-07T00:00:00.000Z",
          dayofMonth: 7,
          month: 12,
        },
        {
          name: "Prajwal",
          email: "prajwaxxxxxxxx@gmail.com",
          phone: "7XXXXXXXX2",
          gender: "male",
          dayOfMonthA: 7,
          monthA: 12,
          anniversary: "2022-12-07T00:00:00.000Z",
          dayofMonth: 7,
          month: 12,
        },
        {
          name: "Rohtash",
          email: "rohtaxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX1",
          gender: "male",
          dayOfMonthB: 7,
          monthB: 12,
          birthday: "2022-12-07T00:00:00.000Z",
          dayofMonth: 7,
          month: 12,
        },
        {
          name: "sarthak",
          email: "sarthaxxxxxxxx@gmail.com",
          phone: "7XXXXXXXX6",
          gender: "male",
          dayOfMonthB: 8,
          monthB: 12,
          birthday: "2022-12-08T00:00:00.000Z",
          dayofMonth: 8,
          month: 12,
        },
        {
          name: "mr pankj",
          email: "",
          phone: "9XXXXXXXX8",
          gender: "male",
          dayOfMonthA: 8,
          monthA: 12,
          anniversary: "2022-12-08T00:00:00.000Z",
          dayofMonth: 8,
          month: 12,
        },
        {
          name: "raghav",
          email: "",
          phone: "9XXXXXXXX3",
          gender: "male",
          dayOfMonthA: 8,
          monthA: 12,
          anniversary: "2002-12-08T00:00:00.000Z",
          dayofMonth: 8,
          month: 12,
        },
        {
          name: "Aman Sharma",
          email: "asxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX6",
          gender: "male",
          dayOfMonthB: 8,
          monthB: 12,
          birthday: "2022-12-08T00:00:00.000Z",
          dayofMonth: 8,
          month: 12,
        },
        {
          name: "mr pankj",
          email: "",
          phone: "9XXXXXXXX5",
          gender: "male",
          dayOfMonthB: 8,
          monthB: 12,
          birthday: "2022-12-08T00:00:00.000Z",
          dayofMonth: 8,
          month: 12,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX1",
          gender: "female",
          dayOfMonthB: 8,
          monthB: 12,
          birthday: "2022-12-08T00:00:00.000Z",
          dayofMonth: 8,
          month: 12,
        },
        {
          name: "",
          email: "",
          phone: "7XXXXXXXX7",
          gender: "male",
          dayOfMonthA: 8,
          monthA: 12,
          anniversary: "2012-12-08T00:00:00.000Z",
          dayofMonth: 8,
          month: 12,
        },
        {
          name: "",
          email: "",
          phone: "8XXXXXXXX0",
          gender: "male",
          dayOfMonthA: 8,
          monthA: 12,
          anniversary: "2012-12-08T00:00:00.000Z",
          dayofMonth: 8,
          month: 12,
        },
        {
          name: "shubham",
          email: "",
          phone: "9XXXXXXXX8",
          gender: "male",
          dayOfMonthB: 8,
          monthB: 12,
          birthday: "2022-12-08T00:00:00.000Z",
          dayofMonth: 8,
          month: 12,
        },
        {
          name: "Sanjiv dhiman",
          email: "sanjxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX6",
          gender: "male",
          dayOfMonthA: 8,
          monthA: 12,
          anniversary: "2002-12-08T00:00:00.000Z",
          dayofMonth: 8,
          month: 12,
        },
        {
          name: "surbhi",
          email: "",
          phone: "8XXXXXXXX1",
          gender: "female",
          dayOfMonthA: 9,
          monthA: 12,
          anniversary: "2022-12-09T00:00:00.000Z",
          dayofMonth: 9,
          month: 12,
        },
        {
          name: "RAJINDER JI",
          email: "gpstxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX3",
          gender: "male",
          dayOfMonthA: 9,
          monthA: 12,
          anniversary: "1992-12-09T00:00:00.000Z",
          dayofMonth: 9,
          month: 12,
        },
        {
          name: "Nazar Singh",
          email: "nazarxxxxxxxx@yahoo.in",
          phone: "9XXXXXXXX0",
          gender: "male",
          dayOfMonthA: 9,
          monthA: 12,
          anniversary: "2012-12-09T00:00:00.000Z",
          dayofMonth: 9,
          month: 12,
        },
        {
          name: "sukhi lail",
          email: "sukhjexxxxxxxx@gmail.com",
          phone: "9XXXXXXXX4",
          gender: "male",
          dayOfMonthA: 9,
          monthA: 12,
          anniversary: "2012-12-09T00:00:00.000Z",
          dayofMonth: 9,
          month: 12,
        },
        {
          name: "Navneet goel",
          email: "sakshaxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX1",
          gender: "male",
          dayOfMonthB: 9,
          monthB: 12,
          birthday: "2022-12-09T00:00:00.000Z",
          dayofMonth: 9,
          month: 12,
        },
        {
          name: "Mokshi",
          email: "mokvxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX3",
          gender: "female",
          dayOfMonthA: 10,
          monthA: 12,
          anniversary: "2012-12-10T00:00:00.000Z",
          dayofMonth: 10,
          month: 12,
        },
        {
          name: "",
          email: "",
          phone: "8XXXXXXXX1",
          gender: "male",
          dayOfMonthA: 10,
          monthA: 12,
          anniversary: "2002-12-10T00:00:00.000Z",
          dayofMonth: 10,
          month: 12,
        },
        {
          name: "Bhavya",
          email: "bhavyxxxxxxxx@gmail.com",
          phone: "8XXXXXXXX7",
          gender: "female",
          dayOfMonthB: 10,
          monthB: 12,
          birthday: "2022-12-10T00:00:00.000Z",
          dayofMonth: 10,
          month: 12,
        },
        {
          name: "navdeep",
          email: "",
          phone: "9XXXXXXXX6",
          gender: "male",
          dayOfMonthA: 10,
          monthA: 12,
          anniversary: "2012-12-10T00:00:00.000Z",
          dayofMonth: 10,
          month: 12,
        },
        {
          name: "Ravinder Kumar",
          email: "Ravxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX5",
          gender: "male",
          dayOfMonthB: 10,
          monthB: 12,
          birthday: "2022-12-10T00:00:00.000Z",
          dayofMonth: 10,
          month: 12,
        },
        {
          name: "naveen",
          email: "navexxxxxxxxx@ymail.com",
          phone: "7XXXXXXXX6",
          gender: "male",
          dayOfMonthB: 10,
          monthB: 12,
          birthday: "2022-12-10T00:00:00.000Z",
          dayofMonth: 10,
          month: 12,
        },
        {
          name: "Manish chanana",
          email: "manisxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX0",
          gender: "male",
          dayOfMonthA: 10,
          monthA: 12,
          anniversary: "2022-12-10T00:00:00.000Z",
          dayofMonth: 10,
          month: 12,
        },
        {
          name: "Sanjeev Kumar",
          email: "sanjeevsxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX4",
          gender: "male",
          dayOfMonthA: 10,
          monthA: 12,
          anniversary: "2002-12-10T00:00:00.000Z",
          dayofMonth: 10,
          month: 12,
        },
        {
          name: "Mukesh Kumar",
          email: "Buntygxxxxxxxx@gmail.com",
          phone: "8XXXXXXXX1",
          gender: "male",
          dayOfMonthB: 10,
          monthB: 12,
          birthday: "2022-12-10T00:00:00.000Z",
          dayofMonth: 10,
          month: 12,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX4",
          gender: "male",
          dayOfMonthB: 10,
          monthB: 12,
          birthday: "2022-12-10T00:00:00.000Z",
          dayofMonth: 10,
          month: 12,
        },
        {
          name: "Nitin Walia",
          email: "waliaxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX0",
          gender: "male",
          dayOfMonthA: 10,
          monthA: 12,
          anniversary: "2022-12-10T00:00:00.000Z",
          dayofMonth: 10,
          month: 12,
        },
        {
          name: "Mukesh",
          email: "mukexxxxxxxx@gmail.com",
          phone: "9XXXXXXXX4",
          gender: "male",
          dayOfMonthA: 10,
          monthA: 12,
          anniversary: "2012-12-10T00:00:00.000Z",
          dayofMonth: 10,
          month: 12,
        },
        {
          name: "VINOD",
          email: "vkumxxxxxxxx@gmail.com",
          phone: "7XXXXXXXX5",
          gender: "male",
          dayOfMonthA: 11,
          monthA: 12,
          anniversary: "2022-12-11T00:00:00.000Z",
          dayofMonth: 11,
          month: 12,
        },
        {
          name: "",
          email: "",
          phone: "8XXXXXXXX9",
          gender: "male",
          dayOfMonthB: 11,
          monthB: 12,
          birthday: "2022-12-11T00:00:00.000Z",
          dayofMonth: 11,
          month: 12,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX2",
          gender: "male",
          dayOfMonthA: 11,
          monthA: 12,
          anniversary: "2022-12-11T00:00:00.000Z",
          dayofMonth: 11,
          month: 12,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX7",
          gender: "male",
          dayOfMonthA: 11,
          monthA: 12,
          anniversary: "2002-12-11T00:00:00.000Z",
          dayofMonth: 11,
          month: 12,
        },
        {
          name: "Sandeep",
          email: "sandxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX8",
          gender: "male",
          dayOfMonthA: 11,
          monthA: 12,
          anniversary: "2012-12-11T00:00:00.000Z",
          dayofMonth: 11,
          month: 12,
        },
        {
          name: "Bir Devender",
          email: "birdxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX7",
          gender: "male",
          dayOfMonthA: 11,
          monthA: 12,
          anniversary: "2002-12-11T00:00:00.000Z",
          dayofMonth: 11,
          month: 12,
        },
        {
          name: "Jagroop Singh",
          email: "jagroogixxxxxxxx@gmail.com",
          phone: "9XXXXXXXX7",
          gender: "male",
          dayOfMonthB: 11,
          monthB: 12,
          birthday: "2022-12-11T00:00:00.000Z",
          dayofMonth: 11,
          month: 12,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX6",
          gender: "female",
          dayOfMonthB: 11,
          monthB: 12,
          birthday: "2022-12-11T00:00:00.000Z",
          dayofMonth: 11,
          month: 12,
        },
        {
          name: "𝒎𝒂𝒏𝒊𝒔𝒉𝒂 𝒔𝒉𝒂𝒓𝒎𝒂",
          email: "sharmaaxxxxxxxx@GMAIL.COM",
          phone: "9XXXXXXXX3",
          gender: "female",
          dayOfMonthA: 11,
          monthA: 12,
          anniversary: "1992-12-11T00:00:00.000Z",
          dayofMonth: 11,
          month: 12,
        },
        {
          name: "Deepak",
          email: "dgoexxxxxxxx@gmail.com",
          phone: "9XXXXXXXX3",
          gender: "male",
          dayOfMonthB: 12,
          monthB: 12,
          birthday: "2022-12-12T00:00:00.000Z",
          dayofMonth: 12,
          month: 12,
        },
        {
          name: "Harsit ji",
          email: "",
          phone: "9XXXXXXXX5",
          gender: "male",
          dayOfMonthA: 12,
          monthA: 12,
          anniversary: "2022-12-12T00:00:00.000Z",
          dayofMonth: 12,
          month: 12,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX1",
          gender: "male",
          dayOfMonthA: 12,
          monthA: 12,
          anniversary: "2012-12-12T00:00:00.000Z",
          dayofMonth: 12,
          month: 12,
        },
        {
          name: "",
          email: "",
          phone: "9XXXXXXXX9",
          gender: "male",
          dayOfMonthA: 12,
          monthA: 12,
          anniversary: "2022-12-12T00:00:00.000Z",
          dayofMonth: 12,
          month: 12,
        },
        {
          name: "mr mohit",
          email: "mohitkuxxxxxxxx@gmail.com",
          phone: "8XXXXXXXX5",
          gender: "male",
          dayOfMonthB: 12,
          monthB: 12,
          birthday: "2022-12-12T00:00:00.000Z",
          dayofMonth: 12,
          month: 12,
        },
        {
          name: "Vikas",
          email: "vikxxxxxxxx@gmail.com",
          phone: "8XXXXXXXX3",
          gender: "male",
          dayOfMonthB: 12,
          monthB: 12,
          birthday: "2022-12-12T00:00:00.000Z",
          dayofMonth: 12,
          month: 12,
        },
        {
          name: "Munish kumar",
          email: "ermunixxxxxxxx@gmail.com",
          phone: "9XXXXXXXX0",
          gender: "male",
          dayOfMonthB: 12,
          monthB: 12,
          birthday: "2022-12-12T00:00:00.000Z",
          dayofMonth: 12,
          month: 12,
        },
        {
          name: "Sandeep",
          email: "skxxxxxxxx@gmail.com",
          phone: "8XXXXXXXX2",
          gender: "male",
          dayOfMonthA: 12,
          monthA: 12,
          anniversary: "2022-12-12T00:00:00.000Z",
          dayofMonth: 12,
          month: 12,
        },
      ]),
      autoCampaigns: null,
    },
    generalStats: {
      activeUsers: 6404,
      inactiveUsers: 2070,
      blockedUsers: 930,
      reward_scoreboard: commonRewardScoreboard,
    },
  },
  campaigns: {
    CampPerformance: {
      campaignRevenue: 21556,
      attributeRevenue: 225898,
      redemptionsCount: 15,
      campaignVisits: 15,
      attributeVisits: 270,
      campaign_count: 14,
      campaignsRedemptions: 0,
      attributeRedemption: 0,
      attributeVisitsStats: getUpdatedDateData("date", "YYYY-MM-DD", [
        {
          date: "2022-10-10",
          sales: 1,
        },
        {
          date: "2022-10-11",
          sales: 3,
        },
        {
          date: "2022-10-12",
          sales: 18,
        },
        {
          date: "2022-10-13",
          sales: 51,
        },
        {
          date: "2022-10-14",
          sales: 5,
        },
        {
          date: "2022-10-15",
          sales: 0,
        },
        {
          date: "2022-10-16",
          sales: 0,
        },
        {
          date: "2022-10-17",
          sales: 0,
        },
        {
          date: "2022-10-18",
          sales: 0,
        },
        {
          date: "2022-10-19",
          sales: 0,
        },
        {
          date: "2022-10-20",
          sales: 2,
        },
        {
          date: "2022-10-21",
          sales: 6,
        },
        {
          date: "2022-10-22",
          sales: 6,
        },
        {
          date: "2022-10-23",
          sales: 3,
        },
        {
          date: "2022-10-24",
          sales: 0,
        },
        {
          date: "2022-10-25",
          sales: 19,
        },
        {
          date: "2022-10-26",
          sales: 22,
        },
        {
          date: "2022-10-27",
          sales: 19,
        },
        {
          date: "2022-10-28",
          sales: 7,
        },
        {
          date: "2022-10-29",
          sales: 17,
        },
        {
          date: "2022-10-30",
          sales: 16,
        },
        {
          date: "2022-10-31",
          sales: 1,
        },
        {
          date: "2022-11-01",
          sales: 5,
        },
        {
          date: "2022-11-02",
          sales: 9,
        },
        {
          date: "2022-11-03",
          sales: 3,
        },
        {
          date: "2022-11-04",
          sales: 2,
        },
        {
          date: "2022-11-05",
          sales: 6,
        },
        {
          date: "2022-11-06",
          sales: 30,
        },
        {
          date: "2022-11-07",
          sales: 18,
        },
        {
          date: "2022-11-08",
          sales: 1,
        },
      ]),
      attributeRevenueStats: getUpdatedDateData("date", "YYYY-MM-DD", [
        {
          date: "2022-10-10",
          sales: 0,
        },
        {
          date: "2022-10-11",
          sales: 0,
        },
        {
          date: "2022-10-12",
          sales: 0,
        },
        {
          date: "2022-10-13",
          sales: 0,
        },
        {
          date: "2022-10-14",
          sales: 0,
        },
        {
          date: "2022-10-15",
          sales: 0,
        },
        {
          date: "2022-10-16",
          sales: 0,
        },
        {
          date: "2022-10-17",
          sales: 0,
        },
        {
          date: "2022-10-18",
          sales: 0,
        },
        {
          date: "2022-10-19",
          sales: 0,
        },
        {
          date: "2022-10-20",
          sales: 0,
        },
        {
          date: "2022-10-21",
          sales: 0,
        },
        {
          date: "2022-10-22",
          sales: 0,
        },
        {
          date: "2022-10-23",
          sales: 0,
        },
        {
          date: "2022-10-24",
          sales: 0,
        },
        {
          date: "2022-10-25",
          sales: 0,
        },
        {
          date: "2022-10-26",
          sales: 0,
        },
        {
          date: "2022-10-27",
          sales: 0,
        },
        {
          date: "2022-10-28",
          sales: 0,
        },
        {
          date: "2022-10-29",
          sales: 0,
        },
        {
          date: "2022-10-30",
          sales: 0,
        },
        {
          date: "2022-10-31",
          sales: 0,
        },
        {
          date: "2022-11-01",
          sales: 0,
        },
        {
          date: "2022-11-02",
          sales: 0,
        },
        {
          date: "2022-11-03",
          sales: 0,
        },
        {
          date: "2022-11-04",
          sales: 0,
        },
        {
          date: "2022-11-05",
          sales: 0,
        },
        {
          date: "2022-11-06",
          sales: 0,
        },
        {
          date: "2022-11-07",
          sales: 0,
        },
        {
          date: "2022-11-08",
          sales: 0,
        },
      ]),
      avg_revenue_redemption: "15059.9",
      campaign_delivered: 22764,
      avg_visit_rate: "1.2",
    },
    CampList: {
      docs: [
        {
          _id: "63676d023890a899ee6e3894",
          whatsapp: {
            details: {
              store_name: "GAUTAMS O DINE ",
              details_0: "Hocus Pocus! You need to focus here because;",
              details_1: "We’ve got delicious &",
              details_2:
                "FREE. Yes, you heard it right! It’s FREE!! Visit us today.",
              details_3: "Don’t miss this! Click here",
              reward_value: "starter",
            },
            short_link: {
              type: "default",
              is_file: false,
              url: "l.reelo.io/Ccvg8",
            },
            content:
              "GAUTAMS O DINE \n\nHocus Pocus! You need to focus here because;\n\nWe’ve got delicious & mouth-watering starter for FREE. Yes, you heard it right! It’s FREE!! Visit us today.\n\nDon’t miss this! Click here",
            media_details: {
              is_enable: true,
              is_custom: false,
              type: "image",
              document:
                "https://reelo-assets.s3.ap-south-1.amazonaws.com/static/campaigns/templates/banners/%23144.jpg",
            },
            call_to_action: {
              is_enable: true,
              buttons: [
                {
                  action: "link",
                  label: "Learn more",
                  value: "l.reelo.io/Ccvg8",
                },
              ],
            },
            fields: [
              "store_name",
              "details_0",
              "details_1",
              "reward_value",
              "details_2",
              "details_3",
            ],
          },
          reward: {
            type: "free_item",
            items: [
              {
                name: "starter",
              },
            ],
            applies_on: "purchase",
          },
          status: "published",
          channels: [
            {
              name: "sms",
              credits: 1,
              status: false,
            },
            {
              credits: 1,
              name: "email",
              status: false,
            },
            {
              credits: 1,
              name: "whatsapp",
              status: true,
            },
          ],
          repeat: null,
          auto_deactivate: false,
          entity_type: "Group",
          entity_id: "6305bf488fe4c44de1858f6c",
          type: "template",
          user_id: "6206410f9be20234ced45c98",
          template_id: "02718",
          created_at: "2022-11-06T08:14:58.504Z",
          updated_at: "2022-11-06T08:18:21.033Z",
          __v: 0,
          email_content: "not-exist-yet",
          email_subject: "Weekends at GAUTAMS O DINE . Free food inside. ",
          subtitle:
            "This weekend binge on free starter at GAUTAMS O DINE  while we Serve you a splendid three-course meal.",
          title: "FREE FREE FREE Starter at GAUTAMS O DINE ",
          contact_number: "9XXXXXXXX4",
          expires_at: "2022-11-11T18:29:59.000Z",
          redemption_per_customer: "single",
          terms:
            "2 offers cannot be clubbed.\n Reward cannot be exchanged for cash.\nMin purchase required Rs1999",
          banner:
            "https://reelo-assets.s3.ap-south-1.amazonaws.com/static/campaigns/templates/banners/%23144.jpg",
          banner_position: {
            scale: 1,
            position_x: 0,
            position_y: 0,
          },
          colors: {
            theme: "#186B76",
            text: "#FFFFFF",
          },
          logo: "https://reelo-uploads-production.s3.ap-south-1.amazonaws.com/uploads/users/6206410f9be20234ced45c98/1663135731206.png",
          audience: {
            type: "all",
            filters: {
              blocked_customers: false,
              exclude_invalid_channels: ["whatsapp"],
              store_ids: ["633af231c23d786015b6e8d7"],
            },
          },
          repeat_ends: null,
          repeat_interval: null,
          schedule_at: "2022-11-06T08:18:16.000Z",
          timezone: "Asia/Kolkata",
          attribute_visits: 5,
          attribute_revenue: 14045,
          delivered: 371,
        },
        {
          _id: "636769513890a899ee6da92c",
          whatsapp: {
            details: {
              store_name: "GAUTAMS O DINE ",
              details_0: "This weekend, bite into the cheesier side of life!",
              details_1:
                "Visit us today & enjoy our cheesylicious delicacies at",
              details_2: "Hurry, the offer is valid till today!",
              details_3: "Don’t miss this! Click here",
              reward_value: 20,
              contact: "9XXXXXXXX1",
            },
            short_link: {
              type: "default",
              is_file: false,
              url: "l.reelo.io/mVW4H",
            },
            content:
              "GAUTAMS O DINE \n\nThis weekend, bite into the cheesier side of life!\n\nVisit us today & enjoy our cheesylicious delicacies at a 20% discount. Hurry, the offer is valid till today!\n\nCall #9050753971\n\nDon’t miss this! Click here",
            media_details: {
              is_enable: true,
              is_custom: false,
              type: "image",
              document:
                "https://reelo-assets.s3.ap-south-1.amazonaws.com/static/campaigns/templates/banners/%2335.jpg",
            },
            call_to_action: {
              is_enable: true,
              buttons: [
                {
                  action: "link",
                  label: "Learn more",
                  value: "l.reelo.io/mVW4H",
                },
              ],
            },
            fields: [
              "store_name",
              "details_0",
              "details_1",
              "reward_value",
              "details_2",
              "contact",
              "details_3",
            ],
          },
          reward: {
            type: "percentage_off",
            discount_off: 20,
            applies_on: "purchase",
          },
          status: "published",
          channels: [
            {
              name: "sms",
              credits: 1,
              status: false,
            },
            {
              credits: 1,
              name: "email",
              status: false,
            },
            {
              credits: 1,
              name: "whatsapp",
              status: true,
            },
          ],
          repeat: null,
          auto_deactivate: false,
          entity_type: "Group",
          entity_id: "6305bf488fe4c44de1858f6c",
          type: "template",
          user_id: "6206410f9be20234ced45c98",
          template_id: "02713",
          created_at: "2022-11-06T07:59:13.474Z",
          updated_at: "2022-11-06T08:12:40.658Z",
          __v: 0,
          email_content:
            "https://reelo-uploads-production.s3.ap-south-1.amazonaws.com/not-exist-yet",
          email_subject: "Step out this weekend!",
          subtitle:
            "Eat out on weekends and get 20% off on your bill. Make your weekends all about food, food, and more food!",
          title:
            "Set a no cooking weekend tradition in your family. Get 20% off. ",
          contact_number: "9XXXXXXXX1",
          expires_at: "2022-11-11T18:29:59.000Z",
          redemption_per_customer: "single",
          terms:
            "2 offers cannot be clubbed.\n Reward cannot be exchanged for cash.\nMin purchase required rs1299",
          banner:
            "https://reelo-assets.s3.ap-south-1.amazonaws.com/static/campaigns/templates/banners/%2335.jpg",
          banner_position: {
            scale: 1,
            position_x: 0,
            position_y: 0,
          },
          colors: {
            theme: "#202840",
            text: "#FFFFFF",
          },
          logo: "https://reelo-uploads-production.s3.ap-south-1.amazonaws.com/uploads/users/6206410f9be20234ced45c98/1663135731206.png",
          audience: {
            type: "filters",
            filters: {
              average_spend: ["medium", "high", "very_high"],
              store_ids: ["6206418c92a7a876caaedefb"],
              exclude_invalid_channels: ["whatsapp"],
              blocked_customers: false,
            },
          },
          repeat_ends: null,
          repeat_interval: null,
          schedule_at: "2022-11-06T08:12:18.000Z",
          timezone: "Asia/Kolkata",
          attribute_visits: 39,
          attribute_revenue: 30544,
          delivered: 4096,
        },
        {
          _id: "63638185a51980588fc1ca4e",
          whatsapp: {
            details: {
              store_name: "GAUTAMS O DINE ",
              details_0: "Did someone say",
              details_1:
                "Don't worry, just walk in & pamper yourself with our delicious delights!",
              details_2: "Don’t miss this! Click here",
              reward_value: "dessert",
            },
            short_link: {
              type: "default",
              is_file: false,
              url: "l.reelo.io/acTcH",
            },
            content:
              "GAUTAMS O DINE \n\nDid someone say Free dessert?\n\nDon't worry, just walk in & pamper yourself with our delicious delights!\n\nDon’t miss this! Click here",
            media_details: {
              is_enable: true,
              is_custom: false,
              type: "image",
              document:
                "https://reelo-assets.s3.ap-south-1.amazonaws.com/static/campaigns/templates/banners/%23148.jpg",
            },
            call_to_action: {
              is_enable: true,
              buttons: [
                {
                  action: "link",
                  label: "Learn more",
                  value: "l.reelo.io/acTcH",
                },
              ],
            },
            fields: [
              "store_name",
              "details_0",
              "reward_value",
              "details_1",
              "details_2",
            ],
          },
          reward: {
            type: "free_item",
            items: [
              {
                name: "dessert",
              },
            ],
            applies_on: "purchase",
          },
          status: "published",
          channels: [
            {
              name: "sms",
              credits: 1,
              status: false,
            },
            {
              credits: 1,
              name: "email",
              status: false,
            },
            {
              credits: 1,
              name: "whatsapp",
              status: true,
            },
          ],
          repeat: null,
          auto_deactivate: false,
          entity_type: "Group",
          entity_id: "6305bf488fe4c44de1858f6c",
          type: "template",
          user_id: "6206410f9be20234ced45c98",
          template_id: "02697",
          created_at: "2022-11-03T08:53:25.733Z",
          updated_at: "2022-11-03T08:56:16.843Z",
          __v: 0,
          email_content: "not-exist-yet",
          email_subject: "Free dessert alert!!!",
          subtitle:
            "Pamper yourself to a splendid meal with a free dessert at GAUTAMS O DINE . ",
          title: "Make your meals special with free dessert",
          contact_number: "9XXXXXXXX4",
          expires_at: "2022-11-08T18:29:59.000Z",
          redemption_per_customer: "single",
          terms:
            "2 offers cannot be clubbed.\n Reward cannot be exchanged for cash.",
          banner:
            "https://reelo-assets.s3.ap-south-1.amazonaws.com/static/campaigns/templates/banners/%23148.jpg",
          banner_position: {
            scale: 1,
            position_x: 0,
            position_y: 0,
          },
          colors: {
            theme: "#546C78",
            text: "#FFFFFF",
          },
          logo: "https://reelo-uploads-production.s3.ap-south-1.amazonaws.com/uploads/users/6206410f9be20234ced45c98/1663135731206.png",
          audience: {
            type: "all",
            filters: {
              blocked_customers: false,
              exclude_invalid_channels: ["whatsapp"],
              store_ids: ["633af231c23d786015b6e8d7"],
            },
          },
          repeat_ends: null,
          repeat_interval: null,
          schedule_at: "2022-11-03T08:56:12.000Z",
          timezone: "Asia/Kolkata",
          attribute_visits: 3,
          attribute_revenue: 3574,
          delivered: 318,
        },
        {
          _id: "6360ef3ea0f71a3f59ced986",
          whatsapp: {
            fields: [],
          },
          reward: {
            items: [
              {
                name: "Desserts",
              },
            ],
            type: "free_item",
            applies_on: "purchase",
          },
          status: "completed",
          channels: [
            {
              name: "sms",
              credits: 1,
              status: true,
            },
            {
              credits: 1,
              name: "email",
              status: true,
            },
            {
              credits: 1,
              name: "whatsapp",
              status: false,
            },
          ],
          repeat: null,
          auto_deactivate: false,
          entity_type: "Group",
          entity_id: "6305bf488fe4c44de1858f6c",
          type: "template",
          user_id: "6206410f9be20234ced45c98",
          template_id: "02710",
          created_at: "2022-11-01T10:04:46.504Z",
          updated_at: "2022-11-06T18:29:59.028Z",
          __v: 0,
          email_content:
            "uploads/users/6206410f9be20234ced45c98/6360ef3ea0f71a3f59ced986.png",
          email_subject: "Complimentary Desserts on us!",
          subtitle:
            "On our 5 Year Store Anniversary Occasion Grab these FREE Desserts on a minimum order of 499\n",
          title: "FREE Desserts on the house. Come visit us.",
          contact_number: "9XXXXXXXX4",
          expires_at: "2022-11-06T18:29:59.000Z",
          redemption_per_customer: "single",
          terms:
            "2 offers cannot be clubbed.\n Reward cannot be exchanged for cash.\nMin purchase required RS499",
          banner:
            "https://reelo-assets.s3.ap-south-1.amazonaws.com/static/campaigns/templates/banners/4JpKGulysse-pointcheval-1WmlAiYgnoI-unsplash.jpg",
          banner_position: {
            scale: 1,
            position_x: 0,
            position_y: 0,
          },
          colors: {
            theme: "#121213",
            text: "#FFFFFF",
          },
          logo: "https://reelo-uploads-production.s3.ap-south-1.amazonaws.com/uploads/users/6206410f9be20234ced45c98/1663135731206.png",
          sms: {
            details: {
              store_name: "GAUTAMS O DINE ",
              details_0: "It's time for celebration",
              details_1: "We just turned 5 today",
              details_2: "Come join us & enjoy",
              details_3: "us.",
              reward_value: "Desserts",
            },
            short_link: {
              type: "default",
              is_file: false,
              url: "l.reelo.io/StUkI",
            },
            content:
              "GAUTAMS O DINE : It's time for celebration. We just turned 5 today. Come join us & enjoy FREE Desserts with us. Click l.reelo.io/StUkI \n\nvia Reelo",
          },
          audience: {
            type: "all",
            filters: {
              blocked_customers: false,
              exclude_invalid_channels: ["sms", "email"],
              store_ids: ["633af231c23d786015b6e8d7"],
            },
          },
          repeat_ends: null,
          repeat_interval: null,
          schedule_at: "2022-11-01T10:13:15.000Z",
          timezone: "Asia/Kolkata",
          attribute_visits: 27,
          attribute_revenue: 31263,
          delivered: 2348,
        },
        {
          _id: "635e5ec67d1cb204954b0bae",
          whatsapp: {
            details: {
              store_name: "GAUTAMS O DINE ",
              details_0:
                "BOO! 👻 Our yummy Halloween deals are here. Where are you?",
              details_1: "Order now & enjoy our tasty #HalloweenSpecial treats",
              details_2: "Don’t miss this! Click here",
              reward_value: 10,
              contact: "9XXXXXXXX4",
            },
            short_link: {
              type: "default",
              is_file: false,
              url: "l.reelo.io/YIxYy",
            },
            content:
              "GAUTAMS O DINE \n\nBOO! 👻 Our yummy Halloween deals are here. Where are you?\n\nOrder now & enjoy our tasty #HalloweenSpecial treats at 10% Off.\n\nCall #9034043664\n\nDon’t miss this! Click here",
            media_details: {
              is_enable: true,
              is_custom: false,
              type: "image",
              document:
                "https://reelo-assets.s3.ap-south-1.amazonaws.com/static/loyalty/food_beverage/fine_dine_restaurant/Fine+dining+7.jpg",
            },
            call_to_action: {
              is_enable: true,
              buttons: [
                {
                  action: "link",
                  label: "Learn more",
                  value: "l.reelo.io/YIxYy",
                },
              ],
            },
            fields: [
              "store_name",
              "details_0",
              "details_1",
              "reward_value",
              "contact",
              "details_2",
            ],
          },
          reward: {
            type: "percentage_off",
            discount_off: 10,
            applies_on: "purchase",
          },
          status: "completed",
          channels: [
            {
              name: "sms",
              credits: 1,
              status: false,
            },
            {
              credits: 1,
              name: "email",
              status: false,
            },
            {
              credits: 1,
              name: "whatsapp",
              status: true,
            },
          ],
          repeat: null,
          auto_deactivate: false,
          entity_type: "Group",
          entity_id: "6305bf488fe4c44de1858f6c",
          type: "template",
          user_id: "6206410f9be20234ced45c98",
          template_id: "05459",
          created_at: "2022-10-30T11:23:50.744Z",
          updated_at: "2022-11-04T18:29:59.013Z",
          __v: 0,
          email_content: "not-exist-yet",
          email_subject: "Halloween Treats: Disappearing in few Hrs 🕧",
          subtitle:
            "🎃 HAPPY HALLOWEEN! Get an exclusive 10% Off on our tasty #HalloweenSpecials - grab now ",
          title: "BOO! Tasty Savings Alert: 10% Off",
          contact_number: "9XXXXXXXX4",
          expires_at: "2022-11-04T18:29:59.000Z",
          redemption_per_customer: "single",
          terms:
            "2 offers cannot be clubbed.\n Reward cannot be exchanged for cash.\nMin purchase required Rs 1499",
          banner:
            "https://reelo-assets.s3.ap-south-1.amazonaws.com/static/loyalty/food_beverage/fine_dine_restaurant/Fine+dining+7.jpg",
          banner_position: {
            scale: 1,
            position_x: 0,
            position_y: 0,
          },
          colors: {
            theme: "#060809",
            text: "#FFFFFF",
          },
          logo: "https://reelo-uploads-production.s3.ap-south-1.amazonaws.com/uploads/users/6206410f9be20234ced45c98/1663135731206.png",
          audience: {
            type: "all",
            filters: {
              blocked_customers: false,
              exclude_invalid_channels: ["whatsapp"],
              store_ids: ["633af231c23d786015b6e8d7"],
            },
          },
          repeat_ends: null,
          repeat_interval: null,
          schedule_at: "2022-10-30T11:27:44.000Z",
          timezone: "Asia/Kolkata",
          attribute_visits: 3,
          attribute_revenue: 4470,
          delivered: 248,
        },
      ],
      totalDocs: 55,
      limit: 5,
      page: 1,
      totalPages: 11,
      pagingCounter: 1,
      hasPrevPage: false,
      hasNextPage: true,
      prevPage: null,
      nextPage: 2,
    },
  },
  customerInsights: {
    custGraphData: getUpdatedDateData("date", "MMM DD", [
      {
        date: "Oct 10",
        new: 20,
        repeat: 24,
      },
      {
        date: "Oct 11",
        new: 23,
        repeat: 34,
      },
      {
        date: "Oct 12",
        new: 21,
        repeat: 25,
      },
      {
        date: "Oct 13",
        new: 42,
        repeat: 61,
      },
      {
        date: "Oct 14",
        new: 22,
        repeat: 25,
      },
      {
        date: "Oct 15",
        new: 20,
        repeat: 23,
      },
      {
        date: "Oct 16",
        new: 24,
        repeat: 30,
      },
      {
        date: "Oct 17",
        new: 11,
        repeat: 24,
      },
      {
        date: "Oct 18",
        new: 23,
        repeat: 35,
      },
      {
        date: "Oct 19",
        new: 17,
        repeat: 36,
      },
      {
        date: "Oct 20",
        new: 18,
        repeat: 25,
      },
      {
        date: "Oct 21",
        new: 30,
        repeat: 40,
      },
      {
        date: "Oct 22",
        new: 20,
        repeat: 37,
      },
      {
        date: "Oct 23",
        new: 34,
        repeat: 47,
      },
      {
        date: "Oct 24",
        new: 10,
        repeat: 16,
      },
      {
        date: "Oct 25",
        new: 19,
        repeat: 50,
      },
      {
        date: "Oct 26",
        new: 35,
        repeat: 35,
      },
      {
        date: "Oct 27",
        new: 24,
        repeat: 33,
      },
      {
        date: "Oct 28",
        new: 11,
        repeat: 15,
      },
      {
        date: "Oct 29",
        new: 30,
        repeat: 34,
      },
      {
        date: "Oct 30",
        new: 22,
        repeat: 22,
      },
      {
        date: "Oct 31",
        new: 20,
        repeat: 27,
      },
      {
        date: "Nov 01",
        new: 13,
        repeat: 19,
      },
      {
        date: "Nov 02",
        new: 8,
        repeat: 22,
      },
      {
        date: "Nov 03",
        new: 13,
        repeat: 17,
      },
      {
        date: "Nov 04",
        new: 10,
        repeat: 28,
      },
      {
        date: "Nov 05",
        new: 18,
        repeat: 28,
      },
      {
        date: "Nov 06",
        new: 23,
        repeat: 38,
      },
      {
        date: "Nov 07",
        new: 16,
        repeat: 35,
      },
      {
        date: "Nov 08",
        new: 6,
        repeat: 3,
      },
    ]),
    snapShotData: {
      unique: 9344,
      first_time: 9344,
      more_than_one_visit: 3073,
    },
    kycData: {
      customers_by_day: {
        mon_fri: 55,
        weekend: 26,
        both: 19,
      },
      avg_spend: {
        first: 740,
        repeat: 705,
        percentage_change: -5,
      },
    },
    custList: {
      docs: [
        {
          _id: "627f91120627788dfdcf74ad",
          total_spent: 42768,
          redemptions: 15,
          total_redeemed_points: 37600,
          current_points: 5168,
          last_visited_at: "2022-09-19T13:01:55.206Z",
          total_visits: 121,
          avg_spend: 353,
          rfm_segment: "at-risk",
          invalid_channels: [],
          customer_tags: [],
          name: "",
          email: "",
          phone: "8XXXXXXXX7",
          points_balance: 5168,
        },
        {
          _id: "6214b6195b6fc1e0237ac70f",
          total_spent: 40174,
          redemptions: 16,
          total_redeemed_points: 29600,
          current_points: 3313,
          last_visited_at: "2022-11-08T07:49:03.456Z",
          total_visits: 58,
          avg_spend: 693,
          rfm_segment: "vip",
          invalid_channels: ["sms"],
          customer_tags: [],
          name: "",
          email: "smadhxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX7",
          points_balance: 3313,
        },
        {
          _id: "621cdfb1f31b7366ec182e00",
          total_spent: 36470,
          redemptions: 13,
          total_redeemed_points: 28800,
          current_points: 7170,
          last_visited_at: "2022-11-02T17:23:13.601Z",
          total_visits: 99,
          avg_spend: 368,
          rfm_segment: "vip",
          invalid_channels: [],
          customer_tags: [],
          name: "",
          email: "",
          phone: "8XXXXXXXX8",
          points_balance: 7170,
        },
        {
          _id: "621cdf9bf31b7366ec1826c0",
          total_spent: 36195,
          redemptions: 9,
          total_redeemed_points: 29000,
          current_points: 4372,
          last_visited_at: "2022-11-06T17:28:47.952Z",
          total_visits: 43,
          avg_spend: 842,
          rfm_segment: "at-risk",
          invalid_channels: [],
          customer_tags: [],
          name: "",
          email: "",
          phone: "9XXXXXXXX2",
          points_balance: 4372,
        },
        {
          _id: "6352ba44e8aa6b319b6d8c4e",
          total_spent: 35108,
          redemptions: 0,
          total_redeemed_points: 0,
          current_points: 35108,
          last_visited_at: "2022-10-21T15:35:07.479Z",
          total_visits: 2,
          avg_spend: 17554,
          rfm_segment: "promising",
          invalid_channels: [],
          customer_tags: [],
          preferences: {
            communication: {
              whatsapp: [],
              sms: [],
              email: [],
            },
          },
          name: "AMBUJA CEMENTS LIMITED",
          email: "",
          phone: "7XXXXXXXX3",
          points_balance: 35108,
        },
        {
          _id: "620d158e86adaf1359e3c2f0",
          total_spent: 30769,
          redemptions: 12,
          total_redeemed_points: 25000,
          current_points: 4603,
          last_visited_at: "2022-11-06T15:34:38.559Z",
          total_visits: 69,
          avg_spend: 446,
          rfm_segment: "vip",
          invalid_channels: [],
          customer_tags: [],
          name: "vikram",
          email: "",
          phone: "9XXXXXXXX6",
          points_balance: 4603,
        },
        {
          _id: "621cdfbff31b7366ec1832c0",
          total_spent: 30263,
          redemptions: 6,
          total_redeemed_points: 18500,
          current_points: 11843,
          last_visited_at: "2022-10-05T18:16:20.457Z",
          total_visits: 15,
          avg_spend: 2018,
          rfm_segment: "promising",
          invalid_channels: ["sms"],
          customer_tags: [],
          name: "",
          email: "",
          phone: "9XXXXXXXX0",
          points_balance: 11843,
        },
        {
          _id: "621cdfa8f31b7366ec182b7b",
          total_spent: 28933,
          redemptions: 2,
          total_redeemed_points: 10000,
          current_points: 9950,
          last_visited_at: "2022-09-18T16:45:58.554Z",
          total_visits: 7,
          avg_spend: 4133,
          rfm_segment: "promising",
          invalid_channels: [],
          customer_tags: [],
          name: "mr yogesh",
          email: "",
          phone: "8XXXXXXXX1",
          points_balance: 9950,
        },
        {
          _id: "6214f8e95b6fc1e0237ad4e5",
          total_spent: 26963,
          redemptions: 10,
          total_redeemed_points: 27300,
          current_points: 1381,
          last_visited_at: "2022-10-30T12:38:18.678Z",
          total_visits: 46,
          avg_spend: 586,
          rfm_segment: "vip",
          invalid_channels: ["sms"],
          customer_tags: [],
          name: "customer",
          email: "",
          phone: "9XXXXXXXX4",
          points_balance: 1381,
        },
        {
          _id: "621654dd5b6fc1e0237b0188",
          total_spent: 24439,
          redemptions: 12,
          total_redeemed_points: 22400,
          current_points: 3039,
          last_visited_at: "2022-11-04T06:53:54.526Z",
          total_visits: 31,
          avg_spend: 788,
          rfm_segment: "vip",
          invalid_channels: ["sms"],
          customer_tags: [],
          name: "customer",
          email: "",
          phone: "7XXXXXXXX1",
          points_balance: 3039,
        },
        {
          _id: "621b96fabd5e281e79cf524d",
          total_spent: 23555,
          redemptions: 12,
          total_redeemed_points: 22000,
          current_points: 990,
          last_visited_at: "2022-11-07T14:13:49.855Z",
          total_visits: 52,
          avg_spend: 453,
          rfm_segment: "vip",
          invalid_channels: ["sms"],
          customer_tags: [],
          name: "",
          email: "",
          phone: "9XXXXXXXX9",
          points_balance: 990,
        },
        {
          _id: "621ce04af31b7366ec186905",
          total_spent: 22085,
          redemptions: 1,
          total_redeemed_points: 5000,
          current_points: 0,
          last_visited_at: "2022-08-29T17:14:17.766Z",
          total_visits: 4,
          avg_spend: 5521,
          rfm_segment: "promising",
          invalid_channels: [],
          customer_tags: [],
          name: "mr. manoj kalra",
          email: "",
          phone: "9XXXXXXXX1",
          points_balance: 0,
        },
        {
          _id: "621ce03df31b7366ec1863a9",
          total_spent: 21684,
          redemptions: 0,
          total_redeemed_points: 0,
          current_points: 0,
          last_visited_at: "2022-06-28T10:24:27.915Z",
          total_visits: 1,
          avg_spend: 21684,
          rfm_segment: "promising",
          invalid_channels: [],
          customer_tags: [],
          name: "Ramnivas Ji",
          email: "",
          phone: "9XXXXXXXX4",
          points_balance: 0,
        },
        {
          _id: "623c2e8045ede87b5e8c9aaf",
          total_spent: 20199,
          redemptions: 6,
          total_redeemed_points: 14000,
          current_points: 5363,
          last_visited_at: "2022-11-05T07:41:44.842Z",
          total_visits: 26,
          avg_spend: 777,
          rfm_segment: "vip",
          invalid_channels: ["sms"],
          customer_tags: [],
          name: "",
          email: "",
          phone: "9XXXXXXXX4",
          points_balance: 5363,
        },
        {
          _id: "620e72863442de7ddf4ae593",
          total_spent: 19192,
          redemptions: 7,
          total_redeemed_points: 13000,
          current_points: 5153,
          last_visited_at: "2022-10-25T15:42:12.122Z",
          total_visits: 26,
          avg_spend: 738,
          rfm_segment: "vip",
          invalid_channels: [],
          customer_tags: [],
          name: "",
          email: "",
          phone: "9XXXXXXXX8",
          points_balance: 5153,
        },
      ],
      totalDocs: 28151,
      limit: 15,
      page: 1,
      totalPages: 1146,
      pagingCounter: 1,
      hasPrevPage: false,
      hasNextPage: true,
      prevPage: null,
      nextPage: 2,
    },
    custActivity: {
      docs: getCustomersActivity([
        {
          _id: "636a19c949852fd3e974d61b",
          belongs_to: "loyalty",
          action: "Purchase",
          history: [],
          customer_id: "636a19c949852fd3e974d604",
          store_id: "6206418c92a7a876caaedefb",
          value: 1537,
          bill_number: "19235",
          bill_amount: 1537,
          date_time: "08 Nov, 2022 | 14:26",
          name: "",
          mobile: "9XXXXXXXX0",
          store_name: "GAUTAMS O DINE ",
          points: "+1537",
        },
        {
          _id: "636a18f549852fd3e974b291",
          belongs_to: "loyalty",
          action: "Purchase",
          history: [],
          customer_id: "636a18f449852fd3e974b279",
          store_id: "6206418c92a7a876caaedefb",
          value: 574,
          bill_number: "19234",
          bill_amount: 574,
          date_time: "08 Nov, 2022 | 14:23",
          name: "",
          mobile: "8XXXXXXXX5",
          store_name: "GAUTAMS O DINE ",
          points: "+574",
        },
        {
          _id: "636a171649852fd3e9747d08",
          belongs_to: "loyalty",
          action: "Purchase",
          history: [],
          customer_id: "636a171549852fd3e9747cde",
          store_id: "6206418c92a7a876caaedefb",
          value: 439,
          bill_number: "19233",
          bill_amount: 439,
          date_time: "08 Nov, 2022 | 14:15",
          name: "",
          mobile: "9XXXXXXXX4",
          store_name: "GAUTAMS O DINE ",
          points: "+439",
        },
        {
          _id: "636a151949852fd3e97435d8",
          belongs_to: "loyalty",
          action: "Purchase",
          history: [],
          customer_id: "626d51005236e00f339807a6",
          store_id: "6206418c92a7a876caaedefb",
          value: 40,
          bill_number: "19232",
          bill_amount: 40,
          date_time: "08 Nov, 2022 | 14:06",
          name: "",
          mobile: "8XXXXXXXX2",
          store_name: "GAUTAMS O DINE ",
          points: "+40",
        },
        {
          _id: "636a151949852fd3e97435cf",
          belongs_to: "loyalty",
          action: "Redemption",
          history: [],
          customer_id: "626d51005236e00f339807a6",
          store_id: "6206418c92a7a876caaedefb",
          value: 0,
          bill_number: "19232",
          bill_amount: "0",
          date_time: "08 Nov, 2022 | 14:06",
          name: "",
          mobile: "8XXXXXXXX2",
          store_name: "GAUTAMS O DINE ",
          points: "-800",
        },
        {
          _id: "636a14ef49852fd3e9743125",
          belongs_to: "loyalty",
          action: "Purchase",
          history: [],
          customer_id: "626d51005236e00f339807a6",
          store_id: "6206418c92a7a876caaedefb",
          value: 93,
          bill_number: "19231",
          bill_amount: 93,
          date_time: "08 Nov, 2022 | 14:05",
          name: "",
          mobile: "8XXXXXXXX2",
          store_name: "GAUTAMS O DINE ",
          points: "+93",
        },
        {
          _id: "636a0f6049852fd3e973814a",
          belongs_to: "loyalty",
          action: "Purchase",
          history: [],
          customer_id: "636a0f6049852fd3e9738133",
          store_id: "6206418c92a7a876caaedefb",
          value: 2262,
          bill_number: "19230",
          bill_amount: 2262,
          date_time: "08 Nov, 2022 | 13:42",
          name: "",
          mobile: "9XXXXXXXX6",
          store_name: "GAUTAMS O DINE ",
          points: "+2262",
        },
        {
          _id: "636a0d3f49852fd3e97333dd",
          belongs_to: "loyalty",
          action: "Purchase",
          history: [],
          customer_id: "621ce013f31b7366ec185393",
          store_id: "6206418c92a7a876caaedefb",
          value: 486,
          bill_number: "19228",
          bill_amount: 486,
          date_time: "08 Nov, 2022 | 13:33",
          name: "",
          mobile: "9XXXXXXXX5",
          store_name: "GAUTAMS O DINE ",
          points: "+486",
        },
        {
          _id: "636a09ef49852fd3e972d5fe",
          belongs_to: "campaign",
          action: "Purchase",
          history: [],
          customer_id: "6214b6195b6fc1e0237ac70f",
          store_id: "6206418c92a7a876caaedefb",
          value: 1271,
          bill_number: "19227",
          bill_amount: 1271,
          date_time: "08 Nov, 2022 | 13:19",
          name: "",
          mobile: "9XXXXXXXX7",
          store_name: "GAUTAMS O DINE ",
          points: "+1271",
        },
        {
          _id: "636a09ef49852fd3e972d5fb",
          belongs_to: "campaign",
          action: "Redemption",
          history: [],
          customer_id: "6214b6195b6fc1e0237ac70f",
          store_id: "6206418c92a7a876caaedefb",
          value: 1271,
          bill_number: "19227",
          bill_amount: "0",
          date_time: "08 Nov, 2022 | 13:19",
          name: "",
          mobile: "9XXXXXXXX7",
          store_name: "GAUTAMS O DINE ",
          points: "-0",
        },
      ]),
      totalDocs: 43003,
      limit: 10,
      page: 1,
      totalPages: 4301,
      pagingCounter: 1,
      hasPrevPage: false,
      hasNextPage: true,
      prevPage: null,
      nextPage: 2,
    },
    custSegm: {
      total_customers: 9405,
      customer_segments: [
        {
          segment: "vip",
          count: 20,
        },
        {
          segment: "loyal",
          count: 2,
        },
        {
          segment: "promising",
          count: 1871,
        },
        {
          segment: "new",
          count: 4859,
        },
        {
          segment: "need-attention",
          count: 831,
        },
        {
          segment: "at-risk",
          count: 301,
        },
        {
          segment: "lost",
          count: 1521,
        },
      ],
    },
    custTableSegm: [
      {
        rfm_segment: "promising",
        customers: 1870,
        visits: 6583,
        value: 6067932,
      },
      {
        rfm_segment: "loyal",
        customers: 2,
        visits: 64,
        value: 27026,
      },
      {
        rfm_segment: "vip",
        customers: 20,
        visits: 801,
        value: 397403,
      },
      {
        rfm_segment: "new",
        customers: 4799,
        visits: 5733,
        value: 2758881,
      },
      {
        rfm_segment: "need-attention",
        customers: 831,
        visits: 2229,
        value: 1434884,
      },
      {
        rfm_segment: "at-risk",
        customers: 301,
        visits: 1584,
        value: 1370477,
      },
      {
        rfm_segment: "lost",
        customers: 1521,
        visits: 1944,
        value: 941449,
      },
    ],
    dynamicFilterVals: {
      visits: {
        max: 121,
        min: 1,
        avg: 2,
      },
      spent: {
        max: 42768,
        min: 0,
        avg: 1391,
      },
      average_spent: {
        max: 21684,
        min: 0,
        avg: 729,
      },
      redemption: {
        max: 37600,
        min: 0,
        avg: 3083,
      },
      segments: [
        {
          _id: "promising",
          count: 1871,
        },
        {
          _id: "lost",
          count: 1521,
        },
        {
          _id: "imported",
          count: 7779,
        },
        {
          _id: "need-attention",
          count: 831,
        },
        {
          _id: "new",
          count: 4859,
        },
        {
          _id: "at-risk",
          count: 301,
        },
        {
          _id: "loyal",
          count: 2,
        },
        {
          _id: "vip",
          count: 20,
        },
        {
          _id: "potential",
          count: 1,
        },
      ],
      gender: [
        {
          _id: "male",
          count: 970,
        },
        {
          _id: "female",
          count: 154,
        },
        {
          _id: "Not Specified",
          count: 16061,
        },
      ],
      loyalty_points: {
        max: 35108,
        min: 0,
        avg: 268,
      },
      customers: {
        blocked: 2,
        imported: 7728,
        potential: 269,
        purchased: 20149,
        total: 28151,
      },
      stores: [],
    },
  },
  loyalty: {
    loyaltyInsights: {
      reward_scoreboard: commonRewardScoreboard,
      rewards_redemption_count: 1188,
      points_redeemed: 2034900,
      points_issued: 13350258,
      redemption_rate: "15.24",
      top_redeeming_customers: [
        {
          total_spent: 42768,
          customer: {
            name: "",
            phone: "8XXXXXXXX7",
            id: "627f91120627788dfdcf74ad",
          },
          count: 15,
        },
        {
          total_spent: 38903,
          customer: {
            name: "",
            phone: "9XXXXXXXX7",
            id: "6214b6195b6fc1e0237ac70f",
          },
          count: 15,
        },
        {
          total_spent: 36470,
          customer: {
            phone: "8XXXXXXXX8",
            name: "",
            id: "621cdfb1f31b7366ec182e00",
          },
          count: 13,
        },
      ],
      avg_days_to_redemption: 74.2,
      customers_enough_to_redeem: "9.9",
      best_and_least_popular_time: {
        best: {
          time: "Sunday Afternoon",
          redemptions: 112,
          percentage: 9.427609427609427,
        },
        least: {
          time: "Thursday Night",
          redemptions: 1,
          percentage: 0.08417508417508417,
        },
      },
      recent_activity: [
        {
          customer: {
            name: "",
            phone: "9XXXXXXXX0",
            id: "636a19c949852fd3e974d604",
          },
          action: "Earn",
          date: `${moment().format("MMM DD, YYYY")} 2:26 PM`,
          points: "+1537",
        },
        {
          customer: {
            name: "",
            phone: "8XXXXXXXX5",
            id: "636a18f449852fd3e974b279",
          },
          action: "Earn",
          date: `${moment().format("MMM DD, YYYY")} 2:23 PM`,
          points: "+574",
        },
        {
          customer: {
            name: "",
            phone: "9XXXXXXXX4",
            id: "636a171549852fd3e9747cde",
          },
          action: "Earn",
          date: `${moment().format("MMM DD, YYYY")} 2:15 PM`,
          points: "+439",
        },
        {
          customer: {
            name: "",
            phone: "8XXXXXXXX2",
            id: "626d51005236e00f339807a6",
          },
          action: "Earn",
          date: `${moment().format("MMM DD, YYYY")} 2:06 PM`,
          points: "+40",
        },
        {
          customer: {
            name: "",
            phone: "8XXXXXXXX2",
            id: "626d51005236e00f339807a6",
          },
          action: "Redeem",
          date: `${moment().format("MMM DD, YYYY")} 2:06 PM`,
          points: "-800",
        },
      ],
      general: {
        activeUsers: 7583,
        inactiveUsers: 1822,
        stats: getUpdatedDateData("date", "YYYY-MM-DD", [
          {
            revenue: 0,
            redemptions: 9,
            date: "2022-08-23",
          },
          {
            revenue: 0,
            redemptions: 3,
            date: "2022-03-13",
          },
          {
            revenue: 0,
            redemptions: 9,
            date: "2022-06-13",
          },
          {
            revenue: 1371,
            redemptions: 3,
            date: "2022-04-16",
          },
          {
            revenue: 0,
            redemptions: 15,
            date: "2022-08-21",
          },
          {
            revenue: 0,
            redemptions: 7,
            date: "2022-07-28",
          },
          {
            revenue: 0,
            redemptions: 6,
            date: "2022-08-16",
          },
          {
            revenue: 0,
            redemptions: 5,
            date: "2022-06-20",
          },
          {
            revenue: 0,
            redemptions: 3,
            date: "2022-03-09",
          },
          {
            revenue: 0,
            redemptions: 2,
            date: "2022-03-12",
          },
          {
            revenue: 0,
            redemptions: 6,
            date: "2022-08-12",
          },
          {
            revenue: 0,
            redemptions: 5,
            date: "2022-09-06",
          },
          {
            revenue: 0,
            redemptions: 7,
            date: "2022-10-07",
          },
          {
            revenue: 2628,
            redemptions: 4,
            date: "2022-04-21",
          },
          {
            revenue: 0,
            redemptions: 8,
            date: "2022-08-17",
          },
          {
            revenue: 877,
            redemptions: 1,
            date: "2022-05-03",
          },
          {
            revenue: 3307,
            redemptions: 4,
            date: "2022-05-15",
          },
          {
            revenue: 1208,
            redemptions: 3,
            date: "2022-04-30",
          },
          {
            revenue: 0,
            redemptions: 3,
            date: "2022-09-12",
          },
          {
            revenue: 1078,
            redemptions: 3,
            date: "2022-04-15",
          },
          {
            revenue: 3960,
            redemptions: 6,
            date: "2022-04-02",
          },
          {
            revenue: 0,
            redemptions: 1,
            date: "2022-09-23",
          },
          {
            revenue: 1942,
            redemptions: 4,
            date: "2022-04-13",
          },
          {
            revenue: 0,
            redemptions: 6,
            date: "2022-06-22",
          },
          {
            revenue: 3252,
            redemptions: 5,
            date: "2022-04-18",
          },
          {
            revenue: 3018,
            redemptions: 5,
            date: "2022-05-01",
          },
          {
            revenue: 0,
            redemptions: 10,
            date: "2022-08-22",
          },
          {
            revenue: 933,
            redemptions: 1,
            date: "2022-04-29",
          },
          {
            revenue: 0,
            redemptions: 6,
            date: "2022-06-29",
          },
          {
            revenue: 0,
            redemptions: 17,
            date: "2022-07-24",
          },
          {
            revenue: 0,
            redemptions: 2,
            date: "2022-03-15",
          },
          {
            revenue: 741,
            redemptions: 2,
            date: "2022-05-26",
          },
          {
            revenue: 0,
            redemptions: 3,
            date: "2022-08-15",
          },
          {
            revenue: 0,
            redemptions: 8,
            date: "2022-07-14",
          },
          {
            revenue: 0,
            redemptions: 2,
            date: "2022-11-01",
          },
          {
            revenue: 0,
            redemptions: 5,
            date: "2022-10-15",
          },
          {
            revenue: 0,
            redemptions: 1,
            date: "2022-03-17",
          },
          {
            revenue: 592,
            redemptions: 3,
            date: "2022-03-31",
          },
          {
            revenue: 0,
            redemptions: 7,
            date: "2022-09-14",
          },
          {
            revenue: 1514,
            redemptions: 4,
            date: "2022-05-05",
          },
          {
            revenue: 0,
            redemptions: 8,
            date: "2022-07-29",
          },
          {
            revenue: 0,
            redemptions: 2,
            date: "2022-08-01",
          },
          {
            revenue: 0,
            redemptions: 2,
            date: "2022-09-30",
          },
          {
            revenue: 0,
            redemptions: 11,
            date: "2022-07-03",
          },
          {
            revenue: 6539,
            redemptions: 3,
            date: "2022-04-06",
          },
          {
            revenue: 0,
            redemptions: 11,
            date: "2022-07-13",
          },
          {
            revenue: 96,
            redemptions: 1,
            date: "2022-04-27",
          },
          {
            revenue: 4163,
            redemptions: 6,
            date: "2022-05-09",
          },
          {
            revenue: 0,
            redemptions: 7,
            date: "2022-06-08",
          },
          {
            revenue: 0,
            redemptions: 4,
            date: "2022-09-21",
          },
          {
            revenue: 0,
            redemptions: 2,
            date: "2022-02-25",
          },
          {
            revenue: 3159,
            redemptions: 8,
            date: "2022-04-03",
          },
          {
            revenue: 0,
            redemptions: 6,
            date: "2022-09-05",
          },
          {
            revenue: 0,
            redemptions: 2,
            date: "2022-06-11",
          },
          {
            revenue: 0,
            redemptions: 6,
            date: "2022-08-04",
          },
          {
            revenue: 0,
            redemptions: 7,
            date: "2022-08-10",
          },
          {
            revenue: 809,
            redemptions: 2,
            date: "2022-05-16",
          },
          {
            revenue: 0,
            redemptions: 2,
            date: "2022-03-01",
          },
          {
            revenue: 0,
            redemptions: 3,
            date: "2022-09-04",
          },
          {
            revenue: 0,
            redemptions: 2,
            date: "2022-06-24",
          },
          {
            revenue: 0,
            redemptions: 5,
            date: "2022-08-19",
          },
          {
            revenue: 0,
            redemptions: 8,
            date: "2022-09-10",
          },
          {
            revenue: 0,
            redemptions: 5,
            date: "2022-06-16",
          },
          {
            revenue: 0,
            redemptions: 12,
            date: "2022-10-18",
          },
          {
            revenue: 0,
            redemptions: 11,
            date: "2022-08-20",
          },
          {
            revenue: 0,
            redemptions: 6,
            date: "2022-10-16",
          },
          {
            revenue: 0,
            redemptions: 6,
            date: "2022-07-26",
          },
          {
            revenue: 0,
            redemptions: 7,
            date: "2022-07-21",
          },
          {
            revenue: 0,
            redemptions: 3,
            date: "2022-07-02",
          },
          {
            revenue: 0,
            redemptions: 1,
            date: "2022-02-15",
          },
          {
            revenue: 0,
            redemptions: 8,
            date: "2022-10-06",
          },
          {
            revenue: 1160,
            redemptions: 3,
            date: "2022-05-07",
          },
          {
            revenue: 0,
            redemptions: 7,
            date: "2022-10-17",
          },
          {
            revenue: 0,
            redemptions: 14,
            date: "2022-08-29",
          },
          {
            revenue: 0,
            redemptions: 6,
            date: "2022-09-19",
          },
          {
            revenue: 0,
            redemptions: 9,
            date: "2022-08-18",
          },
          {
            revenue: 0,
            redemptions: 2,
            date: "2022-06-09",
          },
          {
            revenue: 0,
            redemptions: 4,
            date: "2022-08-24",
          },
          {
            revenue: 0,
            redemptions: 8,
            date: "2022-09-25",
          },
          {
            revenue: 0,
            redemptions: 9,
            date: "2022-09-28",
          },
          {
            revenue: 0,
            redemptions: 3,
            date: "2022-06-27",
          },
          {
            revenue: 0,
            redemptions: 2,
            date: "2022-06-15",
          },
          {
            revenue: 1611,
            redemptions: 4,
            date: "2022-06-03",
          },
          {
            revenue: 0,
            redemptions: 6,
            date: "2022-11-07",
          },
          {
            revenue: 152,
            redemptions: 1,
            date: "2022-05-12",
          },
          {
            revenue: 0,
            redemptions: 11,
            date: "2022-07-22",
          },
          {
            revenue: 0,
            redemptions: 4,
            date: "2022-06-26",
          },
          {
            revenue: 0,
            redemptions: 1,
            date: "2022-02-23",
          },
          {
            revenue: 0,
            redemptions: 6,
            date: "2022-08-26",
          },
          {
            revenue: 1883,
            redemptions: 3,
            date: "2022-05-04",
          },
          {
            revenue: 0,
            redemptions: 10,
            date: "2022-10-12",
          },
          {
            revenue: 0,
            redemptions: 5,
            date: "2022-09-15",
          },
          {
            revenue: 0,
            redemptions: 10,
            date: "2022-09-16",
          },
          {
            revenue: 0,
            redemptions: 3,
            date: "2022-10-30",
          },
          {
            revenue: 0,
            redemptions: 1,
            date: "2022-11-03",
          },
          {
            revenue: 921,
            redemptions: 2,
            date: "2022-06-04",
          },
          {
            revenue: 553,
            redemptions: 2,
            date: "2022-04-08",
          },
          {
            revenue: 1872,
            redemptions: 4,
            date: "2022-04-26",
          },
          {
            revenue: 0,
            redemptions: 10,
            date: "2022-09-11",
          },
          {
            revenue: 2788,
            redemptions: 3,
            date: "2022-03-23",
          },
          {
            revenue: 2908,
            redemptions: 4,
            date: "2022-05-13",
          },
          {
            revenue: 3634,
            redemptions: 5,
            date: "2022-05-29",
          },
          {
            revenue: 2472,
            redemptions: 4,
            date: "2022-06-02",
          },
          {
            revenue: 0,
            redemptions: 1,
            date: "2022-02-24",
          },
          {
            revenue: 0,
            redemptions: 6,
            date: "2022-07-15",
          },
          {
            revenue: 0,
            redemptions: 1,
            date: "2022-11-04",
          },
          {
            revenue: 1529,
            redemptions: 4,
            date: "2022-04-23",
          },
          {
            revenue: 0,
            redemptions: 3,
            date: "2022-07-10",
          },
          {
            revenue: 0,
            redemptions: 4,
            date: "2022-09-20",
          },
          {
            revenue: 0,
            redemptions: 4,
            date: "2022-07-01",
          },
          {
            revenue: 0,
            redemptions: 4,
            date: "2022-06-30",
          },
          {
            revenue: 0,
            redemptions: 3,
            date: "2022-03-05",
          },
          {
            revenue: 1998,
            redemptions: 3,
            date: "2022-05-20",
          },
          {
            revenue: 0,
            redemptions: 11,
            date: "2022-07-30",
          },
          {
            revenue: 0,
            redemptions: 5,
            date: "2022-08-30",
          },
          {
            revenue: 1509,
            redemptions: 2,
            date: "2022-04-11",
          },
          {
            revenue: 868,
            redemptions: 3,
            date: "2022-05-11",
          },
          {
            revenue: 1342,
            redemptions: 3,
            date: "2022-05-18",
          },
          {
            revenue: 0,
            redemptions: 9,
            date: "2022-08-08",
          },
          {
            revenue: 0,
            redemptions: 1,
            date: "2022-10-08",
          },
          {
            revenue: 0,
            redemptions: 4,
            date: "2022-07-16",
          },
          {
            revenue: 124,
            redemptions: 1,
            date: "2022-04-20",
          },
          {
            revenue: 0,
            redemptions: 7,
            date: "2022-09-13",
          },
          {
            revenue: 0,
            redemptions: 3,
            date: "2022-08-13",
          },
          {
            revenue: 0,
            redemptions: 12,
            date: "2022-10-01",
          },
          {
            revenue: 2289,
            redemptions: 4,
            date: "2022-05-17",
          },
          {
            revenue: 0,
            redemptions: 11,
            date: "2022-09-01",
          },
          {
            revenue: 0,
            redemptions: 5,
            date: "2022-07-04",
          },
          {
            revenue: 0,
            redemptions: 6,
            date: "2022-07-27",
          },
          {
            revenue: 1695,
            redemptions: 3,
            date: "2022-03-24",
          },
          {
            revenue: 0,
            redemptions: 1,
            date: "2022-03-07",
          },
          {
            revenue: 1928,
            redemptions: 9,
            date: "2022-05-27",
          },
          {
            revenue: 903,
            redemptions: 2,
            date: "2022-04-12",
          },
          {
            revenue: 0,
            redemptions: 9,
            date: "2022-09-17",
          },
          {
            revenue: 0,
            redemptions: 6,
            date: "2022-08-27",
          },
          {
            revenue: 2962,
            redemptions: 4,
            date: "2022-04-22",
          },
          {
            revenue: 0,
            redemptions: 10,
            date: "2022-07-11",
          },
          {
            revenue: 0,
            redemptions: 4,
            date: "2022-03-08",
          },
          {
            revenue: 0,
            redemptions: 2,
            date: "2022-10-14",
          },
          {
            revenue: 0,
            redemptions: 7,
            date: "2022-07-07",
          },
          {
            revenue: 0,
            redemptions: 9,
            date: "2022-10-20",
          },
          {
            revenue: 0,
            redemptions: 1,
            date: "2022-10-26",
          },
          {
            revenue: 0,
            redemptions: 3,
            date: "2022-03-03",
          },
          {
            revenue: 0,
            redemptions: 5,
            date: "2022-08-02",
          },
          {
            revenue: 3180,
            redemptions: 6,
            date: "2022-04-17",
          },
          {
            revenue: 0,
            redemptions: 4,
            date: "2022-06-14",
          },
          {
            revenue: 0,
            redemptions: 6,
            date: "2022-06-19",
          },
          {
            revenue: 0,
            redemptions: 9,
            date: "2022-08-07",
          },
          {
            revenue: 610,
            redemptions: 1,
            date: "2022-03-25",
          },
          {
            revenue: 0,
            redemptions: 6,
            date: "2022-10-21",
          },
          {
            revenue: 2463,
            redemptions: 6,
            date: "2022-04-04",
          },
          {
            revenue: 2702,
            redemptions: 8,
            date: "2022-03-28",
          },
          {
            revenue: 0,
            redemptions: 9,
            date: "2022-07-31",
          },
          {
            revenue: 1557,
            redemptions: 2,
            date: "2022-04-25",
          },
          {
            revenue: 3214,
            redemptions: 5,
            date: "2022-05-24",
          },
          {
            revenue: 0,
            redemptions: 5,
            date: "2022-07-18",
          },
          {
            revenue: 0,
            redemptions: 3,
            date: "2022-10-25",
          },
          {
            revenue: 0,
            redemptions: 1,
            date: "2022-07-19",
          },
          {
            revenue: 0,
            redemptions: 9,
            date: "2022-08-25",
          },
          {
            revenue: 0,
            redemptions: 6,
            date: "2022-09-29",
          },
          {
            revenue: 0,
            redemptions: 1,
            date: "2022-11-02",
          },
          {
            revenue: 0,
            redemptions: 5,
            date: "2022-06-23",
          },
          {
            revenue: 0,
            redemptions: 2,
            date: "2022-10-13",
          },
          {
            revenue: 0,
            redemptions: 6,
            date: "2022-09-07",
          },
          {
            revenue: 0,
            redemptions: 6,
            date: "2022-06-17",
          },
          {
            revenue: 0,
            redemptions: 10,
            date: "2022-07-12",
          },
          {
            revenue: 0,
            redemptions: 9,
            date: "2022-07-06",
          },
          {
            revenue: 14,
            redemptions: 1,
            date: "2022-05-06",
          },
          {
            revenue: 4070,
            redemptions: 5,
            date: "2022-03-26",
          },
          {
            revenue: 0,
            redemptions: 12,
            date: "2022-09-03",
          },
          {
            revenue: 0,
            redemptions: 1,
            date: "2022-11-08",
          },
          {
            revenue: 0,
            redemptions: 10,
            date: "2022-07-05",
          },
          {
            revenue: 2437,
            redemptions: 4,
            date: "2022-05-19",
          },
          {
            revenue: 0,
            redemptions: 10,
            date: "2022-09-24",
          },
          {
            revenue: 0,
            redemptions: 13,
            date: "2022-06-21",
          },
          {
            revenue: 603,
            redemptions: 2,
            date: "2022-03-30",
          },
          {
            revenue: 1596,
            redemptions: 2,
            date: "2022-04-05",
          },
          {
            revenue: 0,
            redemptions: 2,
            date: "2022-03-02",
          },
          {
            revenue: 0,
            redemptions: 6,
            date: "2022-07-20",
          },
          {
            revenue: 0,
            redemptions: 8,
            date: "2022-09-27",
          },
          {
            revenue: 0,
            redemptions: 8,
            date: "2022-10-03",
          },
          {
            revenue: 0,
            redemptions: 1,
            date: "2022-10-29",
          },
          {
            revenue: 2840,
            redemptions: 6,
            date: "2022-05-28",
          },
          {
            revenue: 0,
            redemptions: 5,
            date: "2022-11-06",
          },
          {
            revenue: 0,
            redemptions: 1,
            date: "2022-03-06",
          },
          {
            revenue: 0,
            redemptions: 4,
            date: "2022-06-10",
          },
          {
            revenue: 1139,
            redemptions: 2,
            date: "2022-04-14",
          },
          {
            revenue: 4211,
            redemptions: 6,
            date: "2022-05-08",
          },
          {
            revenue: 0,
            redemptions: 2,
            date: "2022-08-11",
          },
          {
            revenue: 3110,
            redemptions: 3,
            date: "2022-04-19",
          },
          {
            revenue: 361,
            redemptions: 1,
            date: "2022-06-01",
          },
          {
            revenue: 0,
            redemptions: 2,
            date: "2022-08-03",
          },
          {
            revenue: 294,
            redemptions: 1,
            date: "2022-04-07",
          },
          {
            revenue: 0,
            redemptions: 5,
            date: "2022-03-14",
          },
          {
            revenue: 0,
            redemptions: 2,
            date: "2022-03-10",
          },
          {
            revenue: 2131,
            redemptions: 4,
            date: "2022-03-27",
          },
          {
            revenue: 0,
            redemptions: 1,
            date: "2022-10-05",
          },
          {
            revenue: 0,
            redemptions: 4,
            date: "2022-10-09",
          },
          {
            revenue: 0,
            redemptions: 13,
            date: "2022-07-17",
          },
          {
            revenue: 3450,
            redemptions: 6,
            date: "2022-05-22",
          },
          {
            revenue: 0,
            redemptions: 5,
            date: "2022-10-02",
          },
          {
            revenue: 0,
            redemptions: 4,
            date: "2022-07-23",
          },
          {
            revenue: 0,
            redemptions: 2,
            date: "2022-10-23",
          },
          {
            revenue: 0,
            redemptions: 6,
            date: "2022-10-04",
          },
          {
            revenue: 1000,
            redemptions: 4,
            date: "2022-05-25",
          },
          {
            revenue: 0,
            redemptions: 6,
            date: "2022-09-22",
          },
          {
            revenue: 0,
            redemptions: 4,
            date: "2022-07-25",
          },
          {
            revenue: 0,
            redemptions: 12,
            date: "2022-08-14",
          },
          {
            revenue: 3115,
            redemptions: 2,
            date: "2022-06-06",
          },
          {
            revenue: 0,
            redemptions: 5,
            date: "2022-08-28",
          },
          {
            revenue: 0,
            redemptions: 8,
            date: "2022-10-11",
          },
          {
            revenue: 5312,
            redemptions: 7,
            date: "2022-05-21",
          },
          {
            revenue: 0,
            redemptions: 15,
            date: "2022-08-31",
          },
          {
            revenue: 0,
            redemptions: 11,
            date: "2022-06-18",
          },
          {
            revenue: 0,
            redemptions: 7,
            date: "2022-10-19",
          },
          {
            revenue: 210,
            redemptions: 1,
            date: "2022-04-01",
          },
          {
            revenue: 3239,
            redemptions: 7,
            date: "2022-04-24",
          },
          {
            revenue: 3143,
            redemptions: 4,
            date: "2022-06-07",
          },
          {
            revenue: 0,
            redemptions: 4,
            date: "2022-06-12",
          },
          {
            revenue: 0,
            redemptions: 8,
            date: "2022-09-18",
          },
          {
            revenue: 0,
            redemptions: 9,
            date: "2022-09-09",
          },
          {
            revenue: 0,
            redemptions: 6,
            date: "2022-10-22",
          },
          {
            revenue: 4158,
            redemptions: 4,
            date: "2022-05-14",
          },
          {
            revenue: 0,
            redemptions: 13,
            date: "2022-09-26",
          },
          {
            revenue: 0,
            redemptions: 4,
            date: "2022-09-02",
          },
          {
            revenue: 0,
            redemptions: 4,
            date: "2022-08-09",
          },
          {
            revenue: 0,
            redemptions: 9,
            date: "2022-09-08",
          },
          {
            revenue: 91,
            redemptions: 1,
            date: "2022-04-10",
          },
          {
            revenue: 679,
            redemptions: 2,
            date: "2022-05-02",
          },
          {
            revenue: 0,
            redemptions: 4,
            date: "2022-06-28",
          },
        ]),
        total_revenue: 12812152,
        total_redemptions: 139217,
        average_revenue_per_redemption: 0,
      },
      enrolled: {
        count: 93,
        month: "November",
      },
      power_customer: {
        _id: "6214b6195b6fc1e0237ac70f",
        redemptions_count: 5,
        spend: 8924,
        customer: {
          name: "Sambhav",
          email: "smadhxxxxxxxx@gmail.com",
          phone: "9XXXXXXXX7",
          id: "6214b6195b6fc1e0237ac70f",
        },
      },
    },
    loyaltyPerf: {
      points_redeemed: 197000,
      points_issued: 891982,
      redeem_count: 107,
      redemption_rate: "22.09",
      total_revenue: 78213,
      visits: 107,
      avg_revenue_redemption: "730.96",
      stats: getUpdatedDateData("_id", "YYYY-MM-DD", [
        {
          _id: "2022-10-10",
          revenue: 0,
          redemptions: 0,
        },
        {
          _id: "2022-10-11",
          revenue: 10029,
          redemptions: 8,
        },
        {
          _id: "2022-10-12",
          revenue: 10543,
          redemptions: 10,
        },
        {
          _id: "2022-10-13",
          revenue: 877,
          redemptions: 2,
        },
        {
          _id: "2022-10-14",
          revenue: 917,
          redemptions: 2,
        },
        {
          _id: "2022-10-15",
          revenue: 2261,
          redemptions: 5,
        },
        {
          _id: "2022-10-16",
          revenue: 2770,
          redemptions: 6,
        },
        {
          _id: "2022-10-17",
          revenue: 3065,
          redemptions: 7,
        },
        {
          _id: "2022-10-18",
          revenue: 7541,
          redemptions: 12,
        },
        {
          _id: "2022-10-19",
          revenue: 4132,
          redemptions: 7,
        },
        {
          _id: "2022-10-20",
          revenue: 4573,
          redemptions: 9,
        },
        {
          _id: "2022-10-21",
          revenue: 6988,
          redemptions: 6,
        },
        {
          _id: "2022-10-22",
          revenue: 9336,
          redemptions: 6,
        },
        {
          _id: "2022-10-23",
          revenue: 447,
          redemptions: 2,
        },
        {
          _id: "2022-10-24",
          revenue: 0,
          redemptions: 0,
        },
        {
          _id: "2022-10-25",
          revenue: 3998,
          redemptions: 3,
        },
        {
          _id: "2022-10-26",
          revenue: 51,
          redemptions: 1,
        },
        {
          _id: "2022-10-27",
          revenue: 0,
          redemptions: 0,
        },
        {
          _id: "2022-10-28",
          revenue: 0,
          redemptions: 0,
        },
        {
          _id: "2022-10-29",
          revenue: 624,
          redemptions: 1,
        },
        {
          _id: "2022-10-30",
          revenue: 277,
          redemptions: 3,
        },
        {
          _id: "2022-10-31",
          revenue: 0,
          redemptions: 0,
        },
        {
          _id: "2022-11-01",
          revenue: 2224,
          redemptions: 2,
        },
        {
          _id: "2022-11-02",
          revenue: 100,
          redemptions: 1,
        },
        {
          _id: "2022-11-03",
          revenue: 292,
          redemptions: 1,
        },
        {
          _id: "2022-11-04",
          revenue: 104,
          redemptions: 1,
        },
        {
          _id: "2022-11-05",
          revenue: 0,
          redemptions: 0,
        },
        {
          _id: "2022-11-06",
          revenue: 2143,
          redemptions: 5,
        },
        {
          _id: "2022-11-07",
          revenue: 4881,
          redemptions: 6,
        },
        {
          _id: "2022-11-08",
          revenue: 40,
          redemptions: 1,
        },
      ]),
    },
    loyaltyData: {
      banner_position: {
        scale: 1.22,
        position_x: 50.8,
        position_y: -41.2,
      },
      colors: {
        text: "#FFFFFF",
        theme: "#272745",
      },
      settings: {
        profile_reward: {
          status: true,
          points: 100,
        },
        points_reminder: {
          reward_eligible_customers: false,
          active: true,
          duration: 15,
          period: "days",
        },
        points_expiry: {
          active: true,
          current: 2,
        },
        points_branding: {
          active: false,
          name: "",
        },
        min_requirements: {
          bill_amount: {
            active: false,
            amount: 0,
          },
          visit_interval: {
            active: false,
          },
        },
        redemption_limit: {
          active: false,
          percentage: 50,
        },
      },
      is_active: true,
      is_draft: false,
      terms: ["Minimum purchase required.", "2 offers cannot be clubbed"],
      auto_deactivate: false,
      entity_type: "Store",
      entity_id: "6206418c92a7a876caaedefb",
      type: "amount_spent",
      title: "GAUTAMS O DINE  Rewards",
      logo: "https://reelo-uploads-production.s3.ap-south-1.amazonaws.com/uploads/users/6206410f9be20234ced45c98/1645198771534.png",
      description: "Get rewarded on every purchase",
      amount_spent: 1,
      points_earned: 1,
      banner:
        "https://reelo-uploads-production.s3.ap-south-1.amazonaws.com/uploads/users/6206410f9be20234ced45c98/1645198788936.jpg",
      channels: [
        {
          _id: "620b5e7886adaf1359e37eb6",
          name: "sms",
          status: false,
        },
        {
          _id: "620b5e7886adaf1359e37eb7",
          name: "whatsapp",
          status: true,
          custom_text: "",
          fallback_sms: true,
        },
        {
          _id: "620b5e7886adaf1359e37eb8",
          name: "email",
          status: false,
        },
        {
          _id: "620b5e7886adaf1359e37eb9",
          name: "push",
          status: false,
        },
      ],
      rewards: [
        {
          is_active: true,
          combo: false,
          items: [
            {
              id: "1240958395",
              name: "Truffle Slice Per Piece",
            },
          ],
          inspiration: false,
          name: "Get a free Dessert Truffle slice",
          points_value: 500,
          applies_on: "all",
          redeem_type: "free_item_service",
          _id: "63526839e8aa6b319b60dcd6",
          created_at: "2022-10-21T09:36:57.200Z",
          updated_at: "2022-10-21T09:36:57.200Z",
        },
        {
          is_active: true,
          combo: false,
          items: [
            {
              id: "1243605056",
              name: '6" Pizza @179',
            },
          ],
          inspiration: false,
          name: 'Get a free 6"pizza , because who does not love pizza .',
          points_value: 800,
          applies_on: "all",
          redeem_type: "free_item_service",
          _id: "63526839e8aa6b319b60dcd9",
          created_at: "2022-10-21T09:36:57.371Z",
          updated_at: "2022-10-21T09:36:57.371Z",
        },
        {
          is_active: true,
          combo: false,
          items: [],
          inspiration: false,
          name: "Hurrayyy!100₹ off on entire purchase",
          points_value: 1000,
          applies_on: "all",
          redeem_type: "amount_off",
          amount_off: 100,
          _id: "63526839e8aa6b319b60dcdc",
          created_at: "2022-10-21T09:36:57.555Z",
          updated_at: "2022-10-21T09:36:57.555Z",
        },
        {
          is_active: true,
          combo: false,
          items: [],
          inspiration: false,
          name: "Treat yourself with ₹300 off on entire purchase",
          points_value: 2000,
          applies_on: "all",
          redeem_type: "amount_off",
          amount_off: 300,
          _id: "63526839e8aa6b319b60dcdf",
          created_at: "2022-10-21T09:36:57.712Z",
          updated_at: "2022-10-21T09:36:57.712Z",
        },
        {
          is_active: true,
          combo: false,
          items: [
            {
              id: "1240958436",
              name: "Red Velvet Cake Half Kg.",
            },
          ],
          inspiration: false,
          name: "Get a free RED VELVET CAKE. CELEBRATIONS TIME ",
          points_value: 2500,
          applies_on: "all",
          redeem_type: "free_item_service",
          _id: "63526839e8aa6b319b60dce2",
          created_at: "2022-10-21T09:36:57.885Z",
          updated_at: "2022-10-21T09:36:57.885Z",
        },
        {
          is_active: true,
          combo: false,
          items: [],
          inspiration: false,
          name: "You deserve it! Get ₹500 off on entire purchase",
          points_value: 3000,
          applies_on: "all",
          redeem_type: "amount_off",
          amount_off: 500,
          _id: "63526839e8aa6b319b60dce8",
          created_at: "2022-10-21T09:36:58.030Z",
          updated_at: "2022-10-21T09:36:58.030Z",
        },
        {
          is_active: true,
          combo: false,
          items: [],
          inspiration: false,
          name: "Party time! Get ₹1000 off on entire purchase",
          points_value: 5000,
          applies_on: "all",
          redeem_type: "amount_off",
          amount_off: 1000,
          _id: "6352683ae8aa6b319b60dced",
          created_at: "2022-10-21T09:36:58.342Z",
          updated_at: "2022-10-21T09:36:58.342Z",
        },
      ],
      created_at: "2022-02-15T08:04:09.009Z",
      updated_at: "2022-10-21T09:36:58.345Z",
      id: "620b5e7886adaf1359e37eb5",
    },
  },
  feedback: {
    fbResData: {
      colors: {
        text: "#FFFFFF",
        theme: "#5E74A1",
      },
      bonus: {
        status: true,
        points: 50,
      },
      questions: {
        main: "How was your experience?",
        followup: {
          negative: "Sorry to hear. Tell us what went wrong?",
          neutral: "Sorry to hear. Tell us what went wrong?",
          positive: "Glad to hear that. What did you like?",
        },
      },
      feedback_delay: {
        trigger: "immediately",
      },
      negative_feedback_alert: {
        channels: {
          sms: false,
          whatsapp: true,
        },
        mobile_numbers: ["9577777845"],
        emails: [],
        status: true,
      },
      hear_about_us: {
        sources: [
          {
            name: "Zomato / Swiggy",
            active: true,
          },
          {
            name: "Social Media",
            active: true,
          },
          {
            name: "Friends & Family",
            active: true,
          },
          {
            name: "Walking by",
            active: true,
          },
          {
            name: "Newspaper",
            active: false,
          },
          {
            name: "Website",
            active: true,
          },
        ],
        status: true,
      },
      online_review: {
        min_ratings: [4],
        is_active: true,
        review_links: [
          {
            _id: "634409d29b792feb96c38e5a",
            link: "https://g.page/r/CfEVC4r5VqpHEB0/review",
            shortlink: "YlsOJ",
            source: "Google",
          },
        ],
      },
      is_active: true,
      is_draft: false,
      category_options: [
        {
          name: "Food",
          active: true,
        },
        {
          name: "Service",
          active: true,
        },
        {
          name: "Ambience",
          active: true,
        },
        {
          name: "Cleanliness",
          active: true,
        },
        {
          name: "Value for money",
          active: true,
        },
      ],
      auto_deactivate: false,
      entity_id: "6206418c92a7a876caaedefb",
      entity_type: "Store",
      channels: [
        {
          _id: "634409ab9b792feb96c38abe",
          name: "sms",
          status: false,
        },
        {
          _id: "634409ab9b792feb96c38abf",
          name: "whatsapp",
          status: true,
          fallback_sms: true,
        },
        {
          _id: "634409ab9b792feb96c38ac0",
          name: "email",
          status: false,
        },
        {
          _id: "634409ab9b792feb96c38ac1",
          name: "tablet",
          status: false,
        },
      ],
      created_at: "2022-02-15T08:14:17.061Z",
      logo: "https://reelo-uploads-production.s3.ap-south-1.amazonaws.com/uploads/users/6206410f9be20234ced45c98/1644911388534.png",
      style: "emoji",
      updated_at: "2022-10-10T12:02:26.467Z",
      id: "620b60d992a7a876ca4c7be7",
    },
    recentFeedBacks: {
      docs: [
        {
          category_options: ["Food", "Service", "Cleanliness", "Ambience"],
          hear_about_us: ["Friends & Family"],
          answer: "Amazing ",
          score: 5,
          customer: {
            _id: "621108c59f6599c17453f589",
            name: "Jayesh",
            phone: "8XXXXXXXX9",
          },
          datetime: "Nov 6, 2022 8:06 PM",
          store_name: "GAUTAMS O DINE ",
        },
        {
          category_options: ["Food"],
          hear_about_us: [],
          answer: "Average ",
          score: 2,
          customer: {
            _id: "63679c053890a899ee75d5b0",
            name: "Navi",
            phone: "8XXXXXXXX5",
          },
          datetime: "Nov 6, 2022 5:39 PM",
          store_name: "GAUTAMS O DINE ",
        },
        {
          category_options: ["Food", "Service"],
          hear_about_us: ["Friends & Family"],
          answer: "",
          score: 5,
          customer: {
            _id: "63678f253890a899ee73f404",
            name: "Mahesh",
            phone: "8XXXXXXXX2",
          },
          datetime: "Nov 6, 2022 4:58 PM",
          store_name: "GAUTAMS O DINE ",
        },
        {
          category_options: ["Food"],
          hear_about_us: ["Friends & Family"],
          answer: "",
          score: 3,
          customer: {
            _id: "621cdff0f31b7366ec18460d",
            name: "",
            phone: "9XXXXXXXX8",
          },
          datetime: "Nov 6, 2022 1:59 PM",
          store_name: "GAUTAMS O DINE ",
        },
        {
          category_options: ["Food", "Service", "Cleanliness"],
          hear_about_us: ["Friends & Family"],
          answer: "",
          score: 4,
          customer: {
            _id: "6353e794e8aa6b319b8565a5",
            name: "",
            phone: "7XXXXXXXX9",
          },
          datetime: "Nov 6, 2022 11:45 AM",
          store_name: "GAUTAMS O DINE ",
        },
        {
          category_options: [
            "Food",
            "Service",
            "Cleanliness",
            "Value for money",
            "Ambience",
          ],
          hear_about_us: [],
          answer: "",
          score: 4,
          customer: {
            _id: "621cdfe1f31b7366ec184008",
            name: "Navi",
            phone: "9XXXXXXXX2",
          },
          datetime: "Nov 6, 2022 4:30 AM",
          store_name: "GAUTAMS O DINE ",
        },
        {
          category_options: [
            "Food",
            "Service",
            "Ambience",
            "Cleanliness",
            "Value for money",
          ],
          hear_about_us: ["Walking by"],
          answer: "",
          score: 5,
          customer: {
            _id: "635254ebe8aa6b319b5df2e7",
            name: "",
            phone: "9XXXXXXXX1",
          },
          datetime: "Nov 5, 2022 10:59 AM",
          store_name: "GAUTAMS O DINE ",
        },
        {
          category_options: ["Cleanliness"],
          hear_about_us: [],
          answer: "",
          score: 5,
          customer: {
            _id: "621ce027f31b7366ec185bbb",
            name: "abhinv",
            phone: "7XXXXXXXX7",
          },
          datetime: "Nov 4, 2022 12:09 AM",
          store_name: "GAUTAMS O DINE ",
        },
        {
          category_options: ["Food", "Service"],
          hear_about_us: ["Friends & Family"],
          answer: "",
          score: 4,
          customer: {
            _id: "634a555ef9bb15a9ec32fd16",
            name: "",
            phone: "8XXXXXXXX0",
          },
          datetime: "Nov 1, 2022 2:09 PM",
          store_name: "GAUTAMS O DINE ",
        },
        {
          category_options: [
            "Food",
            "Service",
            "Ambience",
            "Cleanliness",
            "Value for money",
          ],
          hear_about_us: [],
          answer: "",
          score: 5,
          customer: {
            _id: "62d53307e949e8bc77529c15",
            name: "",
            phone: "8XXXXXXXX2",
          },
          datetime: "Oct 27, 2022 3:56 PM",
          store_name: "GAUTAMS O DINE ",
        },
      ],
      totalDocs: 1590,
      limit: 10,
      page: 1,
      totalPages: 159,
      pagingCounter: 1,
      hasPrevPage: false,
      hasNextPage: true,
      prevPage: null,
      nextPage: 2,
    },
    suggestions: {
      docs: [
        {
          category_options: ["Food"],
          hear_about_us: [],
          answer:
            "The tables were set to closely together, the chairs are uncomfortable and the table was dirty. ",
          score: 2,
          customer: {
            _id: "63679c053890a899ee75d5b0",
            name: "Jayesh",
            phone: "8XXXXXXXX5",
          },
          datetime: "Nov 6, 2022 5:39 PM",
          store_name: "GAUTAMS O DINE ",
        },
        {
          category_options: ["Food", "Service"],
          hear_about_us: ["Friends & Family"],
          answer:
            "We had to wait for about 15 minutes before our table was ready even though we had a reservation.",
          score: 1,
          customer: {
            _id: "63678f253890a899ee73f404",
            name: "Navi",
            phone: "8XXXXXXXX2",
          },
          datetime: "Nov 6, 2022 4:58 PM",
          store_name: "GAUTAMS O DINE ",
        },
        {
          category_options: ["Food"],
          hear_about_us: ["Friends & Family"],
          answer: "Food was average. Didn't like the service",
          score: 3,
          customer: {
            _id: "621cdff0f31b7366ec18460d",
            name: "Mahesh",
            phone: "9XXXXXXXX8",
          },
          datetime: "Nov 6, 2022 1:59 PM",
          store_name: "GAUTAMS O DINE ",
        },
      ],
      totalDocs: 1590,
      limit: 10,
      page: 1,
      totalPages: 159,
      pagingCounter: 1,
      hasPrevPage: false,
      hasNextPage: true,
      prevPage: null,
      nextPage: 2,
    },
    compliments: {
      docs: [
        {
          category_options: ["Food", "Service", "Cleanliness", "Ambience"],
          hear_about_us: ["Friends & Family"],
          answer: "Great atmoshpere with all the plants on the wall",
          score: 5,
          customer: {
            _id: "621108c59f6599c17453f589",
            name: "Jayesh",
            phone: "8XXXXXXXX9",
          },
          datetime: "Nov 6, 2022 8:06 PM",
          store_name: "GAUTAMS O DINE ",
        },
        {
          category_options: [
            "Food",
            "Service",
            "Cleanliness",
            "Value for money",
            "Ambience",
          ],
          hear_about_us: [],
          answer: "Super fast and freindly even though it was very busy.",
          score: 4,
          customer: {
            _id: "621cdfe1f31b7366ec184008",
            name: "Navi",
            phone: "9XXXXXXXX2",
          },
          datetime: "Nov 6, 2022 4:30 AM",
          store_name: "GAUTAMS O DINE ",
        },
        {
          category_options: [
            "Food",
            "Service",
            "Ambience",
            "Cleanliness",
            "Value for money",
          ],
          hear_about_us: ["Walking by"],
          answer:
            "For dinner we ordered the shrimp enchiladas, chicken enchiladas, chicken burrito, chimichangas, and steak quesadillas. Everything was so tasty and amazing. I wasnt surprised because the food at the FiDi location is the best so I figured this location would be just as good and it was!!! The enchiladas with the green sauce is to die for. My go to at the FiDi location is usually the chicken enchiladas but I decided to try something new and the shrimp enchiladas did not disappoint.",
          score: 5,
          customer: {
            _id: "635254ebe8aa6b319b5df2e7",
            name: "Mahesh",
            phone: "9XXXXXXXX1",
          },
          datetime: "Nov 5, 2022 10:59 AM",
          store_name: "GAUTAMS O DINE ",
        },
      ],
      totalDocs: 1590,
      limit: 10,
      page: 1,
      totalPages: 159,
      pagingCounter: 1,
      hasPrevPage: false,
      hasNextPage: true,
      prevPage: null,
      nextPage: 2,
    },
    overview: {
      total_feedbacks: 1590,
      avg_rating: 4.511320754716981,
      positive_feedbacks: 1450,
      neutral_feedbacks: 54,
      negative_feedbacks: 86,
      category_rating: [
        {
          _id: "Value for money",
          positive_count: 711,
          neutral_count: 10,
          negative_count: 27,
          avg: 4.688502673796791,
        },
        {
          _id: "Cleanliness",
          positive_count: 823,
          neutral_count: 5,
          negative_count: 10,
          avg: 4.743436754176611,
        },
        {
          _id: "Food",
          positive_count: 1265,
          neutral_count: 24,
          negative_count: 49,
          avg: 4.610612855007473,
        },
        {
          _id: "Service",
          positive_count: 940,
          neutral_count: 23,
          negative_count: 48,
          avg: 4.578635014836795,
        },
        {
          _id: "Ambience",
          positive_count: 678,
          neutral_count: 5,
          negative_count: 11,
          avg: 4.74207492795389,
        },
      ],
      hear_about_us: [
        {
          _id: "Walking by",
          count: 378,
        },
        {
          _id: "Friends & Family",
          count: 447,
        },
        {
          _id: "Zomato / Swiggy",
          count: 48,
        },
        {
          _id: "Website",
          count: 23,
        },
        {
          _id: "Social Media",
          count: 33,
        },
      ],
      rating_breakdown: [
        {
          score: 1,
          count: 51,
        },
        {
          score: 2,
          count: 35,
        },
        {
          score: 3,
          count: 54,
        },
        {
          score: 4,
          count: 360,
        },
        {
          score: 5,
          count: 1090,
        },
      ],
      online_reviews: 252,
    },
    dailyResponses: getUpdatedDateData("_id", "YYYY-MM-DD", [
      {
        _id: "2022-10-10",
        total: 0,
      },
      {
        _id: "2022-10-11",
        total: 0,
      },
      {
        _id: "2022-10-12",
        total: 3,
      },
      {
        _id: "2022-10-13",
        total: 4,
      },
      {
        _id: "2022-10-14",
        total: 4,
      },
      {
        _id: "2022-10-15",
        total: 6,
      },
      {
        _id: "2022-10-16",
        total: 5,
      },
      {
        _id: "2022-10-17",
        total: 2,
      },
      {
        _id: "2022-10-18",
        total: 2,
      },
      {
        _id: "2022-10-19",
        total: 5,
      },
      {
        _id: "2022-10-20",
        total: 0,
      },
      {
        _id: "2022-10-21",
        total: 12,
      },
      {
        _id: "2022-10-22",
        total: 2,
      },
      {
        _id: "2022-10-23",
        total: 7,
      },
      {
        _id: "2022-10-24",
        total: 2,
      },
      {
        _id: "2022-10-25",
        total: 4,
      },
      {
        _id: "2022-10-26",
        total: 9,
      },
      {
        _id: "2022-10-27",
        total: 0,
      },
      {
        _id: "2022-10-28",
        total: 0,
      },
      {
        _id: "2022-10-29",
        total: 0,
      },
      {
        _id: "2022-10-30",
        total: 0,
      },
      {
        _id: "2022-10-31",
        total: 0,
      },
      {
        _id: "2022-11-01",
        total: 1,
      },
      {
        _id: "2022-11-02",
        total: 0,
      },
      {
        _id: "2022-11-03",
        total: 1,
      },
      {
        _id: "2022-11-04",
        total: 0,
      },
      {
        _id: "2022-11-05",
        total: 1,
      },
      {
        _id: "2022-11-06",
        total: 4,
      },
      {
        _id: "2022-11-07",
        total: 0,
      },
      {
        _id: "2022-11-08",
        total: 0,
      },
    ]),
    ratingOverTime: getUpdatedDateData("_id", "YYYY-MM-DD", [
      {
        _id: "2022-10-10",
        avg_rating: 0,
      },
      {
        _id: "2022-10-11",
        avg_rating: 0,
      },
      {
        _id: "2022-10-12",
        avg_rating: 5,
      },
      {
        _id: "2022-10-13",
        avg_rating: 4.25,
      },
      {
        _id: "2022-10-14",
        avg_rating: 4.5,
      },
      {
        _id: "2022-10-15",
        avg_rating: 5,
      },
      {
        _id: "2022-10-16",
        avg_rating: 4.6,
      },
      {
        _id: "2022-10-17",
        avg_rating: 4.5,
      },
      {
        _id: "2022-10-18",
        avg_rating: 5,
      },
      {
        _id: "2022-10-19",
        avg_rating: 3.4,
      },
      {
        _id: "2022-10-20",
        avg_rating: 0,
      },
      {
        _id: "2022-10-21",
        avg_rating: 4.666666666666667,
      },
      {
        _id: "2022-10-22",
        avg_rating: 4.5,
      },
      {
        _id: "2022-10-23",
        avg_rating: 4.428571428571429,
      },
      {
        _id: "2022-10-24",
        avg_rating: 4.5,
      },
      {
        _id: "2022-10-25",
        avg_rating: 4.5,
      },
      {
        _id: "2022-10-26",
        avg_rating: 4.555555555555555,
      },
      {
        _id: "2022-10-27",
        avg_rating: 0,
      },
      {
        _id: "2022-10-28",
        avg_rating: 0,
      },
      {
        _id: "2022-10-29",
        avg_rating: 0,
      },
      {
        _id: "2022-10-30",
        avg_rating: 0,
      },
      {
        _id: "2022-10-31",
        avg_rating: 0,
      },
      {
        _id: "2022-11-01",
        avg_rating: 4,
      },
      {
        _id: "2022-11-02",
        avg_rating: 0,
      },
      {
        _id: "2022-11-03",
        avg_rating: 5,
      },
      {
        _id: "2022-11-04",
        avg_rating: 0,
      },
      {
        _id: "2022-11-05",
        avg_rating: 4,
      },
      {
        _id: "2022-11-06",
        avg_rating: 3.75,
      },
      {
        _id: "2022-11-07",
        avg_rating: 0,
      },
      {
        _id: "2022-11-08",
        avg_rating: 0,
      },
    ]),
  },
  autoCampaigns: {
    campList: {
      docs: [
        {
          _id: "62efffe2e962873e378aaad7",
          whatsapp: {
            fields: [],
          },
          reward: {
            type: "percentage_off",
            discount_off: 20,
            applies_on: "purchase",
          },
          status: "published",
          channels: [
            {
              name: "sms",
              status: true,
              credits: 1,
            },
            {
              name: "email",
              status: true,
              credits: 1,
            },
          ],
          repeat: null,
          auto_deactivate: false,
          entity_type: "Store",
          entity_id: "6206418c92a7a876caaedefb",
          type: "template",
          user_id: "6206410f9be20234ced45c98",
          template_id: "A00006",
          auto_campaign: true,
          created_at: "2022-08-07T18:09:38.991Z",
          updated_at: "2022-08-07T18:12:25.598Z",
          __v: 0,
          banner:
            "https://reelo-assets.s3.ap-south-1.amazonaws.com/static/campaigns/templates/banners/zhq08Indian-food.jpg",
          banner_position: {
            scale: 1,
            position_x: 0,
            position_y: 0,
          },
          colors: {
            theme: "#482315",
            text: "#FFFFFF",
          },
          logo: "uploads/users/6206410f9be20234ced45c98/1659895785371.png",
          auto_campaign_settings: {
            sent_at: {
              period: "days",
              duration: 7,
              when: "before",
            },
            expires_at: {
              period: "days",
              duration: 7,
            },
            run_at: "10:00am",
          },
          email_content:
            "uploads/users/6206410f9be20234ced45c98/62efffe2e962873e378aaad7.png",
          email_subject: "Happy Birthday! Enjoy 20% OFF!",
          subtitle:
            "Celebrate your special day at The Radhika Restaurant with delicious food, great company and an exclusive 20% OFF!\n\nShow this to claim your voucher. We look forward to seeing you soon. \n\nHave a great day!",
          title:
            "It's your Birthday! Enjoy 20% OFF from GAUTAMS O DINE on order above 1999! ",
          contact_number: "9XXXXXXXX4",
          redemption_per_customer: "single",
          terms:
            "2 offers cannot be clubbed.\n Reward cannot be exchanged for cash.\nMin purchase required rs 1999.",
          sms: {
            details: {
              store_name: "GAUTAMS O DINE ",
              details_0: "BIRTHDAY OFFER",
              details_1: "your favourites",
              details_2: "We're celebrating your big day",
              reward_value: 20,
            },
            short_link: {
              type: "default",
              is_file: false,
              url: "l.reelo.io/HTOFo",
            },
            content:
              "BIRTHDAY OFFER - Get 20% OFF on your favourites at GAUTAMS O DINE ! We're celebrating your big day! Expires 07 Aug'22. Click l.reelo.io/HTOFo via Reelo",
          },
          repeat_ends: null,
          repeat_interval: null,
          timezone: "Asia/Kolkata",
          attribute_visits: 3,
          attribute_revenue: 1380,
          delivered: 75,
          objective: {
            key: "customer_birthday",
            value: "Birthday",
          },
        },
        {
          _id: "62eea9c7e962873e3789c296",
          whatsapp: {
            fields: [],
          },
          reward: {
            type: "percentage_off",
            discount_off: 20,
            applies_on: "purchase",
          },
          status: "published",
          channels: [
            {
              name: "sms",
              status: true,
              credits: 1,
            },
            {
              name: "email",
              status: true,
              credits: 1,
            },
          ],
          repeat: null,
          auto_deactivate: false,
          entity_type: "Store",
          entity_id: "6206418c92a7a876caaedefb",
          type: "template",
          user_id: "6206410f9be20234ced45c98",
          template_id: "A00009",
          auto_campaign: true,
          created_at: "2022-08-06T17:49:59.005Z",
          updated_at: "2022-08-06T17:56:37.034Z",
          __v: 0,
          banner:
            "https://reelo-assets.s3.ap-south-1.amazonaws.com/static/loyalty/food_beverage/fine_dine_restaurant/Fine+dining+1+default.jpg",
          banner_position: {
            scale: 1,
            position_x: 0,
            position_y: 0,
          },
          colors: {
            theme: "#006A35",
            text: "#FFFFFF",
          },
          logo: "https://reelo-uploads-production.s3.ap-south-1.amazonaws.com/uploads/users/6206410f9be20234ced45c98/1659808215063.png",
          auto_campaign_settings: {
            sent_at: {
              period: "weeks",
              duration: 2,
              when: "before",
            },
            expires_at: {
              period: "days",
              duration: 14,
            },
            run_at: "10:00am",
          },
          email_content:
            "uploads/users/6206410f9be20234ced45c98/62eea9c7e962873e3789c296.png",
          email_subject: "Happy Anniversary! Enjoy 15% OFF on your date!",
          subtitle:
            "Hooray! Your Anniversary has arrived. To make this extra special, we have sent a treat for you - 15% OFF on your romantic meal. Claim it before it expires. Above rs 1499",
          title: "15% OFF at GAUTAMS O DINE  to celebrate your anniversary!",
          contact_number: "9XXXXXXXX4",
          redemption_per_customer: "single",
          terms:
            "2 offers cannot be clubbed.\n Reward cannot be exchanged for cash.\nMin purchase required rs1499",
          sms: {
            details: {
              store_name: "GAUTAMS O DINE ",
              details_0: "Happy Anniversary",
              details_1: "Make this date extra special",
              details_2: "treat yourself",
              reward_value: 15,
              contact: "9XXXXXXXX4",
            },
            short_link: {
              type: "default",
              is_file: false,
              url: "l.reelo.io/0lzBo",
            },
            content:
              "Happy Anniversary from GAUTAMS O DINE ! Make this date extra special & treat yourself to 15% OFF! #9728405424 Click l.reelo.io/0lzBo via Reelo",
          },
          repeat_ends: null,
          repeat_interval: null,
          timezone: "Asia/Kolkata",
          attribute_visits: 4,
          attribute_revenue: 2116,
          delivered: 78,
          objective: {
            key: "customer_anniversary",
            value: "Anniversary",
          },
        },
        {
          _id: "621b5d81bd5e281e79cf36b4",
          reward: {
            type: "free_item",
            items: [
              {
                id: "1237676024",
                name: "Veg Hakka Noodles",
              },
            ],
            applies_on: "purchase",
          },
          status: "published",
          channels: [
            {
              name: "sms",
              status: true,
              credits: 1,
            },
            {
              name: "email",
              status: true,
              credits: 1,
            },
          ],
          repeat: null,
          auto_deactivate: true,
          entity_type: "Store",
          entity_id: "6206418c92a7a876caaedefb",
          type: "template",
          user_id: "6206410f9be20234ced45c98",
          template_id: "A00337",
          auto_campaign: true,
          created_at: "2022-02-27T11:16:17.251Z",
          updated_at: "2022-09-16T18:40:29.277Z",
          __v: 0,
          banner:
            "https://reelo-assets.s3.ap-south-1.amazonaws.com/static/campaigns/templates/banners/ftMZ_farhad-ibrahimzade-Sk6my6_KTK0-unsplash.jpg",
          banner_position: {
            scale: 1,
            position_x: 0,
            position_y: 0,
          },
          colors: {
            theme: "#0E2956",
            text: "#FFFFFF",
          },
          logo: "https://reelo-uploads-production.s3.ap-south-1.amazonaws.com/uploads/users/6206410f9be20234ced45c98/1645198771534.png",
          auto_campaign_settings: {
            sent_at: {
              period: "days",
              duration: 7,
              when: "after",
            },
            expires_at: {
              period: "days",
              duration: 6,
            },
            run_at: "04:00pm",
          },
          email_content:
            "uploads/users/6206410f9be20234ced45c98/621b5d81bd5e281e79cf36b4.png",
          email_subject:
            "Come for a free Starter. Stay for more. GAUTAMS O DINE  misses you!",
          subtitle:
            "We would love to see you again! Come try new dishes at GAUTAMS O DINE  & enjoy a free Starter on the house! ",
          title: "Missing the good ol’ days? Let's bond over a Free Starter!",
          contact_number: "9XXXXXXXX4",
          redemption_per_customer: "single",
          terms:
            "2 offers cannot be clubbed.\n Reward cannot be exchanged for cash.\nMin purchase required 699",
          sms: {
            details: {
              store_name: "GAUTAMS O DINE ",
              details_0: "How about",
              details_1: "It's our little way of saying",
              details_2: "See you",
              reward_value: "Veg Hakka Noodles",
              discount_on: "Veg Hakka Noodles",
            },
            short_link: {
              type: "default",
              is_file: false,
              url: "l.reelo.io/8bb67",
            },
            content:
              "How about a FREE Veg Hakka Noodles on your bill at GAUTAMS O DINE ? It's our little way of saying, 'we missed you'. See you! Click l.reelo.io/8bb67   via Reelo",
          },
          repeat_ends: null,
          repeat_interval: null,
          timezone: "Asia/Kolkata",
          attribute_visits: 212,
          attribute_revenue: 126259,
          delivered: 4390,
          objective: {
            key: "customer_bring_back",
            value: "Bring Back",
          },
        },
        {
          _id: "621b5b10bd5e281e79cf35df",
          reward: {
            type: "percentage_off",
            discount_off: 25,
            applies_on: "purchase",
          },
          status: "published",
          channels: [
            {
              name: "sms",
              status: true,
              credits: 1,
            },
            {
              name: "email",
              status: true,
              credits: 1,
            },
          ],
          repeat: null,
          auto_deactivate: true,
          entity_type: "Store",
          entity_id: "6206418c92a7a876caaedefb",
          type: "template",
          user_id: "6206410f9be20234ced45c98",
          template_id: "A00302",
          auto_campaign: true,
          created_at: "2022-02-27T11:05:52.623Z",
          updated_at: "2022-09-16T18:40:29.251Z",
          __v: 0,
          banner:
            "https://reelo-assets.s3.ap-south-1.amazonaws.com/static/campaigns/templates/banners/lnyPHprosha-amiri-LpnfAOXoGGE-unsplash.jpg",
          banner_position: {
            scale: 1,
            position_x: -3,
            position_y: -164,
          },
          colors: {
            theme: "#580000",
            text: "#FFFFFF",
          },
          logo: "https://reelo-uploads-production.s3.ap-south-1.amazonaws.com/uploads/users/6206410f9be20234ced45c98/1645198771534.png",
          auto_campaign_settings: {
            sent_at: {
              period: "days",
              duration: 3,
              when: "before",
            },
            expires_at: {
              period: "days",
              duration: 7,
            },
            run_at: "04:00pm",
          },
          email_content:
            "uploads/users/6206410f9be20234ced45c98/621b5b10bd5e281e79cf35df.png",
          email_subject: "25% OFF Birthday Special at GAUTAMS O DINE ",
          subtitle:
            "GAUTAMS O DINE  wishes you a Happy Birthday! Celebrate with us & get Flat 25% OFF upto Rs.399 from us!  We have a surprise for you!",
          title: "Birthday special: 25% Off from GAUTAMS O DINE !",
          contact_number: "9XXXXXXXX4",
          redemption_per_customer: "single",
          terms:
            "2 offers cannot be clubbed.\n Reward cannot be exchanged for cash.\nMin purchase required Rs2299.",
          sms: {
            details: {
              store_name: "GAUTAMS O DINE ",
              details_0: "a Happy Birthday",
              details_1: "Celebrate with us",
              details_2: "upto Rs.399.",
              reward_value: 25,
              contact: "9XXXXXXXX4",
            },
            short_link: {
              type: "default",
              is_file: false,
              url: "l.reelo.io/0HAOh",
            },
            content:
              "GAUTAMS O DINE  wishes you a Happy Birthday! Celebrate with us & get Flat 25% OFF upto Rs.399.! #9728405424 Expires 27 Feb'22. Click l.reelo.io/0HAOh  via Reelo",
          },
          repeat_ends: null,
          repeat_interval: null,
          timezone: "Asia/Kolkata",
          attribute_visits: 16,
          attribute_revenue: 21271,
          delivered: 117,
          objective: {
            key: "customer_birthday",
            value: "Birthday",
          },
        },
        {
          _id: "621b544fbd5e281e79cf32b3",
          reward: {
            type: "amount_off",
            amount_off: 299,
            applies_on: "purchase",
          },
          status: "published",
          channels: [
            {
              name: "sms",
              status: true,
              credits: 1,
            },
            {
              name: "email",
              status: true,
              credits: 1,
            },
          ],
          repeat: null,
          auto_deactivate: true,
          entity_type: "Store",
          entity_id: "6206418c92a7a876caaedefb",
          type: "template",
          user_id: "6206410f9be20234ced45c98",
          template_id: "A00342",
          auto_campaign: true,
          created_at: "2022-02-27T10:37:03.533Z",
          updated_at: "2022-09-16T18:40:29.233Z",
          __v: 0,
          banner:
            "https://reelo-assets.s3.ap-south-1.amazonaws.com/static/campaigns/templates/banners/3TK-Falice-pasqual-cOKmuKWSsiM-unsplash.jpg",
          banner_position: {
            scale: 1,
            position_x: 0,
            position_y: 0,
          },
          colors: {
            theme: "#1E3E71",
            text: "#FFFFFF",
          },
          logo: "https://reelo-uploads-production.s3.ap-south-1.amazonaws.com/uploads/users/6206410f9be20234ced45c98/1645198771534.png",
          auto_campaign_settings: {
            sent_at: {
              period: "weeks",
              duration: 2,
              when: "after",
            },
            expires_at: {
              period: "days",
              duration: 5,
            },
            run_at: "11:00am",
          },
          email_content:
            "uploads/users/6206410f9be20234ced45c98/621b544fbd5e281e79cf32b3.png",
          email_subject:
            "Where'd you go? Here's a special Rs.299 off for you at GAUTAMS O DINE ",
          subtitle:
            "Hello, where'd you go? Let's end this game of Hide & Seek! Come back to GAUTAMS O DINE  & enjoy your favourite food! ",
          title: "And the winner is you! Save Rs.299 on your bill",
          contact_number: "9XXXXXXXX9",
          redemption_per_customer: "single",
          terms:
            "2 offers cannot be clubbed.\n Reward cannot be exchanged for cash.\nMin purchase required Rs 1599",
          sms: {
            details: {
              store_name: "GAUTAMS O DINE ",
              details_0: "end this game of hide & seek",
              details_1: "We've a special offer just",
              reward_value: 299,
              discount_on: "bill",
            },
            short_link: {
              type: "default",
              is_file: false,
              url: "l.reelo.io/hq9TI",
            },
            content:
              "Let's end this game of hide & seek! We've a special offer just for you. Visit GAUTAMS O DINE  & save Rs.299 on your bill. Click l.reelo.io/hq9TI via Reelo",
          },
          repeat_ends: null,
          repeat_interval: null,
          timezone: "Asia/Kolkata",
          attribute_visits: 143,
          attribute_revenue: 77313,
          delivered: 2976,
          objective: {
            key: "customer_win_back",
            value: "Win Back",
          },
        },
        {
          _id: "621a4c6abd5e281e79cf0e0b",
          reward: {
            type: "free_item",
            items: [
              {
                id: "1237675803",
                name: "Red Velvet (muffins)",
              },
            ],
            applies_on: "purchase",
          },
          status: "published",
          channels: [
            {
              name: "sms",
              status: true,
              credits: 1,
            },
            {
              name: "email",
              status: true,
              credits: 1,
            },
          ],
          repeat: null,
          auto_deactivate: true,
          entity_type: "Store",
          entity_id: "6206418c92a7a876caaedefb",
          type: "template",
          user_id: "6206410f9be20234ced45c98",
          template_id: "A00327",
          auto_campaign: true,
          created_at: "2022-02-26T15:51:06.446Z",
          updated_at: "2022-06-05T13:10:48.942Z",
          __v: 0,
          banner:
            "https://reelo-assets.s3.ap-south-1.amazonaws.com/static/campaigns/templates/banners/aKQNtdaniel-oberg-3sl9_ubYIno-unsplash.jpg",
          banner_position: {
            scale: 1,
            position_x: 0,
            position_y: 0,
          },
          colors: {
            theme: "#BD0D2B",
            text: "#FFFFFF",
          },
          logo: "https://reelo-uploads-production.s3.ap-south-1.amazonaws.com/uploads/users/6206410f9be20234ced45c98/1645198771534.png",
          auto_campaign_settings: {
            sent_at: {
              period: "days",
              duration: 7,
              when: "after",
            },
            expires_at: {
              period: "days",
              duration: 5,
            },
            run_at: "10:00am",
          },
          email_content:
            "uploads/users/6206410f9be20234ced45c98/621a4c6abd5e281e79cf0e0b.png",
          email_subject:
            "Get a FREE Dessert at GAUTAMS O DINE  to kickstart our friendship! ",
          subtitle:
            "Thank you for being a member of GAUTAMS O DINE . You'll now be one of the firsts to know about our latest updates, offers, specials & more. \n\nTo celebrate this new friendship, here's a small treat from us on your next order!\n\nYou can order online\nonlineorderlink.com",
          title: "Enjoy FREE Dessert From GAUTAMS O DINE ",
          contact_number: "9XXXXXXXX4",
          redemption_per_customer: "single",
          terms:
            "2 offers cannot be clubbed.\n Reward cannot be exchanged for cash.",
          sms: {
            details: {
              store_name: "GAUTAMS O DINE ",
              details_0: "thank you for being a member",
              details_1: "here's our treat",
              reward_value: "Red Velvet (muffin)",
            },
            short_link: {
              type: "default",
              is_file: false,
              url: "l.reelo.io/HCqNU",
            },
            content:
              "GAUTAMS O DINE : Your free Red Velvet (muffin) has arrived! As a thank you for being a member, here's our treat. See you! Click l.reelo.io/HCqNU   via Reelo",
          },
          repeat_ends: null,
          repeat_interval: null,
          timezone: "Asia/Kolkata",
          attribute_visits: 56,
          attribute_revenue: 29087,
          delivered: 3613,
          objective: {
            key: "customer_first_time_purchase",
            value: "New Customer",
          },
        },
      ],
      totalDocs: 7,
      limit: 10,
      page: 1,
      totalPages: 1,
      pagingCounter: 1,
      hasPrevPage: false,
      hasNextPage: false,
      prevPage: null,
      nextPage: null,
    },
    overview: {
      campaignRevenue: 7015,
      attributeRevenue: 320168,
      redemptionsCount: 12,
      campaignVisits: 6,
      attributeVisits: 524,
      campaign_count: 7,
      campaignsRedemptions: 0,
      attributeRedemption: 7800,
      attributeVisitsStats: getUpdatedDateData("date", "YYYY-MM-DD", [
        {
          date: "2022-10-10",
          sales: 1,
        },
        {
          date: "2022-10-11",
          sales: 3,
        },
        {
          date: "2022-10-12",
          sales: 18,
        },
        {
          date: "2022-10-13",
          sales: 51,
        },
        {
          date: "2022-10-14",
          sales: 5,
        },
        {
          date: "2022-10-15",
          sales: 2,
        },
        {
          date: "2022-10-16",
          sales: 6,
        },
        {
          date: "2022-10-17",
          sales: 8,
        },
        {
          date: "2022-10-18",
          sales: 10,
        },
        {
          date: "2022-10-19",
          sales: 4,
        },
        {
          date: "2022-10-20",
          sales: 26,
        },
        {
          date: "2022-10-21",
          sales: 6,
        },
        {
          date: "2022-10-22",
          sales: 6,
        },
        {
          date: "2022-10-23",
          sales: 3,
        },
        {
          date: "2022-10-24",
          sales: 0,
        },
        {
          date: "2022-10-25",
          sales: 19,
        },
        {
          date: "2022-10-26",
          sales: 22,
        },
        {
          date: "2022-10-27",
          sales: 19,
        },
        {
          date: "2022-10-28",
          sales: 7,
        },
        {
          date: "2022-10-29",
          sales: 17,
        },
        {
          date: "2022-10-30",
          sales: 16,
        },
        {
          date: "2022-10-31",
          sales: 1,
        },
        {
          date: "2022-11-01",
          sales: 5,
        },
        {
          date: "2022-11-02",
          sales: 6,
        },
        {
          date: "2022-11-03",
          sales: 3,
        },
        {
          date: "2022-11-04",
          sales: 7,
        },
        {
          date: "2022-11-05",
          sales: 7,
        },
        {
          date: "2022-11-06",
          sales: 1,
        },
        {
          date: "2022-11-07",
          sales: 5,
        },
        {
          date: "2022-11-08",
          sales: 3,
        },
      ]),
      attributeRevenueStats: getUpdatedDateData("date", "YYYY-MM-DD", [
        {
          date: "2022-10-10",
          sales: 0,
        },
        {
          date: "2022-10-11",
          sales: 0,
        },
        {
          date: "2022-10-12",
          sales: 0,
        },
        {
          date: "2022-10-13",
          sales: 0,
        },
        {
          date: "2022-10-14",
          sales: 0,
        },
        {
          date: "2022-10-15",
          sales: 0,
        },
        {
          date: "2022-10-16",
          sales: 0,
        },
        {
          date: "2022-10-17",
          sales: 0,
        },
        {
          date: "2022-10-18",
          sales: 0,
        },
        {
          date: "2022-10-19",
          sales: 0,
        },
        {
          date: "2022-10-20",
          sales: 0,
        },
        {
          date: "2022-10-21",
          sales: 0,
        },
        {
          date: "2022-10-22",
          sales: 0,
        },
        {
          date: "2022-10-23",
          sales: 0,
        },
        {
          date: "2022-10-24",
          sales: 0,
        },
        {
          date: "2022-10-25",
          sales: 0,
        },
        {
          date: "2022-10-26",
          sales: 0,
        },
        {
          date: "2022-10-27",
          sales: 0,
        },
        {
          date: "2022-10-28",
          sales: 0,
        },
        {
          date: "2022-10-29",
          sales: 0,
        },
        {
          date: "2022-10-30",
          sales: 0,
        },
        {
          date: "2022-10-31",
          sales: 0,
        },
        {
          date: "2022-11-01",
          sales: 0,
        },
        {
          date: "2022-11-02",
          sales: 0,
        },
        {
          date: "2022-11-03",
          sales: 0,
        },
        {
          date: "2022-11-04",
          sales: 0,
        },
        {
          date: "2022-11-05",
          sales: 0,
        },
        {
          date: "2022-11-06",
          sales: 0,
        },
        {
          date: "2022-11-07",
          sales: 0,
        },
        {
          date: "2022-11-08",
          sales: 0,
        },
      ]),
      avg_revenue_redemption: "26680.7",
      campaign_delivered: 14596,
      avg_visit_rate: "3.6",
    },
  },
  QrCode: {
    summary: {
      summary: [
        {
          _id: null,
          customers_captured: 30,
          approx_revenue: 21212,
          visits: 26,
          visit_rate: 37.5,
        },
      ],
      total_active_qr_codes: 7,
      qr_code_new_vs_existing: {
        new_customers_captured: 23,
        existing_customers_captured: 7,
        new_customers_revenue: 14212,
        existing_customers_revenue: 7000,
        new_customers_visits: 20,
        existing_customers_visits: 6,
      },
    },
    list: {
      docs: [
        {
          _id: "6319fd9ba067dfe6707d9fcf",
          status: "draft",
          entity_type: "Group",
          name: "Jaipur Group QR",
          created_at: "2022-09-08T14:35:07.817Z",
          updated_at: "2022-11-03T12:26:41.213Z",
          scan_type: "reward",
          audience: "all",
          reward: {
            redemption: {
              applicable_stores: [
                "61fb87d844f3cd1aa5209e94",
                "621638c6a2fad84afadb0628",
                "6219b9f0b32b000e3c81f404",
                "6219c022b32b000e3c81f41a",
                "62a719adfb1fc8379f6a08d3",
              ],
              redemption_per_customer: "single",
            },
            items: [],
            type: "amount_off",
            applies_on: "all",
            amount_off: 20,
            _id: "6319fda5a067dfe6707d9fe5",
            updated_at: "2022-11-03T12:24:35.285Z",
            created_at: "2022-11-03T12:23:06.368Z",
            expires_in: {
              period: "days",
              duration: 15,
            },
            reminder: {
              period: "days",
              duration: 3,
              channels: [
                {
                  name: "sms",
                  status: true,
                },
                {
                  name: "whatsapp",
                  status: true,
                },
              ],
            },
          },
          type: 0,
          customers_captured: 0,
          revenue: 0,
          visits: 0,
          qr_code_short_link: "ld.reelo.io/6yHDW",
        },
        {
          _id: "630de338e1153bafa016b468",
          status: "active",
          entity_type: "Store",
          name: "Hyderabad Store Loyalty Based QR",
          created_at: "2022-08-30T10:15:20.082Z",
          updated_at: "2022-11-03T12:27:54.396Z",
          scan_type: "reward",
          audience: "all",
          reward: {
            redemption: {
              applicable_stores: [],
            },
            reminder: {
              channels: [],
            },
            items: [],
            type: "loyalty",
            applies_on: "all",
            loyalty_bonus: 200,
            _id: "630de37ae1153bafa016b48f",
            updated_at: "2022-11-03T12:27:42.923Z",
            created_at: "2022-11-03T12:27:42.923Z",
          },
          type: 1,
          customers_captured: 5,
          revenue: 1230,
          visits: 4,
          qr_code_short_link: "ld.reelo.io/g5aZm",
        },
        {
          _id: "6308b44667eba25ecaad8937",
          status: "active",
          entity_type: "Store",
          name: "QR with loyalty",
          created_at: "2022-08-26T11:53:42.432Z",
          updated_at: "2022-08-26T11:54:38.342Z",
          audience: "all",
          reward: {
            redemption: {
              applicable_stores: [],
              redemption_per_customer: "single",
            },
            items: [],
            type: "amount_off",
            applies_on: "all",
            amount_off: 50,
            _id: "6308b45867eba25ecaad894a",
            updated_at: "2022-08-26T11:54:03.875Z",
            created_at: "2022-08-26T11:54:00.851Z",
            expires_in: {
              period: "weeks",
              duration: 10,
            },
            reminder: {
              period: "days",
              duration: 8,
              channels: [
                {
                  name: "sms",
                  status: true,
                },
                {
                  name: "whatsapp",
                  status: true,
                },
              ],
            },
          },
          scan_type: "reward",
          type: 1,
          customers_captured: 1,
          revenue: 200,
          visits: 1,
          qr_code_short_link: "ld.reelo.io/bZWhC",
        },
        {
          _id: "630383a93e6c032077675b26",
          status: "active",
          entity_type: "Store",
          name: "Test AR 13",
          created_at: "2022-08-22T13:24:57.005Z",
          updated_at: "2022-11-03T12:28:25.013Z",
          scan_type: "reward",
          audience: "new",
          reward: {
            redemption: {
              applicable_stores: [],
              redemption_per_customer: "single",
            },
            items: [
              {
                name: "free",
              },
            ],
            type: "free_item_service",
            applies_on: "all",
            _id: "630383b93e6c032077675b3b",
            updated_at: "2022-11-03T12:28:13.865Z",
            created_at: "2022-11-03T12:28:13.014Z",
            expires_in: {
              period: "weeks",
              duration: 2,
            },
            reminder: {
              period: "weeks",
              duration: 1,
              channels: [
                {
                  name: "sms",
                  status: true,
                },
                {
                  name: "whatsapp",
                  status: true,
                },
              ],
            },
          },
          type: 1,
          customers_captured: 10,
          revenue: 7403,
          visits: 8,
          qr_code_short_link: "ld.reelo.io/XIqqF",
        },
        {
          _id: "63033922f585f513f99a40f0",
          status: "active",
          entity_type: "Group",
          name: "Test QR 101",
          created_at: "2022-08-22T08:06:58.362Z",
          updated_at: "2022-08-30T09:34:25.658Z",
          scan_type: "reward",
          audience: "all",
          reward: {
            redemption: {
              applicable_stores: [
                "61fb87d844f3cd1aa5209e94",
                "621638c6a2fad84afadb0628",
                "6219b9f0b32b000e3c81f404",
                "6219c022b32b000e3c81f41a",
              ],
              redemption_per_customer: "single",
            },
            items: [],
            type: "percentage_off",
            applies_on: "all",
            percentage_off: 50,
            _id: "630339c9f585f513f99a4128",
            updated_at: "2022-08-30T09:34:04.216Z",
            created_at: "2022-08-30T09:34:01.529Z",
            expires_in: {
              period: "months",
              duration: 2,
            },
            reminder: {
              period: "days",
              duration: 2,
              channels: [
                {
                  name: "sms",
                  status: true,
                },
                {
                  name: "whatsapp",
                  status: true,
                },
              ],
            },
          },
          type: 1,
          customers_captured: 4,
          revenue: 2000,
          visits: 1,
          qr_code_short_link: "ld.reelo.io/xfYAD",
        },
      ],
      totalDocs: 14,
      limit: 5,
      page: 1,
      totalPages: 3,
      pagingCounter: 1,
      hasPrevPage: false,
      hasNextPage: true,
      prevPage: null,
      nextPage: 2,
    },
    storePerf: {
      docs: [
        {
          redemptions: 27,
          revenue: 21212,
          name: "Jaipur",
        },
      ],
      totalDocs: 1,
      limit: 5,
      page: 1,
      totalPages: 1,
      pagingCounter: 1,
      hasPrevPage: false,
      hasNextPage: false,
      prevPage: null,
      nextPage: null,
    },
  },
  audienceRecs: {
    dashboardSegments: [
      {
        "entity_id": "saaaaaa90af2631f2409",
        "entity_type": "Group",
        "objective": "At risk VIP customers",
        "action": "Bring Them Back",
        "cluster_metrics": {
          "body": {
            "store_ids": [
              "asdsadb3587a1eaa07893320",
              "asd43e699066f5f228f2b",
              "asdf261f587a1eaa07894167"
            ],
            "average_order_value": {
              "min": 697.5687143326433,
              "max": 3276
            },
            "average_tbo_in_days": {
              "min": -2.002469963254672,
              "max": 0.1917821914156225
            },
            "blocked_customers": false
          },
          "query": {
            "last_visited_filter": true,
            "start": "2024-02-11T00:00:00+05:30",
            "end": "2024-11-11T23:59:59+05:30"
          }
        },
        "created_at": "2025-02-07T18:46:08.354Z",
        "emoji": "⚠️",
        "filters": {
          "average_spend": "High",
          "frequency": "High",
          "not_visited_in": "Last 90 days"
        },
        "name": "<span>8338 VIP customers haven’t visited in 90+ days.</span> Don’t let your best spenders slip away.",
        "segment_customers": 8338,
        "tagline": "Customers visiting more frequently than the 0 days average, spending over ₹698 AOV, but inactive for the last 90 days.",
        "updated_at": "2025-02-21T16:02:33.694Z",
        "expires_at": "2025-03-23T18:29:59.000Z",
        "id": "asdasd6717cb020d1db020"
      },
      {
        "entity_id": "saaaaaa90af2631f2409",
        "entity_type": "Group",
        "objective": "Frequent low spenders",
        "action": "Increase AOV",
        "cluster_metrics": {
          "body": {
            "store_ids": [
              "asdasd3e699066f5f228f2b",
              "asdsad1f587a1eaa07894167",
              "asdsadb3587a1eaa07893320"
            ],
            "average_order_value": {
              "min": 0,
              "max": 696.7417891178293
            },
            "average_tbo_in_days": {
              "min": 7.450659460218688,
              "max": 33.17860772357724
            },
            "blocked_customers": false
          },
          "query": {
            "last_visited_filter": true,
            "start": "2024-02-28T00:00:00+05:30",
            "end": "2025-02-28T23:59:59+05:30"
          }
        },
        "created_at": "2025-02-15T08:50:52.930Z",
        "emoji": "🔁",
        "filters": {
          "frequency": "High",
          "average_spend": "Low"
        },
        "name": "Encourage <span>604</span> frequent customers with <span>low spending to increase purchase value</span> & boost revenue.",
        "segment_customers": 604,
        "tagline": "Customers visiting more frequently than the average of 33 days, spending under ₹697",
        "updated_at": "2025-02-16T12:58:00.619Z",
        "expires_at": "2025-03-18T18:29:59.000Z",
        "id": "asdsadcb623b20a0166e154"
      },
      {
        "entity_id": "saaaaaa90af2631f2409",
        "entity_type": "Group",
        "objective": "Infrequent high spenders",
        "action": "Encourage Faster Repeat",
        "cluster_metrics": {
          "body": {
            "store_ids": [
              "asdasd6f5f228f2b63073843",
              "asdasdaa07894167631f261f",
              "asdsaadaa07893320631f25b3"
            ],
            "average_order_value": {
              "min": 696.7417891178293,
              "max": 21500
            },
            "total_visits": {
              "min": 1,
              "max": 1
            },
            "blocked_customers": false
          },
          "query": {
            "last_visited_filter": true,
            "start": "2024-02-28T00:00:00+05:30",
            "end": "2025-01-28T23:59:59+05:30"
          }
        },
        "created_at": "2025-02-06T14:11:26.484Z",
        "emoji": "💸",
        "filters": {
          "frequency": "Low",
          "average_spend": "High"
        },
        "name": "<span>877</span> high spenders take longer to return than usual. Act now to re-engage them and <span>drive more revenue!</span>",
        "segment_customers": 6222,
        "tagline": "Customers with an AOV over ₹200 who take longer than 26 days to return.",
        "updated_at": "2025-02-06T14:53:42.771Z",
        "expires_at": "2025-03-08T18:29:59.000Z",
        "id": "asdasd0d962b9467a4c30e"
      },
      {
        "entity_id": "saaaaaa90af2631f2409",
        "entity_type": "Group",
        "objective": "High-spending first-timers who didn't return",
        "action": "Make them repeat",
        "cluster_metrics": {
          "body": {
            "store_ids": [
              "asdasd6f5f228f2b63073843",
              "asdasdaa07894167631f261f",
              "asdsaadaa07893320631f25b3"
            ],
            "average_order_value": {
              "min": 696.7417891178293,
              "max": 21500
            },
            "total_visits": {
              "min": 1,
              "max": 1
            },
            "blocked_customers": false
          },
          "query": {
            "last_visited_filter": true,
            "start": "2024-02-28T00:00:00+05:30",
            "end": "2025-01-28T23:59:59+05:30"
          }
        },
        "created_at": "2025-02-06T14:11:26.484Z",
        "emoji": "💸",
        "filters": {
          "average_spend": "High",
          "total_visits": "1",
          "not_visited_in": "Last 1 month"
        },
        "name": "<span>6222</span> customers with high spend on their first purchase <span>haven't returned.<span>",
        "segment_customers": 6222,
        "tagline": "Customers with an AOV over ₹697 who haven't returned after their first visit",
        "updated_at": "2025-02-06T14:53:42.771Z",
        "campaign_id": {
          "status": "published",
          "id": "asdsad95dfc9c9f67a4c49d1"
        },
        "expires_at": "2025-03-08T18:29:59.000Z",
        "id": "asdasd0d962b9467a4c30e"
      },
      {
        "entity_type": "Group",
        "objective": "No visit after negative experience",
        "entity_id": "saaaaaa90af2631f2409",
        "action": "Win Them Back",
        "cluster_metrics": {
          "body": {
            "store_ids": [
              "asdsad5f228f2b63073843e",
              "asdsada07894167631f261f5",
              "asdsaa07893320631f25b35"
            ],
            "recent_feedback": {
              "min": 1,
              "max": 3
            },
            "blocked_customers": false
          },
          "query": {
            "last_visited_filter": true,
            "start": "2024-02-28T00:00:00+05:30",
            "end": "2025-01-28T23:59:59+05:30"
          }
        },
        "created_at": "2025-01-31T03:47:44.791Z",
        "emoji": "💔",
        "filters": {
          "feedback": "1, 2, 3",
          "not_visited_in": "Last 1 month"
        },
        "name": "<span>851 customers haven’t returned</span> after a <span>poor experience.</span> Act now and rebuild trust!",
        "segment_customers": 851,
        "tagline": "Customers who gave low ratings (1, 2, or 3 stars) and haven't returned since their last visit.",
        "updated_at": "2025-01-31T15:16:38.015Z",
        "campaign_id": {
          "status": "completed",
          "id": "asdasd433149901679ce68a0"
        },
        "expires_at": "2025-03-02T18:29:59.000Z",
        "id": "717cb020db752f7679c47e06"
      },
      {
        "entity_id": "saaaaaa90af2631f2409",
        "entity_type": "Group",
        "objective": "Active loyalty members",
        "action": "Increase AOV",
        "cluster_metrics": {
          "body": {
            "store_ids": [
              "adasda43e699066f5f228f2b",
              "asdads1f587a1eaa07894167",
              "adsasdab3587a1eaa07893320"
            ],
            "loyalty_redemption_percentage": {
              "min": 35,
              "max": 100
            },
            "blocked_customers": false
          },
          "query": {
            "last_visited_filter": true,
            "start": "2024-11-28T00:00:00+05:30",
            "end": "2025-02-28T23:59:59+05:30"
          }
        },
        "created_at": "2025-02-28T03:47:58.242Z",
        "emoji": "🚀",
        "filters": {
          "loyalty_redemption": "High",
          "visited_in": "Last 3 months"
        },
        "name": "You have <span>607 loyalists who redeem loyalty rewards on every 3rd order of theirs.</span> Continue engaging with them.",
        "segment_customers": 607,
        "tagline": "Customers who redeemed loyalty rewards in at least 35% of their purchases and visited in the last 3 months.",
        "updated_at": "2025-02-28T03:47:58.242Z",
        "campaign_id": {
          "status": "published",
          "id": "asdsad95dfc9c9f67a4c49d1"
        },
        "id": "asdsadaeb623b20a015c16fc"
      },
      {
        "entity_type": "Group",
        "objective": "Recent high spenders",
        "entity_id": "saaaaaa90af2631f2409",
        "action": "Keep Them Engaged",
        "cluster_metrics": {
          "body": {
            "store_ids": [
              "e699066f5f228f2b63073843",
              "587a1eaa07894167631f261f",
              "587a1eaa07893320631f25b3"
            ],
            "average_order_value": {
              "min": 696.7417891178293,
              "max": 21500
            },
            "blocked_customers": false
          },
          "query": {
            "last_visited_filter": true,
            "start": "2024-10-28T00:00:00+05:30",
            "end": "2025-02-28T23:59:59+05:30"
          }
        },
        "created_at": "2025-02-22T04:29:14.786Z",
        "emoji": "🔥",
        "filters": {
          "average_spend": "High",
          "visited_in": "Last 4 months"
        },
        "name": "<span>5071 customers have spent higher than your average spending</span> customers in the last 4 months.",
        "segment_customers": 5071,
        "tagline": "Customers who spent over ₹697 in their last purchase within the past 4 months.",
        "updated_at": "2025-02-22T14:15:55.681Z",
        "campaign_id": {
          "status": "completed",
          "id": "78c08860c8bc5c167b9ce6ae"
        },
        "expires_at": "2025-03-24T18:29:59.000Z",
        "id": "623b20a015e257267b9529ab"
      },
      {
        "entity_id": "saaaaaa90af2631f2409",
        "entity_type": "Group",
        "objective": "Inactive customers",
        "action": "Make Them Repeat",
        "cluster_metrics": {
          "body": {
            "store_ids": [
              "asdasd43e699066f5f228f2b",
              "asdsad1f587a1eaa07894167",
              "asdsadb3587a1eaa07893320"
            ],
            "blocked_customers": false
          },
          "query": {
            "last_visited_filter": true,
            "start": "2024-02-28T00:00:00+05:30",
            "end": "2024-11-28T23:59:59+05:30"
          }
        },
        "created_at": "2025-02-28T03:47:58.242Z",
        "emoji": "⌛",
        "filters": {
          "not_visited_in": "Last 3 months"
        },
        "name": "<span>18240 customers haven’t made purchase since last 3 months.</span> Act now to re-engage them before it's too late.",
        "segment_customers": 18240,
        "tagline": "Customers who haven't made a purchase in over 3 months",
        "updated_at": "2025-02-28T03:47:58.242Z",
        "campaign_id": {
          "status": "completed",
          "id": "67b1dd2d93a9e3f7c7009e81"
        },
        "id": "asdsadeb623b20a015c16ff"
      },
      {
        "entity_type": "Group",
        "objective": "First timers who did not return",
        "entity_id": "saaaaaa90af2631f2409",
        "action": "Make Them Repeat",
        "cluster_metrics": {
          "body": {
            "store_ids": [
              "asdsad43e699066f5f228f2b",
              "asdadfaa587a1eaa07894167",
              "asdasd53587a1eaa07893320"
            ],
            "total_visits": {
              "min": 1,
              "max": 1
            },
            "blocked_customers": false
          },
          "query": {
            "first_visited_filter": true,
            "start": "2024-02-28T00:00:00+05:30",
            "end": "2025-01-28T23:59:59+05:30"
          }
        },
        "created_at": "2025-02-28T03:47:58.242Z",
        "emoji": "🌱",
        "filters": {
          "total_visits": "1",
          "not_visited_in": "Last 1 month"
        },
        "name": "<span>11016 customers haven't returned after their first purchase.</span> Act now to drive their 2nd purchase.",
        "segment_customers": 11016,
        "tagline": "Customers who visited for the first time but have not made a second visit.",
        "updated_at": "2025-02-28T03:47:58.242Z",
        "id": "asdasdeb623b20a015c16f8",
        "campaign_id": {
          "status": "pending",
          "id": "67a755f2f59e230d9b79cb05"
        },
      },
    ],
    customerSegments: [],
    selectedSegment: {},
  },
};
